import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  Json: { input: any; output: any; }
  NaiveDateTime: { input: any; output: any; }
};

/** Input for adding a workflow action to a project's action library */
export type AddProjectActionInput = {
  caseProjectId: Scalars['ID']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  workflowId: Scalars['ID']['input'];
};

/** Advanced query conversion result */
export type AdvancedQueryResult = {
  __typename?: 'AdvancedQueryResult';
  /** Converted advanced query string */
  advancedQuery: Scalars['String']['output'];
  /** Conversion metadata */
  info?: Maybe<Scalars['Json']['output']>;
};

/** Advanced alert search input */
export type AdvancedSearchInput = {
  /** Maximum results to return */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Offset for pagination */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Advanced query string */
  query: Scalars['String']['input'];
  /** Specific fields to return */
  returnFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Sort field */
  sortBy?: InputMaybe<Scalars['String']['input']>;
  /** Sort order: 'asc' or 'desc' */
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};

/** Alert object for case linking */
export type Alert = {
  __typename?: 'Alert';
  /** Alert description */
  description?: Maybe<Scalars['String']['output']>;
  /** External ID from source SIEM */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Additional structured data */
  extraData?: Maybe<Scalars['Json']['output']>;
  /** Alert ID */
  id: Scalars['String']['output'];
  /** Creation timestamp (ISO8601) */
  insertedAt?: Maybe<Scalars['String']['output']>;
  /** Alert name */
  name: Scalars['String']['output'];
  /** Query that generated this alert */
  query?: Maybe<Scalars['String']['output']>;
  /** Alert severity level */
  severity?: Maybe<Scalars['String']['output']>;
  /** Source SIEM system identifier */
  siemSource?: Maybe<Scalars['String']['output']>;
  /** Categorization tags (mitre_tactic, technique, etc.) */
  tags?: Maybe<Scalars['Json']['output']>;
  /** Last update timestamp (ISO8601) */
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/** Paginated alerts response */
export type AlertPage = {
  __typename?: 'AlertPage';
  alerts: Array<Alert>;
  hasMore: Scalars['Boolean']['output'];
  total: Scalars['Int']['output'];
};

/** Alert search result */
export type AlertSearchResult = {
  __typename?: 'AlertSearchResult';
  /** List of alerts */
  alerts: Array<Alert>;
  /** Number of results returned */
  count: Scalars['Int']['output'];
  /** Whether more results exist */
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  /** Query execution metadata */
  queryInfo?: Maybe<Scalars['Json']['output']>;
  /** Total matching results (if available) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A file attachment on a case */
export type Attachment = {
  __typename?: 'Attachment';
  /** MIME type of the file */
  contentType: Scalars['String']['output'];
  /** Presigned download URL (valid for limited time) */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** Original filename */
  filename: Scalars['String']['output'];
  /** Human-readable file size (e.g., '2.5 MB') */
  humanSize: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['NaiveDateTime']['output'];
  /** File size in bytes */
  sizeBytes: Scalars['Int']['output'];
  updatedAt: Scalars['NaiveDateTime']['output'];
  /** User who uploaded the attachment */
  uploadedBy?: Maybe<User>;
};

/** Response for attachment mutations */
export type AttachmentResponse = {
  __typename?: 'AttachmentResponse';
  attachment?: Maybe<Attachment>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success: Scalars['Boolean']['output'];
};

/** Response for listing attachments */
export type AttachmentsResponse = {
  __typename?: 'AttachmentsResponse';
  attachments?: Maybe<Array<Maybe<Attachment>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success: Scalars['Boolean']['output'];
  /** Total size of all attachments */
  totalSizeBytes?: Maybe<Scalars['Int']['output']>;
};

/** Basic alert search input */
export type BasicSearchInput = {
  /** End time (ISO8601 or epoch ms) */
  endTime?: InputMaybe<Scalars['String']['input']>;
  /** Maximum results to return */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Offset for pagination */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Simple search query string */
  query?: InputMaybe<Scalars['String']['input']>;
  /** Filter by severity levels */
  severity?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter by SIEM sources */
  siemSources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Start time (ISO8601 or epoch ms) */
  startTime?: InputMaybe<Scalars['String']['input']>;
};

/** Input for batch adding fields to a case type */
export type BatchCaseTypeFieldInput = {
  caseFieldId: Scalars['ID']['input'];
  closeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  createRequired?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** Response for batch case type field operations */
export type BatchCaseTypeFieldResponse = {
  __typename?: 'BatchCaseTypeFieldResponse';
  caseTypeFields?: Maybe<Array<Maybe<CaseTypeField>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success: Scalars['Boolean']['output'];
};

/** Response for bulk task operations */
export type BulkTaskResponse = {
  __typename?: 'BulkTaskResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success: Scalars['Boolean']['output'];
  tasks?: Maybe<Array<Maybe<CaseTask>>>;
};

/** A case (ticket/incident) */
export type Case = {
  __typename?: 'Case';
  /** User assigned to the case */
  assignee?: Maybe<User>;
  /** Attachments for this case */
  attachments?: Maybe<Array<Maybe<Attachment>>>;
  /** Sequential case number within tenant */
  caseNumber: Scalars['Int']['output'];
  /** Number of comments on this case */
  commentCount: Scalars['Int']['output'];
  /** Comments on this case */
  comments?: Maybe<Array<Maybe<Comment>>>;
  description?: Maybe<Scalars['String']['output']>;
  /** Display key (e.g., 'INC-42') */
  displayKey: Scalars['String']['output'];
  /** ID in upstream SIEM (nullable) */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Deep link to upstream SIEM (nullable) */
  externalUrl?: Maybe<Scalars['String']['output']>;
  /** Custom field values */
  fieldValues?: Maybe<Array<Maybe<CaseFieldValue>>>;
  /** Change history for this case */
  history?: Maybe<HistoryPage>;
  /** History entries (preloaded in search) */
  historyEntries?: Maybe<Array<Maybe<HistoryEntry>>>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['NaiveDateTime']['output'];
  /** Last sync timestamp (nullable) */
  lastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Alerts linked to this case */
  linkedAlerts?: Maybe<Array<Maybe<Alert>>>;
  /** Paginated alerts linked to this case */
  linkedAlertsPage?: Maybe<AlertPage>;
  /** Number of linked cases */
  linkedCaseCount: Scalars['Int']['output'];
  /** Cases linked to this case */
  linkedCases?: Maybe<Array<Maybe<CaseLink>>>;
  /** Free-form provenance/extension bag */
  metadata?: Maybe<Scalars['Json']['output']>;
  /** Priority name from the priorities table */
  priority: Scalars['String']['output'];
  /** The case project this case belongs to */
  project?: Maybe<CaseProject>;
  /** ID of the case project this case belongs to */
  projectId?: Maybe<Scalars['ID']['output']>;
  /** User who reported the case */
  reporter?: Maybe<User>;
  /** Status from the case type's workflow */
  status: Scalars['String']['output'];
  /** Sync state: synced, pending_push, conflict, error (nullable) */
  syncState?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['NaiveDateTime']['output'];
};


/** A case (ticket/incident) */
export type CaseHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** A case (ticket/incident) */
export type CaseLinkedAlertsPageArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Unified real-time case event payload.
 *
 * This single type carries all event types for a case, making it easy
 * to subscribe to all case updates in one subscription.
 */
export type CaseEvent = {
  __typename?: 'CaseEvent';
  /** The actor who triggered the event */
  actor?: Maybe<CaseEventActor>;
  /** Attachment data (for attachment events) */
  attachment?: Maybe<CaseEventAttachment>;
  /** ID of the case this event relates to */
  caseId: Scalars['ID']['output'];
  /** Case summary (for case events) */
  caseSummary?: Maybe<CaseEventCaseSummary>;
  /** Changed fields with from/to values */
  changes?: Maybe<Scalars['Json']['output']>;
  /** Comment data (for comment events) */
  comment?: Maybe<CaseEventComment>;
  /** Type of event that occurred */
  eventType: CaseEventType;
  /** Field update details (for field events) */
  fieldUpdate?: Maybe<CaseEventFieldUpdate>;
  /** Task data (for task events) */
  task?: Maybe<CaseEventTask>;
  /** Timestamp of the event */
  timestamp: Scalars['DateTime']['output'];
};

/** Actor who triggered an event */
export type CaseEventActor = {
  __typename?: 'CaseEventActor';
  displayName?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

/** Attachment data in event payload */
export type CaseEventAttachment = {
  __typename?: 'CaseEventAttachment';
  contentType?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  sizeBytes?: Maybe<Scalars['Int']['output']>;
  uploadedById?: Maybe<Scalars['ID']['output']>;
};

/** Case summary in event payload */
export type CaseEventCaseSummary = {
  __typename?: 'CaseEventCaseSummary';
  assigneeId?: Maybe<Scalars['ID']['output']>;
  caseNumber?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  priority?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Comment data in event payload */
export type CaseEventComment = {
  __typename?: 'CaseEventComment';
  content?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

/** Field update details */
export type CaseEventFieldUpdate = {
  __typename?: 'CaseEventFieldUpdate';
  fieldId?: Maybe<Scalars['ID']['output']>;
  fieldName: Scalars['String']['output'];
  newValue?: Maybe<Scalars['Json']['output']>;
  oldValue?: Maybe<Scalars['Json']['output']>;
};

/**
 * An event reachable from a case's current status, with `enabled` /
 * `reason` annotations from the state machine engine. Used by the UI
 * to render action buttons (greyed out when disabled).
 */
export type CaseEventOption = {
  __typename?: 'CaseEventOption';
  /** Whether the current actor can fire this event right now */
  enabled: Scalars['Boolean']['output'];
  /** Event name (state machine atom rendered as string) */
  event: Scalars['String']['output'];
  /** Machine-readable reason the event is disabled (null when enabled). Examples: "actor_mismatch:user", "guard_failed:requires_assignee" */
  reason?: Maybe<Scalars['String']['output']>;
  /** Target status this event transitions to */
  to: Scalars['String']['output'];
};

/** Task data in event payload */
export type CaseEventTask = {
  __typename?: 'CaseEventTask';
  assigneeId?: Maybe<Scalars['ID']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  taskNumber?: Maybe<Scalars['Int']['output']>;
  taskType?: Maybe<Scalars['String']['output']>;
  /** How task execution is triggered */
  triggerMode?: Maybe<Scalars['String']['output']>;
};

/** Event types for case updates */
export enum CaseEventType {
  /** New attachment uploaded */
  AttachmentAdded = 'ATTACHMENT_ADDED',
  /** Attachment removed */
  AttachmentDeleted = 'ATTACHMENT_DELETED',
  /** Case was deleted */
  CaseDeleted = 'CASE_DELETED',
  /** Case fields were updated */
  CaseUpdated = 'CASE_UPDATED',
  /** New comment added */
  CommentAdded = 'COMMENT_ADDED',
  /** Comment was deleted */
  CommentDeleted = 'COMMENT_DELETED',
  /** Comment was updated */
  CommentUpdated = 'COMMENT_UPDATED',
  /** Custom field value changed */
  FieldUpdated = 'FIELD_UPDATED',
  /** New task created */
  TaskCreated = 'TASK_CREATED',
  /** Task was deleted */
  TaskDeleted = 'TASK_DELETED',
  /** Task was updated */
  TaskUpdated = 'TASK_UPDATED'
}

/** A case field definition */
export type CaseField = {
  __typename?: 'CaseField';
  /** Field description */
  description?: Maybe<Scalars['String']['output']>;
  /** Field configuration JSON (options for Select/MultiSelect) */
  descriptor?: Maybe<Scalars['String']['output']>;
  /** Display label */
  displayName: Scalars['String']['output'];
  /** JSON array of exclusion patterns */
  exclusionRegexes?: Maybe<Scalars['String']['output']>;
  /** Internal field name (snake_case) */
  fieldName: Scalars['String']['output'];
  fieldType: CaseFieldType;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['NaiveDateTime']['output'];
  /** Associated with all case types */
  isAll: Scalars['Boolean']['output'];
  /** Auto-populated using regex */
  isComputed: Scalars['Boolean']['output'];
  /** Whether the field is deprecated */
  isDeprecated: Scalars['Boolean']['output'];
  /** Hidden from UI */
  isHidden: Scalars['Boolean']['output'];
  /** Used for similar case matching */
  isObservable: Scalars['Boolean']['output'];
  /** System field (cannot be deleted) */
  isSystem: Scalars['Boolean']['output'];
  /** Regex pattern for computed fields */
  regex?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['NaiveDateTime']['output'];
  /** Regex for validating field values */
  validationRegex?: Maybe<Scalars['String']['output']>;
};

/** Case field diff entry for import preview */
export type CaseFieldDiff = {
  __typename?: 'CaseFieldDiff';
  /** Whether field already exists in tenant */
  exists: Scalars['Boolean']['output'];
  fieldType: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Exported case field definition */
export type CaseFieldExport = {
  __typename?: 'CaseFieldExport';
  caseTypeNames: Array<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptor?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  exclusionRegexes?: Maybe<Scalars['String']['output']>;
  fieldType: Scalars['String']['output'];
  isAll: Scalars['Boolean']['output'];
  isComputed: Scalars['Boolean']['output'];
  isHidden: Scalars['Boolean']['output'];
  isObservable: Scalars['Boolean']['output'];
  isSystem: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  regex?: Maybe<Scalars['String']['output']>;
  validationRegex?: Maybe<Scalars['String']['output']>;
};

/** Custom field filter for case search */
export type CaseFieldFilter = {
  fieldId: Scalars['ID']['input'];
  fieldName?: InputMaybe<Scalars['String']['input']>;
  values: Array<Scalars['String']['input']>;
};

/** Response for case field mutations */
export type CaseFieldResponse = {
  __typename?: 'CaseFieldResponse';
  caseField?: Maybe<CaseField>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success: Scalars['Boolean']['output'];
};

/** Field types for custom case fields (matches automations-backend CaseField.scala) */
export enum CaseFieldType {
  /** Date value (epoch timestamp) */
  Date = 'DATE',
  /** IP address (IPv4 or IPv6) */
  Ip = 'IP',
  /** JSON data */
  Json = 'JSON',
  /** Markdown formatted text */
  Markdown = 'MARKDOWN',
  /** Multiple selection from options */
  MultiSelect = 'MULTI_SELECT',
  /** Multiple values (extraction fields) */
  MultiValued = 'MULTI_VALUED',
  /** Numeric value */
  Number = 'NUMBER',
  /** Single selection from options */
  Select = 'SELECT',
  /** Single line text */
  Text = 'TEXT',
  /** Multi-line text */
  Textarea = 'TEXTAREA',
  /** URL value */
  Url = 'URL',
  /** User reference */
  User = 'USER'
}

/** A custom field value for a case */
export type CaseFieldValue = {
  __typename?: 'CaseFieldValue';
  /** The field definition */
  caseField: CaseField;
  id: Scalars['ID']['output'];
  /** Parsed value based on field type */
  parsedValue?: Maybe<Scalars['Json']['output']>;
  /** Raw string value (parse based on field_type) */
  value?: Maybe<Scalars['String']['output']>;
};

/** Filter input for case similarity query */
export type CaseFilterFieldInput = {
  /** Field to filter by: status, priority, caseType */
  fieldName: Scalars['String']['input'];
  /** Values to match */
  values: Array<Scalars['String']['input']>;
};

/** Filter options for listing cases */
export type CaseFilterInput = {
  /** Filter by assignee user IDs */
  assigneeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by case type IDs */
  caseTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAfter?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  /** Custom field filters */
  fieldFilters?: InputMaybe<Array<CaseFieldFilter>>;
  includeClosed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by priority values */
  priority?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter by project ID */
  projectId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by reporter user IDs */
  reporterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Free text search in title and description */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter by status values from workflow */
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter by sync state (synced, pending_push, conflict, error) */
  syncState?: InputMaybe<Scalars['String']['input']>;
  /** When true, restrict to cases with no assignee. Combined with assignee_ids via OR. */
  unassigned?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAfter?: InputMaybe<Scalars['NaiveDateTime']['input']>;
  updatedBefore?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};

/** Options for including related data */
export type CaseIncludeOptions = {
  comments?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specific field names to fetch */
  fetchFields?: InputMaybe<Array<Scalars['String']['input']>>;
  fieldValues?: InputMaybe<Scalars['Boolean']['input']>;
  history?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A link between two cases */
export type CaseLink = {
  __typename?: 'CaseLink';
  /** User who created the link */
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  /** When the link was created */
  insertedAt: Scalars['NaiveDateTime']['output'];
  /** Type of link: manual (user-created) or correlated (auto-linked) */
  linkType: Scalars['String']['output'];
  /** The linked case (preloaded) */
  linkedCase?: Maybe<Case>;
  /** ID of the linked case */
  linkedCaseId: Scalars['ID']['output'];
  /** Observable values shared between the linked cases (for correlated links) */
  sharedObservables?: Maybe<Array<Scalars['String']['output']>>;
  /** Similarity score between 0 and 1 (for correlated links) */
  similarityScore?: Maybe<Scalars['Float']['output']>;
};

/** Response for case link mutations */
export type CaseLinkResponse = {
  __typename?: 'CaseLinkResponse';
  /** The created/updated links */
  caseLinks?: Maybe<Array<Maybe<CaseLink>>>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success: Scalars['Boolean']['output'];
};

/** Paginated case results */
export type CasePage = {
  __typename?: 'CasePage';
  cases: Array<Case>;
  hasMore: Scalars['Boolean']['output'];
  total: Scalars['Int']['output'];
};

/** Case priority levels (DEPRECATED - use string priorities from priorities table) */
export enum CasePriority {
  /** Critical priority */
  Critical = 'CRITICAL',
  /** High priority */
  High = 'HIGH',
  /** Low priority */
  Low = 'LOW',
  /** Medium priority */
  Medium = 'MEDIUM'
}

/** A case project that unifies the project and type concepts */
export type CaseProject = {
  __typename?: 'CaseProject';
  /** Hex color (#RRGGBB) for UI rendering */
  color?: Maybe<Scalars['String']['output']>;
  /** Strategy for resolving sync conflicts (remote_wins, local_wins, manual) */
  conflictStrategy: Scalars['String']['output'];
  /** Default user to assign to new cases in this project */
  defaultAssignee?: Maybe<User>;
  /** ID of the default user to assign to new cases in this project */
  defaultAssigneeId?: Maybe<Scalars['ID']['output']>;
  /** Project description */
  description?: Maybe<Scalars['String']['output']>;
  /** Determines how preset tasks are executed */
  executionMode: ExecutionMode;
  /** Icon identifier for UI rendering */
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Workflow for ingesting external cases */
  ingestWorkflowId?: Maybe<Scalars['ID']['output']>;
  insertedAt: Scalars['NaiveDateTime']['output'];
  /** Whether this project is deprecated */
  isDeprecated?: Maybe<Scalars['Boolean']['output']>;
  /** User IDs who are members of this project */
  memberIds: Array<Scalars['ID']['output']>;
  /** Additional metadata */
  metadata?: Maybe<Scalars['Json']['output']>;
  /** Display name of the project */
  name: Scalars['String']['output'];
  /** Workflow for pushing updates externally */
  outboundWorkflowId?: Maybe<Scalars['ID']['output']>;
  /** Prefix for case keys (e.g., 'INC'). Nullable for legacy projects created before the CaseType merge. */
  prefix?: Maybe<Scalars['String']['output']>;
  /** Project-level action library (workflows available as actions for cases in this project) */
  projectActions: Array<CaseProjectAction>;
  /** Project type classification */
  projectType: CaseProjectType;
  /** URL-safe identifier */
  slug: Scalars['String']['output'];
  /** Order for UI rendering */
  sortOrder: Scalars['Int']['output'];
  /** Status workflow for this project */
  statusWorkflow?: Maybe<StatusWorkflow>;
  /** Cron expression for sync interval */
  syncInterval: Scalars['String']['output'];
  /** Task templates (preset tasks) for this project */
  taskTemplates: Array<TaskTemplate>;
  updatedAt: Scalars['NaiveDateTime']['output'];
  /**
   * View layout configuration for the case detail page.
   * JSON defining sections, tabs, and field placements.
   * Returns null if no custom layout is set (UI handles default).
   */
  viewLayout?: Maybe<Scalars['Json']['output']>;
};

/** A workflow registered as an action on a case project's action library */
export type CaseProjectAction = {
  __typename?: 'CaseProjectAction';
  caseProjectId: Scalars['ID']['output'];
  /** Optional display name for UI rendering */
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['NaiveDateTime']['output'];
  sortOrder: Scalars['Int']['output'];
  updatedAt: Scalars['NaiveDateTime']['output'];
  /** ID of the workflow backing this action */
  workflowId: Scalars['ID']['output'];
};

/** Response for project action mutations */
export type CaseProjectActionResponse = {
  __typename?: 'CaseProjectActionResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  projectAction?: Maybe<CaseProjectAction>;
  success: Scalars['Boolean']['output'];
};

/** Response for case project mutations */
export type CaseProjectResponse = {
  __typename?: 'CaseProjectResponse';
  caseProject?: Maybe<CaseProject>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success: Scalars['Boolean']['output'];
};

/** Case project type classification */
export enum CaseProjectType {
  /** Compliance / audit tracking */
  Compliance = 'COMPLIANCE',
  /** Custom project type */
  Custom = 'CUSTOM',
  /** Active investigation project */
  Investigation = 'INVESTIGATION',
  /** Day-to-day operational work */
  Operational = 'OPERATIONAL',
  /** Proactive threat hunting */
  ThreatHunt = 'THREAT_HUNT'
}

/** Response for case mutations */
export type CaseResponse = {
  __typename?: 'CaseResponse';
  case?: Maybe<Case>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success: Scalars['Boolean']['output'];
};

/** Counts of case settings entities */
export type CaseSettingCounts = {
  __typename?: 'CaseSettingCounts';
  caseTypes: Scalars['Int']['output'];
  fields: Scalars['Int']['output'];
  priorityLevels: Scalars['Int']['output'];
  statusWorkflows: Scalars['Int']['output'];
  taskTemplates: Scalars['Int']['output'];
};

/** Import preview showing what will be created vs skipped */
export type CaseSettingDiff = {
  __typename?: 'CaseSettingDiff';
  caseTypes: Array<CaseTypeDiff>;
  fields: Array<CaseFieldDiff>;
  priorityLevels: Array<PriorityDiff>;
  statusWorkflows: Array<StatusWorkflowDiff>;
  version: Scalars['String']['output'];
};

/** Download info for exported settings */
export type CaseSettingDownload = {
  __typename?: 'CaseSettingDownload';
  contentBase64: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  filename: Scalars['String']['output'];
};

/** Complete case settings export */
export type CaseSettingExport = {
  __typename?: 'CaseSettingExport';
  caseTypes: Array<CaseTypeExport>;
  fields: Array<CaseFieldExport>;
  priorityLevels: Array<PriorityExport>;
  statusWorkflows: Array<StatusWorkflowExport>;
  taskTemplates: Array<TaskTemplateExport>;
  version: Scalars['String']['output'];
};

/** Input options for finding similar cases */
export type CaseSimilarityInput = {
  /** Exclude already-linked cases from results */
  excludeLinked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by status, priority, or caseType */
  filterFields?: InputMaybe<Array<InputMaybe<CaseFilterFieldInput>>>;
  /** Maximum number of results to return */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum number of matching observables required */
  minimumMatches?: InputMaybe<Scalars['Int']['input']>;
  /** Pagination offset */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Field to sort results by */
  sortBy?: InputMaybe<SimilaritySortField>;
  /** Sort direction */
  sortOrder?: InputMaybe<SortOrder>;
};

/** Response wrapper for case similarity query */
export type CaseSimilarityResponse = {
  __typename?: 'CaseSimilarityResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  result?: Maybe<CaseSimilarityResult>;
  success: Scalars['Boolean']['output'];
};

/** Result of a case similarity search */
export type CaseSimilarityResult = {
  __typename?: 'CaseSimilarityResult';
  /** Observable values from source case */
  observables: Array<ObservableValue>;
  /** List of similar cases */
  similarCases: Array<SimilarCase>;
  /** Total number of similar cases (before pagination) */
  totalCount: Scalars['Int']['output'];
};

/** Sorting options for cases */
export enum CaseSortField {
  CaseNumber = 'CASE_NUMBER',
  InsertedAt = 'INSERTED_AT',
  Priority = 'PRIORITY',
  Status = 'STATUS',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT'
}

/** A task associated with a case */
export type CaseTask = {
  __typename?: 'CaseTask';
  /** User assigned to this task */
  assignee?: Maybe<User>;
  /** The case this task belongs to */
  case?: Maybe<Case>;
  /** If true, task output is automatically posted as a case comment on completion */
  commentOutput: Scalars['Boolean']['output'];
  /** Whether this task can be completed manually (manual task in pending status) */
  completable: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  /** Type-specific configuration (structure varies by task_type) */
  config?: Maybe<Scalars['Json']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether this task can be executed (mcp_tool or workflow in pending status) */
  executable: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['NaiveDateTime']['output'];
  name: Scalars['String']['output'];
  /** Execution result (populated after completion) */
  result?: Maybe<Scalars['Json']['output']>;
  /** Whether this task can be retried (failed status) */
  retriable: Scalars['Boolean']['output'];
  sortOrder: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['NaiveDateTime']['output']>;
  status: TaskStatus;
  /** Sequential task number within case */
  taskNumber?: Maybe<Scalars['Int']['output']>;
  taskType: TaskType;
  /** How task execution is triggered */
  triggerMode?: Maybe<TriggerMode>;
  updatedAt: Scalars['NaiveDateTime']['output'];
};

/**
 * One row of `case_status_history` — an append-only audit entry produced
 * every time a case successfully transitions via `dispatch_case_event`.
 */
export type CaseTransition = {
  __typename?: 'CaseTransition';
  /** User id when actor_type=user; nullable for system */
  actorId?: Maybe<Scalars['String']['output']>;
  /** "user" or "system" */
  actorType: Scalars['String']['output'];
  /** State machine event name that produced this transition */
  event: Scalars['String']['output'];
  /** Previous status — null for the first transition */
  fromStatus?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  /** Arbitrary payload passed to dispatch (guards/automation context) */
  payload?: Maybe<Scalars['Json']['output']>;
  toStatus: Scalars['String']['output'];
  /** Workflow run id when dispatched by automation */
  workflowRunId?: Maybe<Scalars['String']['output']>;
};

/** Case type diff entry for import preview */
export type CaseTypeDiff = {
  __typename?: 'CaseTypeDiff';
  /** Whether case type already exists in tenant */
  exists: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  prefix: Scalars['String']['output'];
};

/** Exported case type definition */
export type CaseTypeExport = {
  __typename?: 'CaseTypeExport';
  description?: Maybe<Scalars['String']['output']>;
  executionMode: Scalars['String']['output'];
  fieldNames: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  prefix: Scalars['String']['output'];
  statusWorkflowName: Scalars['String']['output'];
};

/** A mapping between a case type and a field */
export type CaseTypeField = {
  __typename?: 'CaseTypeField';
  /** The field definition */
  caseField?: Maybe<CaseField>;
  caseFieldId: Scalars['ID']['output'];
  caseTypeId: Scalars['ID']['output'];
  /** Whether field is required when closing a case */
  closeRequired: Scalars['Boolean']['output'];
  /** Whether field is required when creating a case */
  createRequired: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['NaiveDateTime']['output'];
  /** Display order within the case type */
  sortOrder: Scalars['Int']['output'];
  updatedAt: Scalars['NaiveDateTime']['output'];
};

/** Input for case type field mapping attributes */
export type CaseTypeFieldAttrsInput = {
  closeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  createRequired?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** Response for case type field mapping mutations */
export type CaseTypeFieldResponse = {
  __typename?: 'CaseTypeFieldResponse';
  caseTypeField?: Maybe<CaseTypeField>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success: Scalars['Boolean']['output'];
};

/** A comment on a case */
export type Comment = {
  __typename?: 'Comment';
  content: Scalars['String']['output'];
  contentType: ContentType;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['NaiveDateTime']['output'];
  isDeleted: Scalars['Boolean']['output'];
  updatedAt: Scalars['NaiveDateTime']['output'];
  user: User;
};

/** Response for comment mutations */
export type CommentResponse = {
  __typename?: 'CommentResponse';
  comment?: Maybe<Comment>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success: Scalars['Boolean']['output'];
};

/** Input for completing a manual task */
export type CompleteManualTaskInput = {
  /** Form field values */
  formResponse?: InputMaybe<Scalars['Json']['input']>;
  /** Additional notes */
  notes?: InputMaybe<Scalars['String']['input']>;
};

/** Conflict type indicating how the conflict was detected */
export enum ConflictType {
  /** Case deleted upstream but has local edits */
  DeleteConflict = 'DELETE_CONFLICT',
  /** A field was modified both locally and upstream */
  FieldConflict = 'FIELD_CONFLICT',
  /** Sync state is inconsistent between local and upstream */
  StateConflict = 'STATE_CONFLICT',
  /** Upstream version advanced beyond local */
  VersionMismatch = 'VERSION_MISMATCH'
}

/** Comment content types */
export enum ContentType {
  Markdown = 'MARKDOWN',
  PlainText = 'PLAIN_TEXT'
}

/** Correlation and observable statistics */
export type CorrelationStats = {
  __typename?: 'CorrelationStats';
  /** Average observable field values per case */
  avgObservablesPerCase: Scalars['Float']['output'];
  /** Total case-to-case links */
  totalCorrelations: Scalars['Int']['output'];
};

/** Input for creating a case field */
export type CreateCaseFieldInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** JSON config, e.g. {"options":["Low","High"]} */
  descriptor?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  fieldName: Scalars['String']['input'];
  fieldType: CaseFieldType;
  isAll?: InputMaybe<Scalars['Boolean']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isObservable?: InputMaybe<Scalars['Boolean']['input']>;
  regex?: InputMaybe<Scalars['String']['input']>;
  validationRegex?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a case */
export type CreateCaseInput = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Priority name (e.g., 'low', 'high', or custom) */
  priority?: InputMaybe<Scalars['String']['input']>;
  /** ID of the case project for this case */
  projectId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

/** Input for creating a case project */
export type CreateCaseProjectInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  conflictStrategy?: InputMaybe<Scalars['String']['input']>;
  /** ID of the default user to assign to new cases in this project */
  defaultAssigneeId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Task execution mode (sequential/unordered) */
  executionMode?: InputMaybe<ExecutionMode>;
  icon?: InputMaybe<Scalars['String']['input']>;
  ingestWorkflowId?: InputMaybe<Scalars['ID']['input']>;
  memberIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  name: Scalars['String']['input'];
  outboundWorkflowId?: InputMaybe<Scalars['ID']['input']>;
  /** Prefix for case keys (e.g., 'INC') */
  prefix: Scalars['String']['input'];
  projectType?: InputMaybe<CaseProjectType>;
  slug: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the status workflow to use for this project */
  statusWorkflowId?: InputMaybe<Scalars['ID']['input']>;
  syncInterval?: InputMaybe<Scalars['String']['input']>;
  /** JSON layout config for case detail page */
  viewLayout?: InputMaybe<Scalars['Json']['input']>;
};

/** Input for creating a comment */
export type CreateCommentInput = {
  caseId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  contentType?: InputMaybe<ContentType>;
};

/** Input for creating a manual task */
export type CreateManualTaskInput = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  caseId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Input for creating an MCP tool task */
export type CreateMcpToolTaskInput = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  caseId: Scalars['ID']['input'];
  /** If true, task output is posted as a case comment on completion */
  commentOutput?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Tool parameters as JSON */
  parameters?: InputMaybe<Scalars['Json']['input']>;
  /** MCP server slug (e.g., 'github') */
  serverSlug: Scalars['String']['input'];
  /** Execution timeout in seconds (default: 60) */
  timeoutSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** MCP tool name (e.g., 'create_issue') */
  toolName: Scalars['String']['input'];
  /** How task execution is triggered (automatic executes immediately, on_click waits for user) */
  triggerMode?: InputMaybe<TriggerMode>;
};

/** Input for creating a priority */
export type CreatePriorityInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  priorityValue: Scalars['Int']['input'];
};

/** Input for creating a saved search */
export type CreateSavedSearchInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  query: Scalars['String']['input'];
  queryType?: InputMaybe<SearchQueryType>;
};

/** Input for creating a status workflow */
export type CreateStatusWorkflowInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Initial transitions (uses default if not provided) */
  transitions?: InputMaybe<Array<StatusTransitionInput>>;
};

/** Input for creating a task */
export type CreateTaskInput = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  caseId: Scalars['ID']['input'];
  /** If true, task output is posted as a case comment on completion (mcp_tool/workflow only) */
  commentOutput?: InputMaybe<Scalars['Boolean']['input']>;
  /** Type-specific configuration. For mcp_tool: {server_slug, tool_name, parameters}. For workflow: {workflow_id, inputs}. For manual: empty config. */
  config?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  taskType: TaskType;
  /** How task execution is triggered (automatic or on_click) */
  triggerMode?: InputMaybe<TriggerMode>;
};

/** Input for creating a task template */
export type CreateTaskTemplateInput = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** If true, task output is posted as a case comment on completion (mcp_tool/workflow only) */
  commentOutput?: InputMaybe<Scalars['Boolean']['input']>;
  /** Type-specific configuration. Same structure as task config. */
  config?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  taskType: TaskType;
  /** How task execution is triggered (automatic or on_click) */
  triggerMode?: InputMaybe<TriggerMode>;
};

/** Input for creating a workflow task */
export type CreateWorkflowTaskInput = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  caseId: Scalars['ID']['input'];
  /** If true, task output is posted as a case comment on completion */
  commentOutput?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Workflow inputs as JSON */
  inputs?: InputMaybe<Scalars['Json']['input']>;
  name: Scalars['String']['input'];
  /** How task execution is triggered (automatic executes immediately, on_click waits for user) */
  triggerMode?: InputMaybe<TriggerMode>;
  /** Matrix workflow ID to execute */
  workflowId: Scalars['ID']['input'];
};

/** CSV download response */
export type CsvDownloadResponse = {
  __typename?: 'CsvDownloadResponse';
  /** CSV content as a string */
  data: Scalars['String']['output'];
};

/** Query type for CSV download (BASIC or ADVANCED) */
export enum CsvQueryType {
  /** Advanced search using query language */
  Advanced = 'ADVANCED',
  /** Basic search with filters */
  Basic = 'BASIC'
}

/** A deduplication suggestion between two cases */
export type DedupSuggestion = {
  __typename?: 'DedupSuggestion';
  /** Suggestion ID */
  id: Scalars['ID']['output'];
  /** When the suggestion was accepted or dismissed */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Observable values shared between the cases */
  sharedObservables: Array<Scalars['String']['output']>;
  /** Similarity score between the two cases (0.0 - 1.0) */
  similarityScore: Scalars['Float']['output'];
  /** The source case record */
  sourceCase?: Maybe<Case>;
  /** Source case ID */
  sourceCaseId: Scalars['ID']['output'];
  /** Current status of the suggestion */
  status: DedupSuggestionStatus;
  /** When the suggestion was created */
  suggestedAt: Scalars['DateTime']['output'];
  /** The target case record */
  targetCase?: Maybe<Case>;
  /** Target case ID */
  targetCaseId: Scalars['ID']['output'];
};

/** Status of a dedup suggestion */
export enum DedupSuggestionStatus {
  /** Analyst accepted the merge */
  Accepted = 'ACCEPTED',
  /** Analyst dismissed the suggestion */
  Dismissed = 'DISMISSED',
  /** Awaiting analyst review */
  Pending = 'PENDING'
}

/** Response for delete operations */
export type DeleteResponse = {
  __typename?: 'DeleteResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Result of dismissing a dedup suggestion */
export type DismissSuggestionResult = {
  __typename?: 'DismissSuggestionResult';
  /** Error messages if dismissal failed */
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Whether the dismissal succeeded */
  success: Scalars['Boolean']['output'];
  /** The dismissed suggestion */
  suggestion?: Maybe<DedupSuggestion>;
};

/** Input for `dispatch_case_event` mutation. */
export type DispatchCaseEventInput = {
  caseId: Scalars['ID']['input'];
  /** State machine event name (must match a known transition) */
  event: Scalars['String']['input'];
  /** Optional payload made available to guards */
  payload?: InputMaybe<Scalars['Json']['input']>;
};

/** Input for downloading cases as CSV */
export type DownloadCasesCsvInput = {
  /** Assignee IDs (for BASIC mode) */
  assigneeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Case type IDs (for BASIC mode) */
  caseTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Fields to include in CSV (defaults to standard columns) */
  downloadFields?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Priority filter (for BASIC mode) */
  priority?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Advanced search query string (for ADVANCED mode) */
  query?: InputMaybe<Scalars['String']['input']>;
  /** Type of query (basic or advanced) */
  queryType?: InputMaybe<CsvQueryType>;
  /** Reporter IDs (for BASIC mode) */
  reporterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Free text search (for BASIC mode) */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Field to sort by */
  sortBy?: InputMaybe<CaseSortField>;
  /** Sort order (asc/desc) */
  sortOrder?: InputMaybe<SortOrder>;
  /** Status filter (for BASIC mode) */
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Execution mode for tasks within a case type */
export enum ExecutionMode {
  /** Tasks must be completed in order */
  Sequential = 'SEQUENTIAL',
  /** Tasks can be completed in any order */
  Unordered = 'UNORDERED'
}

/** Per-field choice for merge resolution */
export type FieldChoiceInput = {
  /** Name of the field to resolve */
  field: Scalars['String']['input'];
  /** Whether to use local or upstream value */
  source: FieldSource;
};

/** Source choice for per-field merge resolution */
export enum FieldSource {
  /** Use the local value for this field */
  Local = 'LOCAL',
  /** Use the upstream value for this field */
  Upstream = 'UPSTREAM'
}

/** Response for force_sync mutation */
export type ForceSyncResponse = {
  __typename?: 'ForceSyncResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  projectId?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

/** A history/audit log entry for a case */
export type HistoryEntry = {
  __typename?: 'HistoryEntry';
  afterValue?: Maybe<Scalars['String']['output']>;
  beforeValue?: Maybe<Scalars['String']['output']>;
  fieldName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['NaiveDateTime']['output'];
  metadata?: Maybe<Scalars['Json']['output']>;
  modificationType: ModificationType;
  user: User;
};

/** Paginated history response */
export type HistoryPage = {
  __typename?: 'HistoryPage';
  entries: Array<HistoryEntry>;
  /** Whether more entries exist */
  hasMore: Scalars['Boolean']['output'];
  /** Total number of history entries */
  total: Scalars['Int']['output'];
};

/** Input for importing case settings */
export type ImportCaseSettingsInput = {
  /** Optional list of case type names to import. If empty/nil, imports all case types. */
  caseTypeNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** JSON string of case settings */
  data: Scalars['String']['input'];
};

/** Result of importing case settings */
export type ImportCaseSettingsResult = {
  __typename?: 'ImportCaseSettingsResult';
  caseTypesCreated: Scalars['Int']['output'];
  caseTypesFailed: Scalars['Int']['output'];
  caseTypesSkipped: Scalars['Int']['output'];
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fieldsCreated: Scalars['Int']['output'];
  fieldsFailed: Scalars['Int']['output'];
  fieldsSkipped: Scalars['Int']['output'];
  prioritiesCreated: Scalars['Int']['output'];
  prioritiesFailed: Scalars['Int']['output'];
  prioritiesSkipped: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  taskTemplatesCreated: Scalars['Int']['output'];
  taskTemplatesFailed: Scalars['Int']['output'];
  taskTemplatesSkipped: Scalars['Int']['output'];
  workflowsCreated: Scalars['Int']['output'];
  workflowsFailed: Scalars['Int']['output'];
  workflowsSkipped: Scalars['Int']['output'];
};

/** Link alerts to case result */
export type LinkAlertsResult = {
  __typename?: 'LinkAlertsResult';
  /** The case ID that was updated */
  caseId?: Maybe<Scalars['String']['output']>;
  /** Any errors encountered */
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** IDs of alerts that are now linked */
  linkedAlertIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Number of alerts successfully linked */
  linkedCount: Scalars['Int']['output'];
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

/** Input for linking cases */
export type LinkCasesInput = {
  /** The source case ID */
  caseId: Scalars['ID']['input'];
  /** IDs of cases to link to */
  linkedCaseIds: Array<Scalars['ID']['input']>;
};

/** A matched field in a similar case */
export type MatchedField = {
  __typename?: 'MatchedField';
  /** Display name for the field */
  displayName: Scalars['String']['output'];
  /** Internal field name */
  fieldName: Scalars['String']['output'];
  /** Field type */
  fieldType: Scalars['String']['output'];
  /** Values that matched */
  matchedValues: Array<Scalars['String']['output']>;
};

/** Result of a case merge operation */
export type MergeCasesResult = {
  __typename?: 'MergeCasesResult';
  /** ID of the merged (soft-deleted) case */
  duplicateId?: Maybe<Scalars['ID']['output']>;
  /** Error messages if merge failed */
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Whether the merge succeeded */
  success: Scalars['Boolean']['output'];
  /** ID of the surviving case */
  survivorId?: Maybe<Scalars['ID']['output']>;
  /** Number of alerts/observables transferred to survivor */
  transferredAlerts?: Maybe<Scalars['Int']['output']>;
  /** Number of comments transferred to survivor */
  transferredComments?: Maybe<Scalars['Int']['output']>;
  /** Number of case links transferred to survivor */
  transferredLinks?: Maybe<Scalars['Int']['output']>;
};

/** History modification types */
export enum ModificationType {
  /** Content was appended (e.g., comment added) */
  Appended = 'APPENDED',
  /** Entity was created */
  Created = 'CREATED',
  /** Entity was deleted */
  Deleted = 'DELETED',
  /** Content was edited */
  Edited = 'EDITED',
  /** Field was updated */
  Updated = 'UPDATED'
}

/** Response for move_case_to_project mutation */
export type MoveCaseResponse = {
  __typename?: 'MoveCaseResponse';
  case?: Maybe<Case>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success: Scalars['Boolean']['output'];
};

/** An observable field value from a case */
export type ObservableValue = {
  __typename?: 'ObservableValue';
  /** Display name for the field */
  displayName: Scalars['String']['output'];
  /** Field definition ID */
  fieldId: Scalars['ID']['output'];
  /** Internal field name */
  fieldName: Scalars['String']['output'];
  /** Field type (e.g., Text, IP, MultiValued) */
  fieldType: Scalars['String']['output'];
  /** List of values */
  values: Array<Scalars['String']['output']>;
};

/**
 * An outbox event queued for outbound sync.
 *
 * Note: outbox event storage is not yet implemented (EP2-9).
 * This type is defined ahead of time so the GraphQL schema is stable.
 */
export type OutboxEvent = {
  __typename?: 'OutboxEvent';
  /** Case that triggered the event */
  caseId: Scalars['ID']['output'];
  /** Error from last processing attempt */
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['NaiveDateTime']['output'];
  /** Serialized event payload */
  payload?: Maybe<Scalars['Json']['output']>;
  /** Project the case belongs to */
  projectId: Scalars['ID']['output'];
  /** Number of retry attempts */
  retryCount: Scalars['Int']['output'];
  /** Event state: pending, processing, synced, failed */
  state: Scalars['String']['output'];
  updatedAt: Scalars['NaiveDateTime']['output'];
};

/** A custom priority level */
export type Priority = {
  __typename?: 'Priority';
  /** Hex color code for visual distinction */
  color?: Maybe<Scalars['String']['output']>;
  /** Icon identifier for UI display */
  icon: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['NaiveDateTime']['output'];
  /** Whether this is the default priority for new cases */
  isDefault: Scalars['Boolean']['output'];
  /** Display name (e.g., 'Critical', 'High') */
  name: Scalars['String']['output'];
  /** Numeric value for ordering (higher = more urgent) */
  priorityValue: Scalars['Int']['output'];
  updatedAt: Scalars['NaiveDateTime']['output'];
};

/** Priority diff entry for import preview */
export type PriorityDiff = {
  __typename?: 'PriorityDiff';
  /** Whether priority already exists in tenant */
  exists: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  priorityValue: Scalars['Int']['output'];
};

/** Exported priority level definition */
export type PriorityExport = {
  __typename?: 'PriorityExport';
  color?: Maybe<Scalars['String']['output']>;
  icon: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  priorityValue: Scalars['Int']['output'];
};

/** Response for priority mutations */
export type PriorityResponse = {
  __typename?: 'PriorityResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  priority?: Maybe<Priority>;
  success: Scalars['Boolean']['output'];
};

/** Input for publishing a status workflow */
export type PublishStatusWorkflowInput = {
  /** Map of old status => new status for existing cases (e.g., {"pending": "open"}) */
  statusMappings?: InputMaybe<Scalars['Json']['input']>;
};

/** Response for purge_synced_outbox mutation */
export type PurgeOutboxResponse = {
  __typename?: 'PurgeOutboxResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Number of entries purged */
  purgedCount: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

/** Query validation result */
export type QueryValidationResult = {
  __typename?: 'QueryValidationResult';
  /** Validation error messages */
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Parsed query structure if valid */
  parsedQuery?: Maybe<Scalars['Json']['output']>;
  /** Suggested fixes */
  suggestions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Whether the query is valid */
  valid: Scalars['Boolean']['output'];
};

/** Input for reassigning case types to a different workflow */
export type ReassignStatusWorkflowInput = {
  /** Specific case type to reassign (omit to reassign all) */
  caseTypeId?: InputMaybe<Scalars['ID']['input']>;
  /** Source workflow ID */
  fromWorkflowId: Scalars['ID']['input'];
  /** Map of old status => new status for existing cases */
  statusMappings?: InputMaybe<Scalars['Json']['input']>;
  /** Target workflow ID */
  toWorkflowId: Scalars['ID']['input'];
};

/** Response for workflow reassignment */
export type ReassignStatusWorkflowResponse = {
  __typename?: 'ReassignStatusWorkflowResponse';
  caseTypesUpdated?: Maybe<Scalars['Int']['output']>;
  casesUpdated?: Maybe<Scalars['Int']['output']>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success: Scalars['Boolean']['output'];
};

/** Resolution type for resolving a sync conflict */
export enum ResolutionType {
  /** Keep all local values, queue for push */
  AcceptLocal = 'ACCEPT_LOCAL',
  /** Accept all upstream values */
  AcceptUpstream = 'ACCEPT_UPSTREAM',
  /** Per-field resolution using field choices */
  Merge = 'MERGE'
}

/** Input for resolving a sync conflict */
export type ResolveConflictInput = {
  /** Per-field choices (required for merge resolution) */
  fieldChoices?: InputMaybe<Array<FieldChoiceInput>>;
  /** Resolution strategy to apply */
  type: ResolutionType;
};

/** Response for resolve_conflict mutation */
export type ResolveConflictResponse = {
  __typename?: 'ResolveConflictResponse';
  case?: Maybe<Case>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success: Scalars['Boolean']['output'];
};

/** Response for retry_outbox_event mutation */
export type RetryOutboxResponse = {
  __typename?: 'RetryOutboxResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  eventId?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RootMutationType = {
  __typename?: 'RootMutationType';
  /** Add a field to a case type */
  addFieldToCaseType?: Maybe<CaseTypeFieldResponse>;
  /** Add a workflow action to a project's action library */
  addProjectAction?: Maybe<CaseProjectActionResponse>;
  /** Assign a task to a user */
  assignTask?: Maybe<TaskResponse>;
  /** Batch add multiple fields to a case type */
  batchAddFieldsToCaseType?: Maybe<BatchCaseTypeFieldResponse>;
  /** Cancel a task */
  cancelTask?: Maybe<TaskResponse>;
  /** Clone a status workflow */
  cloneStatusWorkflow?: Maybe<StatusWorkflowResponse>;
  /** Complete a manual task with form response */
  completeManualTask?: Maybe<TaskResponse>;
  /** Create a new case */
  createCase?: Maybe<CaseResponse>;
  /** Create a new case field definition */
  createCaseField?: Maybe<CaseFieldResponse>;
  /** Create a new comment on a case */
  createComment?: Maybe<CommentResponse>;
  /** Create a manual task with structured input */
  createManualTask?: Maybe<TaskResponse>;
  /** Create an MCP tool task with structured input */
  createMcpToolTask?: Maybe<TaskResponse>;
  /** Create a new custom priority */
  createPriority?: Maybe<PriorityResponse>;
  /** Create a new case project */
  createProject?: Maybe<CaseProjectResponse>;
  /** Create a new saved search */
  createSavedSearch?: Maybe<SavedSearchResponse>;
  /** Create a new status workflow */
  createStatusWorkflow?: Maybe<StatusWorkflowResponse>;
  /** Create a task with generic input */
  createTask?: Maybe<TaskResponse>;
  /** Create a task template for a case type */
  createTaskTemplate?: Maybe<TaskTemplateResponse>;
  /** Create a workflow task with structured input */
  createWorkflowTask?: Maybe<TaskResponse>;
  /** Delete an attachment */
  deleteAttachment?: Maybe<DeleteResponse>;
  /** Delete a case (soft delete) */
  deleteCase?: Maybe<DeleteResponse>;
  /** Delete a case field definition */
  deleteCaseField?: Maybe<DeleteResponse>;
  /** Delete a custom field value from a case */
  deleteCaseFieldValue?: Maybe<DeleteResponse>;
  /** Delete a comment (soft delete) */
  deleteComment?: Maybe<DeleteResponse>;
  /** Delete a priority (cannot delete default) */
  deletePriority?: Maybe<DeleteResponse>;
  /** Delete a case project */
  deleteProject?: Maybe<DeleteResponse>;
  /** Delete a saved search (must be owner) */
  deleteSavedSearch?: Maybe<DeleteResponse>;
  /** Delete a status workflow (soft delete) */
  deleteStatusWorkflow?: Maybe<DeleteResponse>;
  /** Delete a task (soft delete) */
  deleteTask?: Maybe<DeleteResponse>;
  /** Delete a task template */
  deleteTaskTemplate?: Maybe<TaskTemplateResponse>;
  /** Dismiss a dedup suggestion so it does not reappear */
  dismissDedupSuggestion?: Maybe<DismissSuggestionResult>;
  /**
   * Dispatch a state machine event against a case (matrix-combined-7xgz).
   * Returns the updated case on success. On failure, returns a structured
   * GraphQL error with a machine-readable `message` (e.g. `invalid_transition`,
   * `guard_failed`, `actor_mismatch`, `not_found`, `no_workflow`,
   * `unknown_event`, `forbidden`).
   */
  dispatchCaseEvent: Case;
  /** Execute all pending executable tasks for a case */
  executeCaseTasks?: Maybe<BulkTaskResponse>;
  /** Execute a task asynchronously (returns immediately) */
  executeTask?: Maybe<TaskExecutionResponse>;
  /** Execute a task synchronously (waits for completion) */
  executeTaskSync?: Maybe<TaskExecutionResponse>;
  /** Reset cursor and trigger an immediate ingest cycle for a project */
  forceSync?: Maybe<ForceSyncResponse>;
  /** Import case settings from a JSON string */
  importCaseSettings?: Maybe<ImportCaseSettingsResult>;
  /** Link one or more alerts to a case */
  linkAlertsToCase?: Maybe<LinkAlertsResult>;
  /** Link a case to one or more other cases */
  linkCases?: Maybe<CaseLinkResponse>;
  /**
   * Merge two cases: transfer all links, comments, and alerts from the
   * duplicate to the survivor, then soft-delete the duplicate.
   */
  mergeCases?: Maybe<MergeCasesResult>;
  /** Move a case to a different project */
  moveCaseToProject?: Maybe<MoveCaseResponse>;
  /** Publish draft transitions to active */
  publishStatusWorkflow?: Maybe<StatusWorkflowResponse>;
  /** Delete synced outbox entries older than the given date */
  purgeSyncedOutbox?: Maybe<PurgeOutboxResponse>;
  /** Reassign case types from one workflow to another */
  reassignStatusWorkflow?: Maybe<ReassignStatusWorkflowResponse>;
  /** Remove all field mappings from a case type */
  removeAllFieldsFromCaseType?: Maybe<SuccessResponse>;
  /** Remove a field from a case type */
  removeFieldFromCaseType?: Maybe<SuccessResponse>;
  /** Remove a workflow action from a project's action library */
  removeProjectAction?: Maybe<DeleteResponse>;
  /** Reorder fields within a case type */
  reorderCaseTypeFields: Array<CaseTypeField>;
  /** Reorder priorities (first = highest priority) */
  reorderPriorities: Array<Priority>;
  /** Reorder task templates within a case type */
  reorderTaskTemplates: Array<TaskTemplate>;
  /** Reorder tasks within a case */
  reorderTasks?: Maybe<BulkTaskResponse>;
  /**
   * Resolve a sync conflict for a case.
   *
   * Accepts three resolution types:
   * - `ACCEPT_LOCAL` - Keep all local values, queue case for push
   * - `ACCEPT_UPSTREAM` - Accept all upstream values, mark case synced
   * - `MERGE` - Per-field resolution using field_choices
   */
  resolveConflict?: Maybe<ResolveConflictResponse>;
  /** Reset a failed outbox entry to pending for reprocessing */
  retryOutboxEvent?: Maybe<RetryOutboxResponse>;
  /** Retry a failed task */
  retryTask?: Maybe<TaskExecutionResponse>;
  /** Set a custom field value for a case */
  setCaseFieldValue?: Maybe<CaseFieldResponse>;
  /** Set a priority as the default for new cases */
  setDefaultPriority?: Maybe<PriorityResponse>;
  /** Unassign a task */
  unassignTask?: Maybe<TaskResponse>;
  /** Unlink one or more alerts from a case */
  unlinkAlertsFromCase?: Maybe<UnlinkAlertsResult>;
  /** Unlink a case from one or more other cases */
  unlinkCases?: Maybe<CaseLinkResponse>;
  /** Update a case */
  updateCase?: Maybe<CaseResponse>;
  /** Update a case field definition */
  updateCaseField?: Maybe<CaseFieldResponse>;
  /** Update a case type field mapping */
  updateCaseTypeField?: Maybe<CaseTypeFieldResponse>;
  /** Update a comment */
  updateComment?: Maybe<CommentResponse>;
  /** Update a priority */
  updatePriority?: Maybe<PriorityResponse>;
  /** Update a case project */
  updateProject?: Maybe<CaseProjectResponse>;
  /** Update a saved search (must be owner) */
  updateSavedSearch?: Maybe<SavedSearchResponse>;
  /** Update a status workflow (use draft_transitions for editing) */
  updateStatusWorkflow?: Maybe<StatusWorkflowResponse>;
  /** Update a task */
  updateTask?: Maybe<TaskResponse>;
  /** Update a task template */
  updateTaskTemplate?: Maybe<TaskTemplateResponse>;
  /** Upload an attachment to a case */
  uploadAttachment?: Maybe<AttachmentResponse>;
  /** Create or update the sync config for the current tenant */
  upsertSyncConfig?: Maybe<SyncConfigResponse>;
};


export type RootMutationTypeAddFieldToCaseTypeArgs = {
  attrs?: InputMaybe<CaseTypeFieldAttrsInput>;
  caseFieldId: Scalars['ID']['input'];
  caseTypeId: Scalars['ID']['input'];
};


export type RootMutationTypeAddProjectActionArgs = {
  input: AddProjectActionInput;
};


export type RootMutationTypeAssignTaskArgs = {
  assigneeId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type RootMutationTypeBatchAddFieldsToCaseTypeArgs = {
  caseTypeId: Scalars['ID']['input'];
  fields: Array<BatchCaseTypeFieldInput>;
};


export type RootMutationTypeCancelTaskArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeCloneStatusWorkflowArgs = {
  id: Scalars['ID']['input'];
  newName: Scalars['String']['input'];
};


export type RootMutationTypeCompleteManualTaskArgs = {
  id: Scalars['ID']['input'];
  input: CompleteManualTaskInput;
};


export type RootMutationTypeCreateCaseArgs = {
  input: CreateCaseInput;
};


export type RootMutationTypeCreateCaseFieldArgs = {
  input: CreateCaseFieldInput;
};


export type RootMutationTypeCreateCommentArgs = {
  input: CreateCommentInput;
};


export type RootMutationTypeCreateManualTaskArgs = {
  input: CreateManualTaskInput;
};


export type RootMutationTypeCreateMcpToolTaskArgs = {
  input: CreateMcpToolTaskInput;
};


export type RootMutationTypeCreatePriorityArgs = {
  input: CreatePriorityInput;
};


export type RootMutationTypeCreateProjectArgs = {
  input: CreateCaseProjectInput;
};


export type RootMutationTypeCreateSavedSearchArgs = {
  input: CreateSavedSearchInput;
};


export type RootMutationTypeCreateStatusWorkflowArgs = {
  input: CreateStatusWorkflowInput;
};


export type RootMutationTypeCreateTaskArgs = {
  input: CreateTaskInput;
};


export type RootMutationTypeCreateTaskTemplateArgs = {
  caseTypeId: Scalars['ID']['input'];
  input: CreateTaskTemplateInput;
};


export type RootMutationTypeCreateWorkflowTaskArgs = {
  input: CreateWorkflowTaskInput;
};


export type RootMutationTypeDeleteAttachmentArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteCaseArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteCaseFieldArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteCaseFieldValueArgs = {
  caseId: Scalars['ID']['input'];
  fieldId: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteCommentArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeletePriorityArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteProjectArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteSavedSearchArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteStatusWorkflowArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteTaskArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDeleteTaskTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeDismissDedupSuggestionArgs = {
  suggestionId: Scalars['ID']['input'];
};


export type RootMutationTypeDispatchCaseEventArgs = {
  input: DispatchCaseEventInput;
};


export type RootMutationTypeExecuteCaseTasksArgs = {
  caseId: Scalars['ID']['input'];
};


export type RootMutationTypeExecuteTaskArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeExecuteTaskSyncArgs = {
  id: Scalars['ID']['input'];
  timeout?: InputMaybe<Scalars['Int']['input']>;
};


export type RootMutationTypeForceSyncArgs = {
  projectId: Scalars['ID']['input'];
};


export type RootMutationTypeImportCaseSettingsArgs = {
  input: ImportCaseSettingsInput;
};


export type RootMutationTypeLinkAlertsToCaseArgs = {
  alertIds: Array<Scalars['String']['input']>;
  caseId: Scalars['String']['input'];
};


export type RootMutationTypeLinkCasesArgs = {
  input: LinkCasesInput;
};


export type RootMutationTypeMergeCasesArgs = {
  duplicateId: Scalars['ID']['input'];
  survivorId: Scalars['ID']['input'];
};


export type RootMutationTypeMoveCaseToProjectArgs = {
  caseId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type RootMutationTypePublishStatusWorkflowArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<PublishStatusWorkflowInput>;
};


export type RootMutationTypePurgeSyncedOutboxArgs = {
  before: Scalars['DateTime']['input'];
};


export type RootMutationTypeReassignStatusWorkflowArgs = {
  input: ReassignStatusWorkflowInput;
};


export type RootMutationTypeRemoveAllFieldsFromCaseTypeArgs = {
  caseTypeId: Scalars['ID']['input'];
};


export type RootMutationTypeRemoveFieldFromCaseTypeArgs = {
  caseFieldId: Scalars['ID']['input'];
  caseTypeId: Scalars['ID']['input'];
};


export type RootMutationTypeRemoveProjectActionArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeReorderCaseTypeFieldsArgs = {
  caseTypeId: Scalars['ID']['input'];
  fieldIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeReorderPrioritiesArgs = {
  priorityIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeReorderTaskTemplatesArgs = {
  caseTypeId: Scalars['ID']['input'];
  templateIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeReorderTasksArgs = {
  caseId: Scalars['ID']['input'];
  taskIds: Array<Scalars['ID']['input']>;
};


export type RootMutationTypeResolveConflictArgs = {
  caseId: Scalars['ID']['input'];
  resolution: ResolveConflictInput;
};


export type RootMutationTypeRetryOutboxEventArgs = {
  eventId: Scalars['ID']['input'];
};


export type RootMutationTypeRetryTaskArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeSetCaseFieldValueArgs = {
  input: SetFieldValueInput;
};


export type RootMutationTypeSetDefaultPriorityArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeUnassignTaskArgs = {
  id: Scalars['ID']['input'];
};


export type RootMutationTypeUnlinkAlertsFromCaseArgs = {
  alertIds: Array<Scalars['String']['input']>;
  caseId: Scalars['String']['input'];
};


export type RootMutationTypeUnlinkCasesArgs = {
  input: UnlinkCasesInput;
};


export type RootMutationTypeUpdateCaseArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCaseInput;
};


export type RootMutationTypeUpdateCaseFieldArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCaseFieldInput;
};


export type RootMutationTypeUpdateCaseTypeFieldArgs = {
  attrs: CaseTypeFieldAttrsInput;
  id: Scalars['ID']['input'];
};


export type RootMutationTypeUpdateCommentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCommentInput;
};


export type RootMutationTypeUpdatePriorityArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePriorityInput;
};


export type RootMutationTypeUpdateProjectArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCaseProjectInput;
};


export type RootMutationTypeUpdateSavedSearchArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSavedSearchInput;
};


export type RootMutationTypeUpdateStatusWorkflowArgs = {
  id: Scalars['ID']['input'];
  input: UpdateStatusWorkflowInput;
};


export type RootMutationTypeUpdateTaskArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTaskInput;
};


export type RootMutationTypeUpdateTaskTemplateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTaskTemplateInput;
};


export type RootMutationTypeUploadAttachmentArgs = {
  input: UploadAttachmentInput;
};


export type RootMutationTypeUpsertSyncConfigArgs = {
  input: UpsertSyncConfigInput;
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  /**
   * Advanced search using query language.
   *
   * Syntax:
   * - Operators: `=`, `!=`, `>`, `<`, `>=`, `<=`, `~` (contains), `!~` (not contains)
   * - Logical: `and`, `or`, `not`, parentheses for grouping
   * - Fields: status, priority, assignee, reporter, title, text, created, modified, caseType
   * - Values: "quoted strings", numbers, currentuser()
   *
   * Examples:
   * - status = "open"
   * - status = "open" and priority = "high"
   * - text ~ "security incident"
   * - created >= "2024/01/01" and created <= "2024/12/31"
   * - assignee = currentuser()
   * - (caseType = "Incident" or caseType = "Alert") and status != "closed"
   * - title ~ "urgent" order by created desc
   */
  advancedSearch: CasePage;
  /** Get a single alert by ID */
  alert?: Maybe<Alert>;
  /** Get all unique severity levels for the tenant */
  alertSeverities: Array<Scalars['String']['output']>;
  /** Get all unique SIEM sources for the tenant */
  alertSiemSources: Array<Scalars['String']['output']>;
  /** List all saved searches visible to the current user (owned + shared) */
  allSavedSearches: Array<SavedSearch>;
  /**
   * Get all available template variables for the tenant (all custom fields).
   *
   * Use this when case type is not yet selected. Returns system fields plus
   * all non-hidden, non-deprecated custom fields defined for the tenant.
   */
  allTemplateVariables: Array<TemplateVariable>;
  /** Get an attachment by ID */
  attachment?: Maybe<Attachment>;
  /** List attachments for a case */
  attachments: AttachmentsResponse;
  /**
   * List events reachable from a case's current status, with enabled/reason
   * annotations evaluated against the current actor and guards. Drives the
   * UI's action buttons (disabled tooltips).
   */
  availableCaseEvents: Array<CaseEventOption>;
  /** Get a case by ID */
  case?: Maybe<Case>;
  /** Get a case by case number */
  caseByNumber?: Maybe<Case>;
  /** Get a case field definition by ID */
  caseField?: Maybe<CaseField>;
  /** List all case field definitions */
  caseFields: Array<CaseField>;
  /** Get case history/audit log with pagination */
  caseHistory: HistoryPage;
  /** Get the observable field values for a case */
  caseObservableValues?: Maybe<Array<ObservableValue>>;
  /** Get available case priorities */
  casePriorities: Array<CasePriority>;
  /** Get a case project by ID */
  caseProject?: Maybe<CaseProject>;
  /** List all case projects for the tenant */
  caseProjects: Array<CaseProject>;
  /** Get counts of all case settings entities */
  caseSettingsCounts?: Maybe<CaseSettingCounts>;
  /**
   * Append-only state machine transition history for a case, in reverse
   * chronological order. One row per successful `dispatch_case_event`.
   */
  caseStatusHistory: Array<CaseTransition>;
  /** Get all fields for a case type (including is_all fields) */
  caseTypeAllFields: Array<CaseField>;
  /** Get a case type field mapping by ID */
  caseTypeField?: Maybe<CaseTypeField>;
  /** List field mappings for a case type */
  caseTypeFieldMappings: Array<CaseTypeField>;
  /** List cases with optional filtering */
  cases: Array<Case>;
  /** Check if two cases are linked */
  casesLinked: Scalars['Boolean']['output'];
  /** Get a comment by ID */
  comment?: Maybe<Comment>;
  /** List comments for a case */
  comments: Array<Comment>;
  /** List cases that are currently in conflict state */
  conflictedCases: Array<Case>;
  /** Convert basic search to advanced query format */
  convertToAdvancedQuery?: Maybe<AdvancedQueryResult>;
  /**
   * Correlation statistics for the tenant.
   *
   * Returns total case-to-case links and average observable values per case.
   */
  correlationStats: CorrelationStats;
  /** Get pending dedup suggestions for a case */
  dedupSuggestions: Array<DedupSuggestion>;
  /**
   * Get the default case status (used when no workflow is configured).
   *
   * NOTE: Valid statuses are now defined per case type via status workflows.
   * Use `statusWorkflow` query with the case type ID to get valid statuses.
   */
  defaultCaseStatus: Scalars['String']['output'];
  /** Get the default priority for the tenant */
  defaultPriority?: Maybe<Priority>;
  /** Get the default status workflow for the tenant */
  defaultStatusWorkflow?: Maybe<StatusWorkflow>;
  /** Download case settings as a file */
  downloadCaseSettings?: Maybe<CaseSettingDownload>;
  /**
   * Download cases as CSV based on current search/filter criteria.
   *
   * Supports both basic and advanced search modes:
   * - BASIC: Use filters (status, priority, search text, etc.)
   * - ADVANCED: Use query language syntax
   *
   * Returns CSV content as a string with all matching cases (not paginated).
   */
  downloadCasesCsv: CsvDownloadResponse;
  /** List executable tasks for a case (mcp_tool or workflow in pending status) */
  executableTasks: Array<CaseTask>;
  /** Export all case settings for the tenant */
  exportCaseSettings?: Maybe<CaseSettingExport>;
  /** Get history for a specific field of a case */
  fieldHistory: Array<HistoryEntry>;
  /** Get available field types */
  fieldTypes: Array<CaseFieldType>;
  /**
   * Find cases similar to a given case based on observable field values.
   *
   * Returns cases that share common observable values (IPs, hashes, domains, etc.)
   * with similarity scores and matched field details.
   *
   * Observable fields are custom fields marked with `is_observable: true`.
   */
  findSimilarCases: CaseSimilarityResponse;
  /** Health check for V2alpha API */
  health: Scalars['String']['output'];
  /** Get total count of history entries for a case */
  historyCount: Scalars['Int']['output'];
  /** Preview what would be imported from a JSON string */
  importCaseSettingsDiff?: Maybe<CaseSettingDiff>;
  /** Get linked case IDs for a case (just IDs, not full objects) */
  linkedCaseIds: Array<Scalars['ID']['output']>;
  /** Get linked cases for a case */
  linkedCases: Array<CaseLink>;
  /** List saved searches owned by the current user */
  mySavedSearches: Array<SavedSearch>;
  /** List tasks assigned to the current user */
  myTasks: Array<CaseTask>;
  /** Get observable field definitions for the tenant */
  observableFields: Array<CaseField>;
  /** List pending tasks for the tenant */
  pendingTasks: Array<CaseTask>;
  /** List all custom priorities */
  priorities: Array<Priority>;
  /** Get a priority by ID */
  priority?: Maybe<Priority>;
  /** Get a saved search by ID */
  savedSearch?: Maybe<SavedSearch>;
  /** Search alerts with advanced LQL-like query */
  searchAlertsAdvanced?: Maybe<AlertSearchResult>;
  /** Search alerts with basic filters */
  searchAlertsBasic?: Maybe<AlertSearchResult>;
  /** Search cases with pagination */
  searchCases: CasePage;
  /** Search tasks with pagination */
  searchTasks: TaskPage;
  /** List shared saved searches */
  sharedSavedSearches: Array<SavedSearch>;
  /** Get a status workflow by ID */
  statusWorkflow?: Maybe<StatusWorkflow>;
  /** Get the status workflow for a case type */
  statusWorkflowForCaseType?: Maybe<StatusWorkflow>;
  /** List all status workflows */
  statusWorkflows: Array<StatusWorkflow>;
  /** Get the sync config for the current tenant (or null if not configured) */
  syncConfig?: Maybe<SyncConfig>;
  /** List unresolved sync conflicts for the current tenant */
  syncConflicts: Array<SyncConflict>;
  /** List unresolved sync conflicts for a specific case */
  syncConflictsForCase: Array<SyncConflict>;
  /**
   * Sync health summary across all projects.
   *
   * Aggregates project health (healthy/degraded/error), last sync
   * timestamp, and outbox pending count. Useful for a quick dashboard
   * overview of sync infrastructure health.
   */
  syncHealthSummary: SyncHealth;
  /** Outbox entries filtered by state (pending, synced, failed). Stub until EP2-9. */
  syncOutbox: Array<OutboxEvent>;
  /** List projects that have sync configured (ingest workflow set) */
  syncSources: Array<SyncSource>;
  /** Per-project sync health for the admin dashboard (last sync, errors, scheduling) */
  syncStatus: Array<SyncProjectStatus>;
  /** Get a task by ID */
  task?: Maybe<CaseTask>;
  /** Get a task by case ID and task number */
  taskByNumber?: Maybe<CaseTask>;
  /** Get a task template by ID */
  taskTemplate?: Maybe<TaskTemplate>;
  /** List task templates for a case type */
  taskTemplates: Array<TaskTemplate>;
  /** List tasks for a case */
  tasks: Array<CaseTask>;
  /**
   * Get available template variables for automated task configuration.
   *
   * Returns system fields (case_id, title, status, etc.) plus custom fields
   * attached to the specified case type. These variables can be used in
   * MCP tool and workflow task configurations using the {{field_name}} syntax.
   *
   * Example usage in task config:
   * - "Case {{case_key}}: {{title}}" => "Case INC-42: Suspicious login"
   * - "Priority: {{priority}}" => "Priority: high"
   */
  templateVariables: Array<TemplateVariable>;
  /** Get valid next statuses for a current status */
  validNextStatuses: Array<Scalars['String']['output']>;
  /** Validate an advanced alert query */
  validateAlertQuery?: Maybe<QueryValidationResult>;
  /**
   * Validate an advanced search query without executing it.
   * Returns validation result with any error messages.
   */
  validateSearch: SearchValidationResult;
  /** Validate a status transition for a case type */
  validateStatusTransition: SearchValidationResult;
};


export type RootQueryTypeAdvancedSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  sortBy?: InputMaybe<CaseSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type RootQueryTypeAlertArgs = {
  id: Scalars['String']['input'];
};


export type RootQueryTypeAllSavedSearchesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeAttachmentArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeAttachmentsArgs = {
  caseId: Scalars['ID']['input'];
};


export type RootQueryTypeAvailableCaseEventsArgs = {
  caseId: Scalars['ID']['input'];
};


export type RootQueryTypeCaseArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeCaseByNumberArgs = {
  caseNumber: Scalars['Int']['input'];
};


export type RootQueryTypeCaseFieldArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeCaseFieldsArgs = {
  fieldType?: InputMaybe<CaseFieldType>;
  isObservable?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeCaseHistoryArgs = {
  caseId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeCaseObservableValuesArgs = {
  caseId: Scalars['ID']['input'];
};


export type RootQueryTypeCaseProjectArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeCaseStatusHistoryArgs = {
  caseId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeCaseTypeAllFieldsArgs = {
  caseTypeId: Scalars['ID']['input'];
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootQueryTypeCaseTypeFieldArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeCaseTypeFieldMappingsArgs = {
  caseTypeId: Scalars['ID']['input'];
};


export type RootQueryTypeCasesArgs = {
  filter?: InputMaybe<CaseFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<CaseSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type RootQueryTypeCasesLinkedArgs = {
  caseId: Scalars['ID']['input'];
  otherCaseId: Scalars['ID']['input'];
};


export type RootQueryTypeCommentArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeCommentsArgs = {
  caseId: Scalars['ID']['input'];
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeConflictedCasesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeConvertToAdvancedQueryArgs = {
  input: BasicSearchInput;
};


export type RootQueryTypeDedupSuggestionsArgs = {
  caseId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<DedupSuggestionStatus>;
};


export type RootQueryTypeDownloadCaseSettingsArgs = {
  caseTypeNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type RootQueryTypeDownloadCasesCsvArgs = {
  input: DownloadCasesCsvInput;
};


export type RootQueryTypeExecutableTasksArgs = {
  caseId: Scalars['ID']['input'];
};


export type RootQueryTypeExportCaseSettingsArgs = {
  caseTypeNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type RootQueryTypeFieldHistoryArgs = {
  caseId: Scalars['ID']['input'];
  fieldName: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeFindSimilarCasesArgs = {
  caseId: Scalars['ID']['input'];
  input?: InputMaybe<CaseSimilarityInput>;
};


export type RootQueryTypeHistoryCountArgs = {
  caseId: Scalars['ID']['input'];
};


export type RootQueryTypeImportCaseSettingsDiffArgs = {
  caseTypeNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  data: Scalars['String']['input'];
};


export type RootQueryTypeLinkedCaseIdsArgs = {
  caseId: Scalars['ID']['input'];
};


export type RootQueryTypeLinkedCasesArgs = {
  caseId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkType?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeMySavedSearchesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeMyTasksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<TaskStatus>;
};


export type RootQueryTypePendingTasksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypePrioritiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypePriorityArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeSavedSearchArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeSearchAlertsAdvancedArgs = {
  input: AdvancedSearchInput;
};


export type RootQueryTypeSearchAlertsBasicArgs = {
  input: BasicSearchInput;
};


export type RootQueryTypeSearchCasesArgs = {
  filter?: InputMaybe<CaseFilterInput>;
  include?: InputMaybe<CaseIncludeOptions>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<CaseSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type RootQueryTypeSearchTasksArgs = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  caseId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<TaskStatus>;
  taskType?: InputMaybe<TaskType>;
};


export type RootQueryTypeSharedSavedSearchesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeStatusWorkflowArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeStatusWorkflowForCaseTypeArgs = {
  caseTypeId: Scalars['ID']['input'];
};


export type RootQueryTypeStatusWorkflowsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeSyncConflictsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RootQueryTypeSyncConflictsForCaseArgs = {
  caseId: Scalars['ID']['input'];
};


export type RootQueryTypeSyncOutboxArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeTaskArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeTaskByNumberArgs = {
  caseId: Scalars['ID']['input'];
  taskNumber: Scalars['Int']['input'];
};


export type RootQueryTypeTaskTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeTaskTemplatesArgs = {
  caseTypeId: Scalars['ID']['input'];
};


export type RootQueryTypeTasksArgs = {
  caseId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<TaskStatus>;
  taskType?: InputMaybe<TaskType>;
};


export type RootQueryTypeTemplateVariablesArgs = {
  caseTypeId: Scalars['ID']['input'];
};


export type RootQueryTypeValidNextStatusesArgs = {
  caseTypeId: Scalars['ID']['input'];
  currentStatus: Scalars['String']['input'];
};


export type RootQueryTypeValidateAlertQueryArgs = {
  query: Scalars['String']['input'];
};


export type RootQueryTypeValidateSearchArgs = {
  query: Scalars['String']['input'];
};


export type RootQueryTypeValidateStatusTransitionArgs = {
  caseTypeId: Scalars['ID']['input'];
  fromStatus: Scalars['String']['input'];
  toStatus: Scalars['String']['input'];
};

export type RootSubscriptionType = {
  __typename?: 'RootSubscriptionType';
  /**
   * Subscribe to ALL updates for a specific case in a single subscription.
   *
   * Events include:
   * - CASE_UPDATED - Case fields changed (status, priority, title, etc.)
   * - CASE_DELETED - Case was deleted
   * - COMMENT_ADDED - New comment added
   * - COMMENT_UPDATED - Comment edited
   * - COMMENT_DELETED - Comment deleted
   * - TASK_CREATED - New task created
   * - TASK_UPDATED - Task status/fields changed
   * - TASK_DELETED - Task deleted
   * - FIELD_UPDATED - Custom field value changed
   * - ATTACHMENT_ADDED - New attachment uploaded
   * - ATTACHMENT_DELETED - Attachment removed
   * - HISTORY_ADDED - New audit entry
   *
   * All events are delivered to a single subscription, making it easy to
   * keep a case detail page in sync with the server.
   */
  caseEvents?: Maybe<CaseEvent>;
};


export type RootSubscriptionTypeCaseEventsArgs = {
  caseId: Scalars['ID']['input'];
};

/** A saved search query */
export type SavedSearch = {
  __typename?: 'SavedSearch';
  /** Optional description */
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['NaiveDateTime']['output'];
  /** Whether visible to all users in tenant */
  isShared: Scalars['Boolean']['output'];
  /** Display name for the saved search */
  name: Scalars['String']['output'];
  /** User who created the search */
  ownerId: Scalars['ID']['output'];
  /** The search query string */
  query: Scalars['String']['output'];
  /** Type of search query */
  queryType: SearchQueryType;
  updatedAt: Scalars['NaiveDateTime']['output'];
};

/** Response for saved search mutations */
export type SavedSearchResponse = {
  __typename?: 'SavedSearchResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  savedSearch?: Maybe<SavedSearch>;
  success: Scalars['Boolean']['output'];
};

/** Saved search query type */
export enum SearchQueryType {
  /** Query language based search */
  Advanced = 'ADVANCED',
  /** Simple text-based search */
  Basic = 'BASIC'
}

/** Result of search query validation */
export type SearchValidationResult = {
  __typename?: 'SearchValidationResult';
  /** Error message if invalid */
  error?: Maybe<Scalars['String']['output']>;
  /** String representation of the parsed query (for debugging) */
  parsedQuery?: Maybe<Scalars['String']['output']>;
  /** Whether the query is syntactically valid */
  valid: Scalars['Boolean']['output'];
};

/** Input for setting a case field value */
export type SetFieldValueInput = {
  caseId: Scalars['ID']['input'];
  fieldId: Scalars['ID']['input'];
  /** Value as string (will be parsed by field type) */
  value: Scalars['String']['input'];
};

/** A case that is similar to the source case */
export type SimilarCase = {
  __typename?: 'SimilarCase';
  /** The similar case record */
  case: Case;
  /** Number of matching observable values */
  matchedCount: Scalars['Int']['output'];
  /** Fields that matched */
  matchedFields: Array<MatchedField>;
  /** Similarity score (0.0 - 1.0) */
  similarityScore: Scalars['Float']['output'];
  /** Total observable values in source case */
  totalObservables: Scalars['Int']['output'];
};

/** Sort fields for case similarity results */
export enum SimilaritySortField {
  /** Sort by case creation date */
  CreatedAt = 'CREATED_AT',
  /** Sort by number of matching observables */
  MatchCount = 'MATCH_COUNT',
  /** Sort by case status */
  Status = 'STATUS'
}

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** A status transition definition */
export type StatusTransition = {
  __typename?: 'StatusTransition';
  /** Source status name */
  from: Scalars['String']['output'];
  /** Classification of this status */
  statusType: StatusType;
  /** Allowed target statuses */
  to: Array<Scalars['String']['output']>;
};

/** Input for a status transition */
export type StatusTransitionInput = {
  /** Source status name */
  from: Scalars['String']['input'];
  /** Classification of this status */
  statusType: StatusType;
  /** Allowed target statuses */
  to: Array<Scalars['String']['input']>;
};

/** Status type classification */
export enum StatusType {
  /** Terminal/end status */
  Closed = 'CLOSED',
  /** Work in progress */
  InProgress = 'IN_PROGRESS',
  /** Initial/starting status */
  Open = 'OPEN'
}

/** A status workflow defining allowed statuses and transitions */
export type StatusWorkflow = {
  __typename?: 'StatusWorkflow';
  /** All status names in this workflow */
  allStatuses: Array<Scalars['String']['output']>;
  /** Number of case types using this workflow */
  caseTypesCount: Scalars['Int']['output'];
  /** Workflow description */
  description?: Maybe<Scalars['String']['output']>;
  /** Draft transitions being edited */
  draftTransitions?: Maybe<Array<Maybe<StatusTransition>>>;
  /** Whether unpublished draft changes exist */
  hasDraft: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['NaiveDateTime']['output'];
  /** Whether workflow has active transitions */
  isPublished: Scalars['Boolean']['output'];
  /** Whether this is a system/default workflow */
  isSystem: Scalars['Boolean']['output'];
  /** Workflow name (unique per tenant) */
  name: Scalars['String']['output'];
  ownerId?: Maybe<Scalars['ID']['output']>;
  /** Initial status for new cases */
  startStatus?: Maybe<Scalars['String']['output']>;
  /** Active (published) transitions */
  transitions?: Maybe<Array<Maybe<StatusTransition>>>;
  updatedAt: Scalars['NaiveDateTime']['output'];
};

/** Status workflow diff entry for import preview */
export type StatusWorkflowDiff = {
  __typename?: 'StatusWorkflowDiff';
  /** Whether workflow already exists in tenant */
  exists: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** Exported status workflow definition */
export type StatusWorkflowExport = {
  __typename?: 'StatusWorkflowExport';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  transitions: Array<Maybe<Scalars['Json']['output']>>;
};

/** Response for status workflow mutations */
export type StatusWorkflowResponse = {
  __typename?: 'StatusWorkflowResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  statusWorkflow?: Maybe<StatusWorkflow>;
  success: Scalars['Boolean']['output'];
};

/** Response for simple success/failure operations */
export type SuccessResponse = {
  __typename?: 'SuccessResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success: Scalars['Boolean']['output'];
};

/** Tenant-level sync configuration with default strategy and per-field overrides */
export type SyncConfig = {
  __typename?: 'SyncConfig';
  /** Default conflict resolution strategy for the tenant (remote_wins, local_wins, manual) */
  defaultStrategy: Scalars['String']['output'];
  /** Per-field strategy overrides as a JSON map (e.g., {"status": "remote_wins"}) */
  fieldStrategies?: Maybe<Scalars['Json']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['NaiveDateTime']['output'];
  tenantId: Scalars['ID']['output'];
  updatedAt: Scalars['NaiveDateTime']['output'];
};

/** Response for sync config mutations */
export type SyncConfigResponse = {
  __typename?: 'SyncConfigResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success: Scalars['Boolean']['output'];
  syncConfig?: Maybe<SyncConfig>;
};

/** A sync conflict detected during case reconciliation */
export type SyncConflict = {
  __typename?: 'SyncConflict';
  /** ID of the case with the conflict */
  caseId: Scalars['ID']['output'];
  /** Type of conflict detected */
  conflictType: ConflictType;
  /** Name of the conflicting field (for field_conflict) */
  fieldName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** When the conflict was detected (ISO8601) */
  insertedAt: Scalars['String']['output'];
  /** The local value of the field */
  localValue?: Maybe<Scalars['String']['output']>;
  /** The upstream value of the field */
  remoteValue?: Maybe<Scalars['String']['output']>;
  /** How the conflict was resolved (if resolved) */
  resolutionStrategy?: Maybe<Scalars['String']['output']>;
  /** When the conflict was resolved (ISO8601) */
  resolvedAt?: Maybe<Scalars['String']['output']>;
  /** ID of the user who resolved the conflict */
  resolvedById?: Maybe<Scalars['ID']['output']>;
};

/** Sync health summary across all projects */
export type SyncHealth = {
  __typename?: 'SyncHealth';
  /** Projects with conflicts but no errors */
  degraded: Scalars['Int']['output'];
  /** Projects with sync errors */
  error: Scalars['Int']['output'];
  /** Projects with all cases synced */
  healthy: Scalars['Int']['output'];
  /** Most recent sync timestamp (ISO8601) */
  lastSync?: Maybe<Scalars['String']['output']>;
  /** Cases pending outbound sync */
  outboxPending: Scalars['Int']['output'];
  /** Total sync-configured projects */
  totalProjects: Scalars['Int']['output'];
};

/** Per-project sync health status for the admin dashboard */
export type SyncProjectStatus = {
  __typename?: 'SyncProjectStatus';
  /** Current sync cursor position */
  cursorValue?: Maybe<Scalars['String']['output']>;
  /** Workflow used for ingest */
  ingestWorkflowId?: Maybe<Scalars['ID']['output']>;
  /** Error from last failed sync run */
  lastError?: Maybe<Scalars['String']['output']>;
  /** Last successful sync timestamp */
  lastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether sync is paused */
  paused: Scalars['Boolean']['output'];
  /** ID of the case project */
  projectId: Scalars['ID']['output'];
  /** Whether a cron job is active */
  scheduled: Scalars['Boolean']['output'];
  /** Per-run metrics (cases_ingested, errors, duration_ms) */
  stats?: Maybe<Scalars['Json']['output']>;
  /** Cron expression for sync schedule */
  syncInterval?: Maybe<Scalars['String']['output']>;
};

/** A project with sync configured (has an ingest workflow) */
export type SyncSource = {
  __typename?: 'SyncSource';
  /** Conflict resolution strategy */
  conflictStrategy: Scalars['String']['output'];
  /** Ingest workflow reference */
  ingestWorkflowId: Scalars['ID']['output'];
  /** Last successful sync timestamp */
  lastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Outbound workflow reference */
  outboundWorkflowId?: Maybe<Scalars['ID']['output']>;
  /** ID of the case project */
  projectId: Scalars['ID']['output'];
  /** Human-readable project name */
  projectName: Scalars['String']['output'];
  /** URL-safe project slug */
  projectSlug: Scalars['String']['output'];
  /** Cron expression for sync schedule */
  syncInterval: Scalars['String']['output'];
};

/** Response for task execution */
export type TaskExecutionResponse = {
  __typename?: 'TaskExecutionResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Unique identifier for this execution */
  executionId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  task?: Maybe<CaseTask>;
};

/** Paginated list of tasks */
export type TaskPage = {
  __typename?: 'TaskPage';
  hasMore: Scalars['Boolean']['output'];
  tasks: Array<CaseTask>;
  total: Scalars['Int']['output'];
};

/** Response for task mutations */
export type TaskResponse = {
  __typename?: 'TaskResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success: Scalars['Boolean']['output'];
  task?: Maybe<CaseTask>;
};

/** Task status enumeration */
export enum TaskStatus {
  /** Task is blocked by dependencies */
  Blocked = 'BLOCKED',
  /** Task was cancelled */
  Cancelled = 'CANCELLED',
  /** Task completed successfully */
  Done = 'DONE',
  /** Task failed during execution */
  Failed = 'FAILED',
  /** Task is currently being worked on */
  InProgress = 'IN_PROGRESS',
  /** Task is ready to be worked on */
  Todo = 'TODO'
}

/** A task template (preset task) associated with a case type */
export type TaskTemplate = {
  __typename?: 'TaskTemplate';
  /** User assigned to tasks created from this template */
  assignee?: Maybe<User>;
  /** If true, task output is automatically posted as a case comment on completion */
  commentOutput: Scalars['Boolean']['output'];
  /** Type-specific configuration (structure varies by task_type) */
  config?: Maybe<Scalars['Json']['output']>;
  /** User who created this template */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['NaiveDateTime']['output'];
  name: Scalars['String']['output'];
  /** The project this template belongs to */
  project?: Maybe<CaseProject>;
  sortOrder: Scalars['Int']['output'];
  taskType: TaskType;
  /** How task execution is triggered */
  triggerMode?: Maybe<TriggerMode>;
  updatedAt: Scalars['NaiveDateTime']['output'];
};

/** Exported task template definition */
export type TaskTemplateExport = {
  __typename?: 'TaskTemplateExport';
  caseTypeName: Scalars['String']['output'];
  config?: Maybe<Scalars['Json']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  taskType: Scalars['String']['output'];
  /** How task execution is triggered (automatic/on_click) */
  triggerMode: Scalars['String']['output'];
};

/** Response for task template mutations */
export type TaskTemplateResponse = {
  __typename?: 'TaskTemplateResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success: Scalars['Boolean']['output'];
  taskTemplate?: Maybe<TaskTemplate>;
};

/** Task type enumeration */
export enum TaskType {
  /** Human-assigned task */
  Manual = 'MANUAL',
  /** Automated MCP server tool execution */
  McpTool = 'MCP_TOOL',
  /** Matrix workflow execution */
  Workflow = 'WORKFLOW'
}

/**
 * A template variable available for task configuration.
 *
 * Template variables can be used in automated task configurations (MCP tools, workflows)
 * using the {{field_name}} syntax. At execution time, these placeholders are replaced
 * with actual case field values.
 */
export type TemplateVariable = {
  __typename?: 'TemplateVariable';
  /** Category: 'system' for built-in fields, 'custom' for user-defined fields */
  category: Scalars['String']['output'];
  /** Human-readable label (e.g., 'Case ID', 'Source IP') */
  displayName: Scalars['String']['output'];
  /** Snake_case name used in templates (e.g., 'case_id', 'source_ip') */
  fieldName: Scalars['String']['output'];
  /** Type of the field (text, number, datetime, etc.) */
  fieldType: Scalars['String']['output'];
};

/** Trigger mode for automated tasks */
export enum TriggerMode {
  /** Task executes automatically during case sweep */
  Automatic = 'AUTOMATIC',
  /** Task requires manual user trigger to execute */
  OnClick = 'ON_CLICK'
}

/** Unlink alerts from case result */
export type UnlinkAlertsResult = {
  __typename?: 'UnlinkAlertsResult';
  /** The case ID that was updated */
  caseId?: Maybe<Scalars['String']['output']>;
  /** Any errors encountered */
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** IDs of alerts still linked */
  remainingAlertIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
  /** Number of alerts successfully unlinked */
  unlinkedCount: Scalars['Int']['output'];
};

/** Input for unlinking cases */
export type UnlinkCasesInput = {
  /** The source case ID */
  caseId: Scalars['ID']['input'];
  /** IDs of cases to unlink from */
  linkedCaseIds: Array<Scalars['ID']['input']>;
};

/** Input for updating a case field */
export type UpdateCaseFieldInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptor?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  isAll?: InputMaybe<Scalars['Boolean']['input']>;
  isDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isObservable?: InputMaybe<Scalars['Boolean']['input']>;
  regex?: InputMaybe<Scalars['String']['input']>;
  validationRegex?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a case */
export type UpdateCaseInput = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Priority name (e.g., 'low', 'high', or custom) */
  priority?: InputMaybe<Scalars['String']['input']>;
  /** New status (must be valid in the case type's workflow) */
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a case project */
export type UpdateCaseProjectInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  conflictStrategy?: InputMaybe<Scalars['String']['input']>;
  /** ID of the default user to assign to new cases in this project */
  defaultAssigneeId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Task execution mode (sequential/unordered) */
  executionMode?: InputMaybe<ExecutionMode>;
  icon?: InputMaybe<Scalars['String']['input']>;
  ingestWorkflowId?: InputMaybe<Scalars['ID']['input']>;
  memberIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  outboundWorkflowId?: InputMaybe<Scalars['ID']['input']>;
  /** Prefix for case keys (e.g., 'INC') */
  prefix?: InputMaybe<Scalars['String']['input']>;
  projectType?: InputMaybe<CaseProjectType>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the status workflow to use for this project */
  statusWorkflowId?: InputMaybe<Scalars['ID']['input']>;
  syncInterval?: InputMaybe<Scalars['String']['input']>;
  /** JSON layout config for case detail page. Set to null to use default. */
  viewLayout?: InputMaybe<Scalars['Json']['input']>;
};

/** Input for updating a comment */
export type UpdateCommentInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<ContentType>;
};

/** Input for updating a priority */
export type UpdatePriorityInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priorityValue?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for updating a saved search */
export type UpdateSavedSearchInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  queryType?: InputMaybe<SearchQueryType>;
};

/** Input for updating a status workflow */
export type UpdateStatusWorkflowInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** Draft transitions for editing (not live until published) */
  draftTransitions?: InputMaybe<Array<StatusTransitionInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a task */
export type UpdateTaskInput = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** If true, task output is posted as a case comment on completion (mcp_tool/workflow only) */
  commentOutput?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** New status for the task (manual tasks only) */
  status?: InputMaybe<TaskStatus>;
  /** How task execution is triggered */
  triggerMode?: InputMaybe<TriggerMode>;
};

/** Input for updating a task template */
export type UpdateTaskTemplateInput = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** If true, task output is posted as a case comment on completion (mcp_tool/workflow only) */
  commentOutput?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** How task execution is triggered */
  triggerMode?: InputMaybe<TriggerMode>;
};

/** Input for uploading an attachment */
export type UploadAttachmentInput = {
  /** The case ID to attach the file to */
  caseId: Scalars['ID']['input'];
  /** Base64 encoded file content */
  content: Scalars['String']['input'];
  /** MIME type (defaults to application/octet-stream) */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Original filename */
  filename: Scalars['String']['input'];
};

/** Input for creating or updating a sync config */
export type UpsertSyncConfigInput = {
  /** Default conflict strategy (remote_wins, local_wins, manual) */
  defaultStrategy?: InputMaybe<Scalars['String']['input']>;
  /** Per-field strategy overrides as a JSON map */
  fieldStrategies?: InputMaybe<Scalars['Json']['input']>;
};

/** Simplified user reference for cases */
export type User = {
  __typename?: 'User';
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type CreateCaseV2MutationVariables = Exact<{
  title: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateCaseV2Mutation = { __typename?: 'RootMutationType', createCase?: { __typename?: 'CaseResponse', success: boolean, errors?: Array<string | null> | null, case?: { __typename?: 'Case', id: string, caseNumber: number, displayKey: string, title: string, description?: string | null, status: string, priority: string, insertedAt: any, updatedAt: any, assignee?: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } | null, project?: { __typename?: 'CaseProject', id: string, name: string, description?: string | null } | null } | null } | null };

export type UpdateCaseV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateCaseV2Mutation = { __typename?: 'RootMutationType', updateCase?: { __typename?: 'CaseResponse', success: boolean, errors?: Array<string | null> | null, case?: { __typename?: 'Case', id: string, caseNumber: number, displayKey: string, title: string, description?: string | null, status: string, priority: string, insertedAt: any, updatedAt: any, assignee?: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } | null } | null } | null };

export type DeleteCaseV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCaseV2Mutation = { __typename?: 'RootMutationType', deleteCase?: { __typename?: 'DeleteResponse', success: boolean, id?: string | null, errors?: Array<string | null> | null } | null };

export type AddFieldToCaseTypeV2MutationVariables = Exact<{
  caseTypeId: Scalars['ID']['input'];
  caseFieldId: Scalars['ID']['input'];
  attrs?: InputMaybe<CaseTypeFieldAttrsInput>;
}>;


export type AddFieldToCaseTypeV2Mutation = { __typename?: 'RootMutationType', addFieldToCaseType?: { __typename?: 'CaseTypeFieldResponse', success: boolean, errors?: Array<string | null> | null, caseTypeField?: { __typename?: 'CaseTypeField', id: string, createRequired: boolean, closeRequired: boolean, sortOrder: number, caseTypeId: string, caseFieldId: string, insertedAt: any, updatedAt: any, caseField?: { __typename?: 'CaseField', id: string, fieldName: string, displayName: string, fieldType: CaseFieldType } | null } | null } | null };

export type BatchAddFieldsToCaseTypeV2MutationVariables = Exact<{
  caseTypeId: Scalars['ID']['input'];
  fields: Array<BatchCaseTypeFieldInput> | BatchCaseTypeFieldInput;
}>;


export type BatchAddFieldsToCaseTypeV2Mutation = { __typename?: 'RootMutationType', batchAddFieldsToCaseType?: { __typename?: 'BatchCaseTypeFieldResponse', success: boolean, errors?: Array<string | null> | null, caseTypeFields?: Array<{ __typename?: 'CaseTypeField', id: string, createRequired: boolean, closeRequired: boolean, sortOrder: number, caseTypeId: string, caseFieldId: string, insertedAt: any, updatedAt: any, caseField?: { __typename?: 'CaseField', id: string, fieldName: string, displayName: string, fieldType: CaseFieldType } | null } | null> | null } | null };

export type RemoveFieldFromCaseTypeV2MutationVariables = Exact<{
  caseTypeId: Scalars['ID']['input'];
  caseFieldId: Scalars['ID']['input'];
}>;


export type RemoveFieldFromCaseTypeV2Mutation = { __typename?: 'RootMutationType', removeFieldFromCaseType?: { __typename?: 'SuccessResponse', success: boolean, errors?: Array<string | null> | null } | null };

export type UpdateCaseTypeFieldV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attrs: CaseTypeFieldAttrsInput;
}>;


export type UpdateCaseTypeFieldV2Mutation = { __typename?: 'RootMutationType', updateCaseTypeField?: { __typename?: 'CaseTypeFieldResponse', success: boolean, errors?: Array<string | null> | null, caseTypeField?: { __typename?: 'CaseTypeField', id: string, createRequired: boolean, closeRequired: boolean, sortOrder: number, caseTypeId: string, caseFieldId: string, insertedAt: any, updatedAt: any } | null } | null };

export type ReorderCaseTypeFieldsV2MutationVariables = Exact<{
  caseTypeId: Scalars['ID']['input'];
  fieldIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ReorderCaseTypeFieldsV2Mutation = { __typename?: 'RootMutationType', reorderCaseTypeFields: Array<{ __typename?: 'CaseTypeField', id: string, sortOrder: number, caseFieldId: string, createRequired: boolean, closeRequired: boolean, caseTypeId: string, caseField?: { __typename?: 'CaseField', id: string, displayName: string, fieldType: CaseFieldType, isSystem: boolean } | null }> };

export type CreateCaseFieldV2MutationVariables = Exact<{
  input: CreateCaseFieldInput;
}>;


export type CreateCaseFieldV2Mutation = { __typename?: 'RootMutationType', createCaseField?: { __typename?: 'CaseFieldResponse', success: boolean, errors?: Array<string | null> | null, caseField?: { __typename?: 'CaseField', id: string, fieldName: string, displayName: string, fieldType: CaseFieldType, description?: string | null, descriptor?: string | null, isDeprecated: boolean, isObservable: boolean, isAll: boolean, isSystem: boolean, isHidden: boolean, isComputed: boolean, regex?: string | null, exclusionRegexes?: string | null, validationRegex?: string | null, insertedAt: any, updatedAt: any } | null } | null };

export type UpdateCaseFieldV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateCaseFieldInput;
}>;


export type UpdateCaseFieldV2Mutation = { __typename?: 'RootMutationType', updateCaseField?: { __typename?: 'CaseFieldResponse', success: boolean, errors?: Array<string | null> | null, caseField?: { __typename?: 'CaseField', id: string, fieldName: string, displayName: string, fieldType: CaseFieldType, description?: string | null, descriptor?: string | null, isDeprecated: boolean, isObservable: boolean, isAll: boolean, isSystem: boolean, isHidden: boolean, isComputed: boolean, regex?: string | null, exclusionRegexes?: string | null, validationRegex?: string | null, insertedAt: any, updatedAt: any } | null } | null };

export type DeleteCaseFieldV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCaseFieldV2Mutation = { __typename?: 'RootMutationType', deleteCaseField?: { __typename?: 'DeleteResponse', success: boolean, id?: string | null, errors?: Array<string | null> | null } | null };

export type CreatePriorityV2MutationVariables = Exact<{
  input: CreatePriorityInput;
}>;


export type CreatePriorityV2Mutation = { __typename?: 'RootMutationType', createPriority?: { __typename?: 'PriorityResponse', success: boolean, errors?: Array<string | null> | null, priority?: { __typename?: 'Priority', id: string, name: string, icon: string, color?: string | null, priorityValue: number, isDefault: boolean, insertedAt: any, updatedAt: any } | null } | null };

export type UpdatePriorityV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdatePriorityInput;
}>;


export type UpdatePriorityV2Mutation = { __typename?: 'RootMutationType', updatePriority?: { __typename?: 'PriorityResponse', success: boolean, errors?: Array<string | null> | null, priority?: { __typename?: 'Priority', id: string, name: string, icon: string, color?: string | null, priorityValue: number, isDefault: boolean, insertedAt: any, updatedAt: any } | null } | null };

export type DeletePriorityV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePriorityV2Mutation = { __typename?: 'RootMutationType', deletePriority?: { __typename?: 'DeleteResponse', success: boolean, id?: string | null, errors?: Array<string | null> | null } | null };

export type SetDefaultPriorityV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SetDefaultPriorityV2Mutation = { __typename?: 'RootMutationType', setDefaultPriority?: { __typename?: 'PriorityResponse', success: boolean, errors?: Array<string | null> | null, priority?: { __typename?: 'Priority', id: string, name: string, icon: string, color?: string | null, priorityValue: number, isDefault: boolean, insertedAt: any, updatedAt: any } | null } | null };

export type ReorderPrioritiesV2MutationVariables = Exact<{
  priorityIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ReorderPrioritiesV2Mutation = { __typename?: 'RootMutationType', reorderPriorities: Array<{ __typename?: 'Priority', id: string, name: string, icon: string, color?: string | null, priorityValue: number, isDefault: boolean, insertedAt: any, updatedAt: any }> };

export type CreateStatusWorkflowV2MutationVariables = Exact<{
  input: CreateStatusWorkflowInput;
}>;


export type CreateStatusWorkflowV2Mutation = { __typename?: 'RootMutationType', createStatusWorkflow?: { __typename?: 'StatusWorkflowResponse', success: boolean, errors?: Array<string | null> | null, statusWorkflow?: { __typename?: 'StatusWorkflow', id: string, name: string, description?: string | null, isSystem: boolean, hasDraft: boolean, insertedAt: any, updatedAt: any, transitions?: Array<{ __typename?: 'StatusTransition', from: string, to: Array<string>, statusType: StatusType } | null> | null } | null } | null };

export type UpdateStatusWorkflowV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateStatusWorkflowInput;
}>;


export type UpdateStatusWorkflowV2Mutation = { __typename?: 'RootMutationType', updateStatusWorkflow?: { __typename?: 'StatusWorkflowResponse', success: boolean, errors?: Array<string | null> | null, statusWorkflow?: { __typename?: 'StatusWorkflow', id: string, name: string, description?: string | null, isSystem: boolean, hasDraft: boolean, insertedAt: any, updatedAt: any, transitions?: Array<{ __typename?: 'StatusTransition', from: string, to: Array<string>, statusType: StatusType } | null> | null, draftTransitions?: Array<{ __typename?: 'StatusTransition', from: string, to: Array<string>, statusType: StatusType } | null> | null } | null } | null };

export type DeleteStatusWorkflowV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteStatusWorkflowV2Mutation = { __typename?: 'RootMutationType', deleteStatusWorkflow?: { __typename?: 'DeleteResponse', success: boolean, id?: string | null, errors?: Array<string | null> | null } | null };

export type CloneStatusWorkflowV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
  newName: Scalars['String']['input'];
}>;


export type CloneStatusWorkflowV2Mutation = { __typename?: 'RootMutationType', cloneStatusWorkflow?: { __typename?: 'StatusWorkflowResponse', success: boolean, errors?: Array<string | null> | null, statusWorkflow?: { __typename?: 'StatusWorkflow', id: string, name: string, description?: string | null, isSystem: boolean, hasDraft: boolean, insertedAt: any, updatedAt: any, transitions?: Array<{ __typename?: 'StatusTransition', from: string, to: Array<string>, statusType: StatusType } | null> | null } | null } | null };

export type ReassignStatusWorkflowV2MutationVariables = Exact<{
  input: ReassignStatusWorkflowInput;
}>;


export type ReassignStatusWorkflowV2Mutation = { __typename?: 'RootMutationType', reassignStatusWorkflow?: { __typename?: 'ReassignStatusWorkflowResponse', success: boolean, caseTypesUpdated?: number | null, casesUpdated?: number | null, errors?: Array<string | null> | null } | null };

export type CreateCommentV2MutationVariables = Exact<{
  input: CreateCommentInput;
}>;


export type CreateCommentV2Mutation = { __typename?: 'RootMutationType', createComment?: { __typename?: 'CommentResponse', success: boolean, errors?: Array<string | null> | null, comment?: { __typename?: 'Comment', id: string, content: string, contentType: ContentType, insertedAt: any, updatedAt: any, isDeleted: boolean, user: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } } | null } | null };

export type UpdateCommentV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateCommentInput;
}>;


export type UpdateCommentV2Mutation = { __typename?: 'RootMutationType', updateComment?: { __typename?: 'CommentResponse', success: boolean, errors?: Array<string | null> | null, comment?: { __typename?: 'Comment', id: string, content: string, contentType: ContentType, insertedAt: any, updatedAt: any, isDeleted: boolean, user: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } } | null } | null };

export type DeleteCommentV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCommentV2Mutation = { __typename?: 'RootMutationType', deleteComment?: { __typename?: 'DeleteResponse', success: boolean, id?: string | null, errors?: Array<string | null> | null } | null };

export type CreateTaskV2MutationVariables = Exact<{
  input: CreateTaskInput;
}>;


export type CreateTaskV2Mutation = { __typename?: 'RootMutationType', createTask?: { __typename?: 'TaskResponse', success: boolean, errors?: Array<string | null> | null, task?: { __typename?: 'CaseTask', id: string, taskNumber?: number | null, name: string, description?: string | null, taskType: TaskType, triggerMode?: TriggerMode | null, commentOutput: boolean, status: TaskStatus, startedAt?: any | null, completedAt?: any | null, errorMessage?: string | null, sortOrder: number, insertedAt: any, updatedAt: any, config?: any | null, result?: any | null, executable: boolean, completable: boolean, retriable: boolean, assignee?: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } | null } | null } | null };

export type CreateWorkflowTaskV2MutationVariables = Exact<{
  input: CreateWorkflowTaskInput;
}>;


export type CreateWorkflowTaskV2Mutation = { __typename?: 'RootMutationType', createWorkflowTask?: { __typename?: 'TaskResponse', success: boolean, errors?: Array<string | null> | null, task?: { __typename?: 'CaseTask', id: string, taskNumber?: number | null, name: string, description?: string | null, taskType: TaskType, triggerMode?: TriggerMode | null, commentOutput: boolean, status: TaskStatus, startedAt?: any | null, completedAt?: any | null, errorMessage?: string | null, sortOrder: number, insertedAt: any, updatedAt: any, config?: any | null, result?: any | null, executable: boolean, completable: boolean, retriable: boolean, assignee?: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } | null } | null } | null };

export type CreateManualTaskV2MutationVariables = Exact<{
  input: CreateManualTaskInput;
}>;


export type CreateManualTaskV2Mutation = { __typename?: 'RootMutationType', createManualTask?: { __typename?: 'TaskResponse', success: boolean, errors?: Array<string | null> | null, task?: { __typename?: 'CaseTask', id: string, taskNumber?: number | null, name: string, description?: string | null, taskType: TaskType, triggerMode?: TriggerMode | null, commentOutput: boolean, status: TaskStatus, startedAt?: any | null, completedAt?: any | null, errorMessage?: string | null, sortOrder: number, insertedAt: any, updatedAt: any, config?: any | null, result?: any | null, executable: boolean, completable: boolean, retriable: boolean, assignee?: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } | null } | null } | null };

export type UpdateTaskV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateTaskInput;
}>;


export type UpdateTaskV2Mutation = { __typename?: 'RootMutationType', updateTask?: { __typename?: 'TaskResponse', success: boolean, errors?: Array<string | null> | null, task?: { __typename?: 'CaseTask', id: string, taskNumber?: number | null, name: string, description?: string | null, taskType: TaskType, triggerMode?: TriggerMode | null, commentOutput: boolean, status: TaskStatus, startedAt?: any | null, completedAt?: any | null, errorMessage?: string | null, sortOrder: number, insertedAt: any, updatedAt: any, config?: any | null, result?: any | null, executable: boolean, completable: boolean, retriable: boolean, assignee?: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } | null } | null } | null };

export type DeleteTaskV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTaskV2Mutation = { __typename?: 'RootMutationType', deleteTask?: { __typename?: 'DeleteResponse', success: boolean, id?: string | null, errors?: Array<string | null> | null } | null };

export type AssignTaskV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
  assigneeId: Scalars['ID']['input'];
}>;


export type AssignTaskV2Mutation = { __typename?: 'RootMutationType', assignTask?: { __typename?: 'TaskResponse', success: boolean, errors?: Array<string | null> | null, task?: { __typename?: 'CaseTask', id: string, taskNumber?: number | null, name: string, assignee?: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } | null } | null } | null };

export type CancelTaskV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CancelTaskV2Mutation = { __typename?: 'RootMutationType', cancelTask?: { __typename?: 'TaskResponse', success: boolean, errors?: Array<string | null> | null, task?: { __typename?: 'CaseTask', id: string, status: TaskStatus } | null } | null };

export type ExecuteTaskV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ExecuteTaskV2Mutation = { __typename?: 'RootMutationType', executeTask?: { __typename?: 'TaskExecutionResponse', success: boolean, executionId?: string | null, errors?: Array<string | null> | null, task?: { __typename?: 'CaseTask', id: string, taskNumber?: number | null, name: string, taskType: TaskType, triggerMode?: TriggerMode | null, status: TaskStatus, startedAt?: any | null, completedAt?: any | null, errorMessage?: string | null, config?: any | null, result?: any | null, executable: boolean, completable: boolean, retriable: boolean } | null } | null };

export type RetryTaskV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RetryTaskV2Mutation = { __typename?: 'RootMutationType', retryTask?: { __typename?: 'TaskExecutionResponse', success: boolean, executionId?: string | null, errors?: Array<string | null> | null, task?: { __typename?: 'CaseTask', id: string, taskNumber?: number | null, name: string, taskType: TaskType, triggerMode?: TriggerMode | null, status: TaskStatus, startedAt?: any | null, completedAt?: any | null, errorMessage?: string | null, config?: any | null, result?: any | null, executable: boolean, completable: boolean, retriable: boolean } | null } | null };

export type CompleteManualTaskV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: CompleteManualTaskInput;
}>;


export type CompleteManualTaskV2Mutation = { __typename?: 'RootMutationType', completeManualTask?: { __typename?: 'TaskResponse', success: boolean, errors?: Array<string | null> | null, task?: { __typename?: 'CaseTask', id: string, taskNumber?: number | null, name: string, taskType: TaskType, triggerMode?: TriggerMode | null, status: TaskStatus, startedAt?: any | null, completedAt?: any | null, result?: any | null, completable: boolean } | null } | null };

export type UploadAttachmentV2MutationVariables = Exact<{
  input: UploadAttachmentInput;
}>;


export type UploadAttachmentV2Mutation = { __typename?: 'RootMutationType', uploadAttachment?: { __typename?: 'AttachmentResponse', success: boolean, errors?: Array<string | null> | null, attachment?: { __typename?: 'Attachment', id: string, filename: string, contentType: string, sizeBytes: number, humanSize: string, insertedAt: any, updatedAt: any, downloadUrl?: string | null, uploadedBy?: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } | null } | null } | null };

export type DeleteAttachmentV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAttachmentV2Mutation = { __typename?: 'RootMutationType', deleteAttachment?: { __typename?: 'DeleteResponse', success: boolean, errors?: Array<string | null> | null } | null };

export type SetCaseFieldValueV2MutationVariables = Exact<{
  input: SetFieldValueInput;
}>;


export type SetCaseFieldValueV2Mutation = { __typename?: 'RootMutationType', setCaseFieldValue?: { __typename?: 'CaseFieldResponse', success: boolean, errors?: Array<string | null> | null } | null };

export type LinkCasesV2MutationVariables = Exact<{
  input: LinkCasesInput;
}>;


export type LinkCasesV2Mutation = { __typename?: 'RootMutationType', linkCases?: { __typename?: 'CaseLinkResponse', success: boolean, errors?: Array<string | null> | null, caseLinks?: Array<{ __typename?: 'CaseLink', id: string, linkedCaseId: string, insertedAt: any, linkedCase?: { __typename?: 'Case', id: string, caseNumber: number, displayKey: string, title: string, status: string, priority: string } | null } | null> | null } | null };

export type UnlinkCasesV2MutationVariables = Exact<{
  input: UnlinkCasesInput;
}>;


export type UnlinkCasesV2Mutation = { __typename?: 'RootMutationType', unlinkCases?: { __typename?: 'CaseLinkResponse', success: boolean, errors?: Array<string | null> | null } | null };

export type LinkAlertsToCaseV2MutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  alertIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type LinkAlertsToCaseV2Mutation = { __typename?: 'RootMutationType', linkAlertsToCase?: { __typename?: 'LinkAlertsResult', success: boolean, linkedCount: number, errors?: Array<string | null> | null, caseId?: string | null, linkedAlertIds?: Array<string | null> | null } | null };

export type UnlinkAlertsFromCaseV2MutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  alertIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UnlinkAlertsFromCaseV2Mutation = { __typename?: 'RootMutationType', unlinkAlertsFromCase?: { __typename?: 'UnlinkAlertsResult', success: boolean, unlinkedCount: number, errors?: Array<string | null> | null, caseId?: string | null, remainingAlertIds?: Array<string | null> | null } | null };

export type CreateProjectV2MutationVariables = Exact<{
  input: CreateCaseProjectInput;
}>;


export type CreateProjectV2Mutation = { __typename?: 'RootMutationType', createProject?: { __typename?: 'CaseProjectResponse', success: boolean, errors?: Array<string | null> | null, caseProject?: { __typename?: 'CaseProject', id: string, name: string, slug: string, description?: string | null, insertedAt: any, updatedAt: any } | null } | null };

export type UpdateProjectV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateCaseProjectInput;
}>;


export type UpdateProjectV2Mutation = { __typename?: 'RootMutationType', updateProject?: { __typename?: 'CaseProjectResponse', success: boolean, errors?: Array<string | null> | null, caseProject?: { __typename?: 'CaseProject', id: string, name: string, slug: string, description?: string | null, insertedAt: any, updatedAt: any } | null } | null };

export type DeleteProjectV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProjectV2Mutation = { __typename?: 'RootMutationType', deleteProject?: { __typename?: 'DeleteResponse', success: boolean, id?: string | null, errors?: Array<string | null> | null } | null };

export type ForceSyncV2MutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ForceSyncV2Mutation = { __typename?: 'RootMutationType', forceSync?: { __typename?: 'ForceSyncResponse', success: boolean, projectId?: string | null, errors?: Array<string | null> | null } | null };

export type UpsertSyncConfigV2MutationVariables = Exact<{
  input: UpsertSyncConfigInput;
}>;


export type UpsertSyncConfigV2Mutation = { __typename?: 'RootMutationType', upsertSyncConfig?: { __typename?: 'SyncConfigResponse', success: boolean, errors?: Array<string | null> | null, syncConfig?: { __typename?: 'SyncConfig', defaultStrategy: string, fieldStrategies?: any | null } | null } | null };

export type DispatchCaseEventV2MutationVariables = Exact<{
  input: DispatchCaseEventInput;
}>;


export type DispatchCaseEventV2Mutation = { __typename?: 'RootMutationType', dispatchCaseEvent: { __typename?: 'Case', id: string, status: string, updatedAt: any } };

export type SearchCasesV2QueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<CaseSortField>;
  sortOrder?: InputMaybe<SortOrder>;
  filter?: InputMaybe<CaseFilterInput>;
}>;


export type SearchCasesV2Query = { __typename?: 'RootQueryType', searchCases: { __typename?: 'CasePage', total: number, hasMore: boolean, cases: Array<{ __typename?: 'Case', id: string, caseNumber: number, displayKey: string, title: string, status: string, priority: string, insertedAt: any, updatedAt: any, assignee?: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } | null }> } };

export type ListPrioritiesV2QueryVariables = Exact<{ [key: string]: never; }>;


export type ListPrioritiesV2Query = { __typename?: 'RootQueryType', priorities: Array<{ __typename?: 'Priority', id: string, name: string, icon: string, color?: string | null, priorityValue: number, isDefault: boolean, insertedAt: any, updatedAt: any }> };

export type GetPriorityV2QueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPriorityV2Query = { __typename?: 'RootQueryType', priority?: { __typename?: 'Priority', id: string, name: string, icon: string, color?: string | null, priorityValue: number, isDefault: boolean, insertedAt: any, updatedAt: any } | null };

export type ListStatusWorkflowsV2QueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ListStatusWorkflowsV2Query = { __typename?: 'RootQueryType', statusWorkflows: Array<{ __typename?: 'StatusWorkflow', id: string, name: string, description?: string | null, isSystem: boolean, hasDraft: boolean, transitions?: Array<{ __typename?: 'StatusTransition', from: string, to: Array<string>, statusType: StatusType } | null> | null }> };

export type GetStatusWorkflowForCaseTypeV2QueryVariables = Exact<{
  caseTypeId: Scalars['ID']['input'];
}>;


export type GetStatusWorkflowForCaseTypeV2Query = { __typename?: 'RootQueryType', statusWorkflowForCaseType?: { __typename?: 'StatusWorkflow', id: string, name: string, description?: string | null, isSystem: boolean, hasDraft: boolean, transitions?: Array<{ __typename?: 'StatusTransition', from: string, to: Array<string>, statusType: StatusType } | null> | null } | null };

export type AdvancedSearchV2QueryVariables = Exact<{
  query: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<CaseSortField>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type AdvancedSearchV2Query = { __typename?: 'RootQueryType', advancedSearch: { __typename?: 'CasePage', total: number, hasMore: boolean, cases: Array<{ __typename?: 'Case', id: string, caseNumber: number, displayKey: string, title: string, status: string, priority: string, insertedAt: any, updatedAt: any, assignee?: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } | null }> } };

export type ValidateSearchQueryV2QueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type ValidateSearchQueryV2Query = { __typename?: 'RootQueryType', validateSearch: { __typename?: 'SearchValidationResult', valid: boolean, error?: string | null, parsedQuery?: string | null } };

export type ListSavedSearchesV2QueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListSavedSearchesV2Query = { __typename?: 'RootQueryType', savedSearches: Array<{ __typename?: 'SavedSearch', id: string, name: string, queryType: SearchQueryType, query: string, description?: string | null, isShared: boolean, ownerId: string, insertedAt: any, updatedAt: any }> };

export type GetCaseByNumberV2QueryVariables = Exact<{
  caseNumber: Scalars['Int']['input'];
}>;


export type GetCaseByNumberV2Query = { __typename?: 'RootQueryType', caseByNumber?: { __typename?: 'Case', id: string, caseNumber: number, displayKey: string, title: string, description?: string | null, status: string, priority: string, externalId?: string | null, externalUrl?: string | null, syncState?: string | null, lastSyncedAt?: any | null, insertedAt: any, updatedAt: any, project?: { __typename?: 'CaseProject', id: string, name: string, prefix?: string | null } | null, assignee?: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } | null, reporter?: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } | null, fieldValues?: Array<{ __typename?: 'CaseFieldValue', id: string, value?: string | null, parsedValue?: any | null, caseField: { __typename?: 'CaseField', id: string, fieldName: string, displayName: string, fieldType: CaseFieldType, description?: string | null, isObservable: boolean, isSystem: boolean, isHidden: boolean } } | null> | null } | null };

export type GetCaseByIdV2QueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCaseByIdV2Query = { __typename?: 'RootQueryType', case?: { __typename?: 'Case', id: string, caseNumber: number, displayKey: string, title: string, description?: string | null, status: string, priority: string, externalId?: string | null, externalUrl?: string | null, syncState?: string | null, lastSyncedAt?: any | null, insertedAt: any, updatedAt: any, project?: { __typename?: 'CaseProject', id: string, name: string, prefix?: string | null } | null, assignee?: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } | null, reporter?: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } | null, fieldValues?: Array<{ __typename?: 'CaseFieldValue', id: string, value?: string | null, parsedValue?: any | null, caseField: { __typename?: 'CaseField', id: string, fieldName: string, displayName: string, fieldType: CaseFieldType, description?: string | null, isObservable: boolean, isSystem: boolean, isHidden: boolean } } | null> | null } | null };

export type ListCaseFieldsV2QueryVariables = Exact<{
  fieldType?: InputMaybe<CaseFieldType>;
  isObservable?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ListCaseFieldsV2Query = { __typename?: 'RootQueryType', caseFields: Array<{ __typename?: 'CaseField', id: string, fieldName: string, displayName: string, fieldType: CaseFieldType, description?: string | null, descriptor?: string | null, isDeprecated: boolean, isObservable: boolean, isAll: boolean, isSystem: boolean, isHidden: boolean, isComputed: boolean, regex?: string | null, exclusionRegexes?: string | null, validationRegex?: string | null, insertedAt: any, updatedAt: any }> };

export type GetCaseFieldV2QueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCaseFieldV2Query = { __typename?: 'RootQueryType', caseField?: { __typename?: 'CaseField', id: string, fieldName: string, displayName: string, fieldType: CaseFieldType, description?: string | null, descriptor?: string | null, isDeprecated: boolean, isObservable: boolean, isAll: boolean, isSystem: boolean, isHidden: boolean, isComputed: boolean, regex?: string | null, exclusionRegexes?: string | null, validationRegex?: string | null, insertedAt: any, updatedAt: any } | null };

export type ListCommentsV2QueryVariables = Exact<{
  caseId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ListCommentsV2Query = { __typename?: 'RootQueryType', comments: Array<{ __typename?: 'Comment', id: string, content: string, contentType: ContentType, insertedAt: any, updatedAt: any, isDeleted: boolean, user: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } }> };

export type GetCommentV2QueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCommentV2Query = { __typename?: 'RootQueryType', comment?: { __typename?: 'Comment', id: string, content: string, contentType: ContentType, insertedAt: any, updatedAt: any, isDeleted: boolean, user: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } } | null };

export type ListTasksV2QueryVariables = Exact<{
  caseId: Scalars['ID']['input'];
  status?: InputMaybe<TaskStatus>;
  taskType?: InputMaybe<TaskType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListTasksV2Query = { __typename?: 'RootQueryType', tasks: Array<{ __typename?: 'CaseTask', id: string, taskNumber?: number | null, name: string, description?: string | null, taskType: TaskType, triggerMode?: TriggerMode | null, commentOutput: boolean, status: TaskStatus, startedAt?: any | null, completedAt?: any | null, errorMessage?: string | null, sortOrder: number, insertedAt: any, updatedAt: any, config?: any | null, result?: any | null, executable: boolean, completable: boolean, retriable: boolean, assignee?: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } | null }> };

export type GetTaskV2QueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTaskV2Query = { __typename?: 'RootQueryType', task?: { __typename?: 'CaseTask', id: string, taskNumber?: number | null, name: string, description?: string | null, taskType: TaskType, triggerMode?: TriggerMode | null, commentOutput: boolean, status: TaskStatus, startedAt?: any | null, completedAt?: any | null, errorMessage?: string | null, sortOrder: number, insertedAt: any, updatedAt: any, config?: any | null, result?: any | null, executable: boolean, completable: boolean, retriable: boolean, assignee?: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } | null } | null };

export type ListAttachmentsV2QueryVariables = Exact<{
  caseId: Scalars['ID']['input'];
}>;


export type ListAttachmentsV2Query = { __typename?: 'RootQueryType', attachments: { __typename?: 'AttachmentsResponse', success: boolean, totalSizeBytes?: number | null, errors?: Array<string | null> | null, attachments?: Array<{ __typename?: 'Attachment', id: string, filename: string, contentType: string, sizeBytes: number, humanSize: string, insertedAt: any, updatedAt: any, downloadUrl?: string | null, uploadedBy?: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } | null } | null> | null } };

export type GetCaseHistoryV2QueryVariables = Exact<{
  caseId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCaseHistoryV2Query = { __typename?: 'RootQueryType', caseHistory: { __typename?: 'HistoryPage', total: number, hasMore: boolean, entries: Array<{ __typename?: 'HistoryEntry', id: string, fieldName: string, modificationType: ModificationType, beforeValue?: string | null, afterValue?: string | null, metadata?: any | null, insertedAt: any, user: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } }> } };

export type LinkedCasesV2QueryVariables = Exact<{
  caseId: Scalars['ID']['input'];
  linkType?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LinkedCasesV2Query = { __typename?: 'RootQueryType', linkedCases: Array<{ __typename?: 'CaseLink', id: string, linkedCaseId: string, linkType: string, sharedObservables?: Array<string> | null, similarityScore?: number | null, insertedAt: any, linkedCase?: { __typename?: 'Case', id: string, caseNumber: number, displayKey: string, title: string, status: string, priority: string, insertedAt: any, updatedAt: any, project?: { __typename?: 'CaseProject', id: string, name: string, prefix?: string | null } | null, assignee?: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } | null, reporter?: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } | null } | null, createdBy?: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } | null }> };

export type FindSimilarCasesV2QueryVariables = Exact<{
  caseId: Scalars['ID']['input'];
  excludeLinked?: InputMaybe<Scalars['Boolean']['input']>;
  minimumMatches?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FindSimilarCasesV2Query = { __typename?: 'RootQueryType', findSimilarCases: { __typename?: 'CaseSimilarityResponse', success: boolean, errors?: Array<string | null> | null, result?: { __typename?: 'CaseSimilarityResult', totalCount: number, similarCases: Array<{ __typename?: 'SimilarCase', totalObservables: number, matchedCount: number, similarityScore: number, case: { __typename?: 'Case', id: string, caseNumber: number, displayKey: string, title: string, description?: string | null, status: string, priority: string, insertedAt: any, updatedAt: any, project?: { __typename?: 'CaseProject', id: string, name: string, prefix?: string | null } | null, assignee?: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } | null, reporter?: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } | null }, matchedFields: Array<{ __typename?: 'MatchedField', fieldName: string, displayName: string, fieldType: string, matchedValues: Array<string> }> }>, observables: Array<{ __typename?: 'ObservableValue', fieldId: string, fieldName: string, displayName: string, fieldType: string, values: Array<string> }> } | null } };

export type GetCaseTypeFieldsV2QueryVariables = Exact<{
  caseTypeId: Scalars['ID']['input'];
}>;


export type GetCaseTypeFieldsV2Query = { __typename?: 'RootQueryType', caseTypeFieldMappings: Array<{ __typename?: 'CaseTypeField', id: string, createRequired: boolean, closeRequired: boolean, sortOrder: number, caseTypeId: string, caseFieldId: string, insertedAt: any, updatedAt: any, caseField?: { __typename?: 'CaseField', id: string, fieldName: string, displayName: string, fieldType: CaseFieldType, description?: string | null, descriptor?: string | null, isObservable: boolean, isSystem: boolean, isHidden: boolean, isComputed: boolean } | null }> };

export type GetCaseTypeAllFieldsV2QueryVariables = Exact<{
  caseTypeId: Scalars['ID']['input'];
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCaseTypeAllFieldsV2Query = { __typename?: 'RootQueryType', caseTypeAllFields: Array<{ __typename?: 'CaseField', id: string, fieldName: string, displayName: string, fieldType: CaseFieldType, description?: string | null, descriptor?: string | null, isObservable: boolean, isSystem: boolean, isHidden: boolean, isComputed: boolean }> };

export type TemplateVariablesV2QueryVariables = Exact<{
  caseTypeId: Scalars['ID']['input'];
}>;


export type TemplateVariablesV2Query = { __typename?: 'RootQueryType', templateVariables: Array<{ __typename?: 'TemplateVariable', fieldName: string, displayName: string, fieldType: string, category: string }> };

export type AllTemplateVariablesV2QueryVariables = Exact<{ [key: string]: never; }>;


export type AllTemplateVariablesV2Query = { __typename?: 'RootQueryType', allTemplateVariables: Array<{ __typename?: 'TemplateVariable', fieldName: string, displayName: string, fieldType: string, category: string }> };

export type ListCaseProjectsV2QueryVariables = Exact<{ [key: string]: never; }>;


export type ListCaseProjectsV2Query = { __typename?: 'RootQueryType', caseProjects: Array<{ __typename?: 'CaseProject', id: string, name: string, slug: string, description?: string | null, projectType: CaseProjectType, icon?: string | null, color?: string | null, insertedAt: any, updatedAt: any }> };

export type LinkedAlertsV2QueryVariables = Exact<{
  caseId: Scalars['ID']['input'];
}>;


export type LinkedAlertsV2Query = { __typename?: 'RootQueryType', case?: { __typename?: 'Case', id: string, linkedAlerts?: Array<{ __typename?: 'Alert', id: string, externalId?: string | null, name: string, description?: string | null, severity?: string | null, siemSource?: string | null, query?: string | null, extraData?: any | null, tags?: any | null, insertedAt?: string | null, updatedAt?: string | null } | null> | null } | null };

export type LinkedAlertsV2PaginatedQueryVariables = Exact<{
  caseId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LinkedAlertsV2PaginatedQuery = { __typename?: 'RootQueryType', case?: { __typename?: 'Case', id: string, linkedAlertsPage?: { __typename?: 'AlertPage', total: number, hasMore: boolean, alerts: Array<{ __typename?: 'Alert', id: string, externalId?: string | null, name: string, description?: string | null, severity?: string | null, siemSource?: string | null, query?: string | null, extraData?: any | null, tags?: any | null, insertedAt?: string | null, updatedAt?: string | null }> } | null } | null };

export type SyncDashboardV2QueryVariables = Exact<{ [key: string]: never; }>;


export type SyncDashboardV2Query = { __typename?: 'RootQueryType', syncSources: Array<{ __typename?: 'SyncSource', projectId: string, projectName: string, projectSlug: string, ingestWorkflowId: string, outboundWorkflowId?: string | null, syncInterval: string, conflictStrategy: string, lastSyncedAt?: any | null }> };

export type SyncOutboxCountV2QueryVariables = Exact<{
  state?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SyncOutboxCountV2Query = { __typename?: 'RootQueryType', syncOutbox: Array<{ __typename?: 'OutboxEvent', id: string }> };

export type SyncHealthV2QueryVariables = Exact<{ [key: string]: never; }>;


export type SyncHealthV2Query = { __typename?: 'RootQueryType', syncHealthSummary: { __typename?: 'SyncHealth', totalProjects: number, healthy: number, degraded: number, error: number, lastSync?: string | null, outboxPending: number } };

export type CorrelationStatsV2QueryVariables = Exact<{ [key: string]: never; }>;


export type CorrelationStatsV2Query = { __typename?: 'RootQueryType', correlationStats: { __typename?: 'CorrelationStats', totalCorrelations: number, avgObservablesPerCase: number } };

export type SyncConfigV2QueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type SyncConfigV2Query = { __typename?: 'RootQueryType', caseProject?: { __typename?: 'CaseProject', id: string, name: string, syncInterval: string, conflictStrategy: string, ingestWorkflowId?: string | null, outboundWorkflowId?: string | null } | null };

export type AvailableCaseEventsV2QueryVariables = Exact<{
  caseId: Scalars['ID']['input'];
}>;


export type AvailableCaseEventsV2Query = { __typename?: 'RootQueryType', availableCaseEvents: Array<{ __typename?: 'CaseEventOption', event: string, to: string, enabled: boolean, reason?: string | null }> };

export type CaseStatusHistoryV2QueryVariables = Exact<{
  caseId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CaseStatusHistoryV2Query = { __typename?: 'RootQueryType', caseStatusHistory: Array<{ __typename?: 'CaseTransition', id: string, fromStatus?: string | null, toStatus: string, event: string, actorType: string, actorId?: string | null, workflowRunId?: string | null, payload?: any | null, insertedAt: any }> };

export type CaseEventsV2SubscriptionVariables = Exact<{
  caseId: Scalars['ID']['input'];
}>;


export type CaseEventsV2Subscription = { __typename?: 'RootSubscriptionType', caseEvents?: { __typename?: 'CaseEvent', eventType: CaseEventType, caseId: string, timestamp: any, changes?: any | null, actor?: { __typename?: 'CaseEventActor', userId?: string | null, displayName?: string | null } | null, caseSummary?: { __typename?: 'CaseEventCaseSummary', id: string, caseNumber?: number | null, title?: string | null, status?: string | null, priority?: string | null, assigneeId?: string | null, updatedAt?: any | null } | null, comment?: { __typename?: 'CaseEventComment', id: string, content?: string | null, contentType?: string | null, userId?: string | null, insertedAt?: any | null, updatedAt?: any | null } | null, task?: { __typename?: 'CaseEventTask', id: string, taskNumber?: number | null, name?: string | null, taskType?: string | null, triggerMode?: string | null, status?: string | null, assigneeId?: string | null, sortOrder?: number | null, startedAt?: any | null, completedAt?: any | null } | null, fieldUpdate?: { __typename?: 'CaseEventFieldUpdate', fieldName: string, fieldId?: string | null, oldValue?: any | null, newValue?: any | null } | null, attachment?: { __typename?: 'CaseEventAttachment', id: string, filename?: string | null, contentType?: string | null, sizeBytes?: number | null, uploadedById?: string | null } | null } | null };

export type GetTaskTemplateV2QueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTaskTemplateV2Query = { __typename?: 'RootQueryType', taskTemplate?: { __typename?: 'TaskTemplate', id: string, name: string, description?: string | null, taskType: TaskType, triggerMode?: TriggerMode | null, commentOutput: boolean, sortOrder: number, insertedAt: any, updatedAt: any, config?: any | null, assignee?: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } | null, project?: { __typename?: 'CaseProject', id: string, name: string } | null } | null };

export type ListTaskTemplatesV2QueryVariables = Exact<{
  caseTypeId: Scalars['ID']['input'];
}>;


export type ListTaskTemplatesV2Query = { __typename?: 'RootQueryType', taskTemplates: Array<{ __typename?: 'TaskTemplate', id: string, name: string, description?: string | null, taskType: TaskType, triggerMode?: TriggerMode | null, commentOutput: boolean, sortOrder: number, insertedAt: any, updatedAt: any, config?: any | null, assignee?: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } | null }> };

export type CreateTaskTemplateV2MutationVariables = Exact<{
  caseTypeId: Scalars['ID']['input'];
  input: CreateTaskTemplateInput;
}>;


export type CreateTaskTemplateV2Mutation = { __typename?: 'RootMutationType', createTaskTemplate?: { __typename?: 'TaskTemplateResponse', success: boolean, errors?: Array<string | null> | null, taskTemplate?: { __typename?: 'TaskTemplate', id: string, name: string, description?: string | null, taskType: TaskType, triggerMode?: TriggerMode | null, commentOutput: boolean, sortOrder: number, insertedAt: any, updatedAt: any, config?: any | null, assignee?: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } | null } | null } | null };

export type UpdateTaskTemplateV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateTaskTemplateInput;
}>;


export type UpdateTaskTemplateV2Mutation = { __typename?: 'RootMutationType', updateTaskTemplate?: { __typename?: 'TaskTemplateResponse', success: boolean, errors?: Array<string | null> | null, taskTemplate?: { __typename?: 'TaskTemplate', id: string, name: string, description?: string | null, taskType: TaskType, triggerMode?: TriggerMode | null, commentOutput: boolean, sortOrder: number, insertedAt: any, updatedAt: any, config?: any | null, assignee?: { __typename?: 'User', id: string, email?: string | null, displayName?: string | null } | null } | null } | null };

export type DeleteTaskTemplateV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTaskTemplateV2Mutation = { __typename?: 'RootMutationType', deleteTaskTemplate?: { __typename?: 'TaskTemplateResponse', success: boolean, errors?: Array<string | null> | null, taskTemplate?: { __typename?: 'TaskTemplate', id: string } | null } | null };

export type ReorderTaskTemplatesV2MutationVariables = Exact<{
  caseTypeId: Scalars['ID']['input'];
  templateIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ReorderTaskTemplatesV2Mutation = { __typename?: 'RootMutationType', reorderTaskTemplates: Array<{ __typename?: 'TaskTemplate', id: string, name: string, sortOrder: number, taskType: TaskType, triggerMode?: TriggerMode | null, commentOutput: boolean, config?: any | null }> };


export const CreateCaseV2Document = gql`
    mutation CreateCaseV2($title: String!, $projectId: ID!, $description: String, $priority: String, $assigneeId: ID) @endpoint(name: asoc_v2) {
  createCase(
    input: {title: $title, projectId: $projectId, description: $description, priority: $priority, assigneeId: $assigneeId}
  ) {
    success
    errors
    case {
      id
      caseNumber
      displayKey
      title
      description
      status
      priority
      assignee {
        id
        email
        displayName
      }
      project {
        id
        name
        description
      }
      insertedAt
      updatedAt
    }
  }
}
    `;
export type CreateCaseV2MutationFn = Apollo.MutationFunction<CreateCaseV2Mutation, CreateCaseV2MutationVariables>;

/**
 * __useCreateCaseV2Mutation__
 *
 * To run a mutation, you first call `useCreateCaseV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaseV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaseV2Mutation, { data, loading, error }] = useCreateCaseV2Mutation({
 *   variables: {
 *      title: // value for 'title'
 *      projectId: // value for 'projectId'
 *      description: // value for 'description'
 *      priority: // value for 'priority'
 *      assigneeId: // value for 'assigneeId'
 *   },
 * });
 */
export function useCreateCaseV2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateCaseV2Mutation, CreateCaseV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCaseV2Mutation, CreateCaseV2MutationVariables>(CreateCaseV2Document, options);
      }
export type CreateCaseV2MutationHookResult = ReturnType<typeof useCreateCaseV2Mutation>;
export type CreateCaseV2MutationResult = Apollo.MutationResult<CreateCaseV2Mutation>;
export type CreateCaseV2MutationOptions = Apollo.BaseMutationOptions<CreateCaseV2Mutation, CreateCaseV2MutationVariables>;
export const UpdateCaseV2Document = gql`
    mutation UpdateCaseV2($id: ID!, $title: String, $description: String, $status: String, $priority: String, $assigneeId: ID) @endpoint(name: asoc_v2) {
  updateCase(
    id: $id
    input: {title: $title, description: $description, status: $status, priority: $priority, assigneeId: $assigneeId}
  ) {
    success
    errors
    case {
      id
      caseNumber
      displayKey
      title
      description
      status
      priority
      assignee {
        id
        email
        displayName
      }
      insertedAt
      updatedAt
    }
  }
}
    `;
export type UpdateCaseV2MutationFn = Apollo.MutationFunction<UpdateCaseV2Mutation, UpdateCaseV2MutationVariables>;

/**
 * __useUpdateCaseV2Mutation__
 *
 * To run a mutation, you first call `useUpdateCaseV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseV2Mutation, { data, loading, error }] = useUpdateCaseV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      status: // value for 'status'
 *      priority: // value for 'priority'
 *      assigneeId: // value for 'assigneeId'
 *   },
 * });
 */
export function useUpdateCaseV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaseV2Mutation, UpdateCaseV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaseV2Mutation, UpdateCaseV2MutationVariables>(UpdateCaseV2Document, options);
      }
export type UpdateCaseV2MutationHookResult = ReturnType<typeof useUpdateCaseV2Mutation>;
export type UpdateCaseV2MutationResult = Apollo.MutationResult<UpdateCaseV2Mutation>;
export type UpdateCaseV2MutationOptions = Apollo.BaseMutationOptions<UpdateCaseV2Mutation, UpdateCaseV2MutationVariables>;
export const DeleteCaseV2Document = gql`
    mutation DeleteCaseV2($id: ID!) @endpoint(name: asoc_v2) {
  deleteCase(id: $id) {
    success
    id
    errors
  }
}
    `;
export type DeleteCaseV2MutationFn = Apollo.MutationFunction<DeleteCaseV2Mutation, DeleteCaseV2MutationVariables>;

/**
 * __useDeleteCaseV2Mutation__
 *
 * To run a mutation, you first call `useDeleteCaseV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCaseV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCaseV2Mutation, { data, loading, error }] = useDeleteCaseV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCaseV2Mutation(baseOptions?: Apollo.MutationHookOptions<DeleteCaseV2Mutation, DeleteCaseV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCaseV2Mutation, DeleteCaseV2MutationVariables>(DeleteCaseV2Document, options);
      }
export type DeleteCaseV2MutationHookResult = ReturnType<typeof useDeleteCaseV2Mutation>;
export type DeleteCaseV2MutationResult = Apollo.MutationResult<DeleteCaseV2Mutation>;
export type DeleteCaseV2MutationOptions = Apollo.BaseMutationOptions<DeleteCaseV2Mutation, DeleteCaseV2MutationVariables>;
export const AddFieldToCaseTypeV2Document = gql`
    mutation AddFieldToCaseTypeV2($caseTypeId: ID!, $caseFieldId: ID!, $attrs: CaseTypeFieldAttrsInput) @endpoint(name: asoc_v2) {
  addFieldToCaseType(
    caseTypeId: $caseTypeId
    caseFieldId: $caseFieldId
    attrs: $attrs
  ) {
    success
    caseTypeField {
      id
      createRequired
      closeRequired
      sortOrder
      caseTypeId
      caseFieldId
      caseField {
        id
        fieldName
        displayName
        fieldType
      }
      insertedAt
      updatedAt
    }
    errors
  }
}
    `;
export type AddFieldToCaseTypeV2MutationFn = Apollo.MutationFunction<AddFieldToCaseTypeV2Mutation, AddFieldToCaseTypeV2MutationVariables>;

/**
 * __useAddFieldToCaseTypeV2Mutation__
 *
 * To run a mutation, you first call `useAddFieldToCaseTypeV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFieldToCaseTypeV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFieldToCaseTypeV2Mutation, { data, loading, error }] = useAddFieldToCaseTypeV2Mutation({
 *   variables: {
 *      caseTypeId: // value for 'caseTypeId'
 *      caseFieldId: // value for 'caseFieldId'
 *      attrs: // value for 'attrs'
 *   },
 * });
 */
export function useAddFieldToCaseTypeV2Mutation(baseOptions?: Apollo.MutationHookOptions<AddFieldToCaseTypeV2Mutation, AddFieldToCaseTypeV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFieldToCaseTypeV2Mutation, AddFieldToCaseTypeV2MutationVariables>(AddFieldToCaseTypeV2Document, options);
      }
export type AddFieldToCaseTypeV2MutationHookResult = ReturnType<typeof useAddFieldToCaseTypeV2Mutation>;
export type AddFieldToCaseTypeV2MutationResult = Apollo.MutationResult<AddFieldToCaseTypeV2Mutation>;
export type AddFieldToCaseTypeV2MutationOptions = Apollo.BaseMutationOptions<AddFieldToCaseTypeV2Mutation, AddFieldToCaseTypeV2MutationVariables>;
export const BatchAddFieldsToCaseTypeV2Document = gql`
    mutation BatchAddFieldsToCaseTypeV2($caseTypeId: ID!, $fields: [BatchCaseTypeFieldInput!]!) @endpoint(name: asoc_v2) {
  batchAddFieldsToCaseType(caseTypeId: $caseTypeId, fields: $fields) {
    success
    caseTypeFields {
      id
      createRequired
      closeRequired
      sortOrder
      caseTypeId
      caseFieldId
      caseField {
        id
        fieldName
        displayName
        fieldType
      }
      insertedAt
      updatedAt
    }
    errors
  }
}
    `;
export type BatchAddFieldsToCaseTypeV2MutationFn = Apollo.MutationFunction<BatchAddFieldsToCaseTypeV2Mutation, BatchAddFieldsToCaseTypeV2MutationVariables>;

/**
 * __useBatchAddFieldsToCaseTypeV2Mutation__
 *
 * To run a mutation, you first call `useBatchAddFieldsToCaseTypeV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchAddFieldsToCaseTypeV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchAddFieldsToCaseTypeV2Mutation, { data, loading, error }] = useBatchAddFieldsToCaseTypeV2Mutation({
 *   variables: {
 *      caseTypeId: // value for 'caseTypeId'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useBatchAddFieldsToCaseTypeV2Mutation(baseOptions?: Apollo.MutationHookOptions<BatchAddFieldsToCaseTypeV2Mutation, BatchAddFieldsToCaseTypeV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchAddFieldsToCaseTypeV2Mutation, BatchAddFieldsToCaseTypeV2MutationVariables>(BatchAddFieldsToCaseTypeV2Document, options);
      }
export type BatchAddFieldsToCaseTypeV2MutationHookResult = ReturnType<typeof useBatchAddFieldsToCaseTypeV2Mutation>;
export type BatchAddFieldsToCaseTypeV2MutationResult = Apollo.MutationResult<BatchAddFieldsToCaseTypeV2Mutation>;
export type BatchAddFieldsToCaseTypeV2MutationOptions = Apollo.BaseMutationOptions<BatchAddFieldsToCaseTypeV2Mutation, BatchAddFieldsToCaseTypeV2MutationVariables>;
export const RemoveFieldFromCaseTypeV2Document = gql`
    mutation RemoveFieldFromCaseTypeV2($caseTypeId: ID!, $caseFieldId: ID!) @endpoint(name: asoc_v2) {
  removeFieldFromCaseType(caseTypeId: $caseTypeId, caseFieldId: $caseFieldId) {
    success
    errors
  }
}
    `;
export type RemoveFieldFromCaseTypeV2MutationFn = Apollo.MutationFunction<RemoveFieldFromCaseTypeV2Mutation, RemoveFieldFromCaseTypeV2MutationVariables>;

/**
 * __useRemoveFieldFromCaseTypeV2Mutation__
 *
 * To run a mutation, you first call `useRemoveFieldFromCaseTypeV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFieldFromCaseTypeV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFieldFromCaseTypeV2Mutation, { data, loading, error }] = useRemoveFieldFromCaseTypeV2Mutation({
 *   variables: {
 *      caseTypeId: // value for 'caseTypeId'
 *      caseFieldId: // value for 'caseFieldId'
 *   },
 * });
 */
export function useRemoveFieldFromCaseTypeV2Mutation(baseOptions?: Apollo.MutationHookOptions<RemoveFieldFromCaseTypeV2Mutation, RemoveFieldFromCaseTypeV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFieldFromCaseTypeV2Mutation, RemoveFieldFromCaseTypeV2MutationVariables>(RemoveFieldFromCaseTypeV2Document, options);
      }
export type RemoveFieldFromCaseTypeV2MutationHookResult = ReturnType<typeof useRemoveFieldFromCaseTypeV2Mutation>;
export type RemoveFieldFromCaseTypeV2MutationResult = Apollo.MutationResult<RemoveFieldFromCaseTypeV2Mutation>;
export type RemoveFieldFromCaseTypeV2MutationOptions = Apollo.BaseMutationOptions<RemoveFieldFromCaseTypeV2Mutation, RemoveFieldFromCaseTypeV2MutationVariables>;
export const UpdateCaseTypeFieldV2Document = gql`
    mutation UpdateCaseTypeFieldV2($id: ID!, $attrs: CaseTypeFieldAttrsInput!) @endpoint(name: asoc_v2) {
  updateCaseTypeField(id: $id, attrs: $attrs) {
    success
    caseTypeField {
      id
      createRequired
      closeRequired
      sortOrder
      caseTypeId
      caseFieldId
      insertedAt
      updatedAt
    }
    errors
  }
}
    `;
export type UpdateCaseTypeFieldV2MutationFn = Apollo.MutationFunction<UpdateCaseTypeFieldV2Mutation, UpdateCaseTypeFieldV2MutationVariables>;

/**
 * __useUpdateCaseTypeFieldV2Mutation__
 *
 * To run a mutation, you first call `useUpdateCaseTypeFieldV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseTypeFieldV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseTypeFieldV2Mutation, { data, loading, error }] = useUpdateCaseTypeFieldV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      attrs: // value for 'attrs'
 *   },
 * });
 */
export function useUpdateCaseTypeFieldV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaseTypeFieldV2Mutation, UpdateCaseTypeFieldV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaseTypeFieldV2Mutation, UpdateCaseTypeFieldV2MutationVariables>(UpdateCaseTypeFieldV2Document, options);
      }
export type UpdateCaseTypeFieldV2MutationHookResult = ReturnType<typeof useUpdateCaseTypeFieldV2Mutation>;
export type UpdateCaseTypeFieldV2MutationResult = Apollo.MutationResult<UpdateCaseTypeFieldV2Mutation>;
export type UpdateCaseTypeFieldV2MutationOptions = Apollo.BaseMutationOptions<UpdateCaseTypeFieldV2Mutation, UpdateCaseTypeFieldV2MutationVariables>;
export const ReorderCaseTypeFieldsV2Document = gql`
    mutation ReorderCaseTypeFieldsV2($caseTypeId: ID!, $fieldIds: [ID!]!) @endpoint(name: asoc_v2) {
  reorderCaseTypeFields(caseTypeId: $caseTypeId, fieldIds: $fieldIds) {
    id
    sortOrder
    caseFieldId
    createRequired
    closeRequired
    caseTypeId
    caseField {
      id
      displayName
      fieldType
      isSystem
    }
  }
}
    `;
export type ReorderCaseTypeFieldsV2MutationFn = Apollo.MutationFunction<ReorderCaseTypeFieldsV2Mutation, ReorderCaseTypeFieldsV2MutationVariables>;

/**
 * __useReorderCaseTypeFieldsV2Mutation__
 *
 * To run a mutation, you first call `useReorderCaseTypeFieldsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderCaseTypeFieldsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderCaseTypeFieldsV2Mutation, { data, loading, error }] = useReorderCaseTypeFieldsV2Mutation({
 *   variables: {
 *      caseTypeId: // value for 'caseTypeId'
 *      fieldIds: // value for 'fieldIds'
 *   },
 * });
 */
export function useReorderCaseTypeFieldsV2Mutation(baseOptions?: Apollo.MutationHookOptions<ReorderCaseTypeFieldsV2Mutation, ReorderCaseTypeFieldsV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderCaseTypeFieldsV2Mutation, ReorderCaseTypeFieldsV2MutationVariables>(ReorderCaseTypeFieldsV2Document, options);
      }
export type ReorderCaseTypeFieldsV2MutationHookResult = ReturnType<typeof useReorderCaseTypeFieldsV2Mutation>;
export type ReorderCaseTypeFieldsV2MutationResult = Apollo.MutationResult<ReorderCaseTypeFieldsV2Mutation>;
export type ReorderCaseTypeFieldsV2MutationOptions = Apollo.BaseMutationOptions<ReorderCaseTypeFieldsV2Mutation, ReorderCaseTypeFieldsV2MutationVariables>;
export const CreateCaseFieldV2Document = gql`
    mutation CreateCaseFieldV2($input: CreateCaseFieldInput!) @endpoint(name: asoc_v2) {
  createCaseField(input: $input) {
    success
    caseField {
      id
      fieldName
      displayName
      fieldType
      description
      descriptor
      isDeprecated
      isObservable
      isAll
      isSystem
      isHidden
      isComputed
      regex
      exclusionRegexes
      validationRegex
      insertedAt
      updatedAt
    }
    errors
  }
}
    `;
export type CreateCaseFieldV2MutationFn = Apollo.MutationFunction<CreateCaseFieldV2Mutation, CreateCaseFieldV2MutationVariables>;

/**
 * __useCreateCaseFieldV2Mutation__
 *
 * To run a mutation, you first call `useCreateCaseFieldV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaseFieldV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaseFieldV2Mutation, { data, loading, error }] = useCreateCaseFieldV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCaseFieldV2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateCaseFieldV2Mutation, CreateCaseFieldV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCaseFieldV2Mutation, CreateCaseFieldV2MutationVariables>(CreateCaseFieldV2Document, options);
      }
export type CreateCaseFieldV2MutationHookResult = ReturnType<typeof useCreateCaseFieldV2Mutation>;
export type CreateCaseFieldV2MutationResult = Apollo.MutationResult<CreateCaseFieldV2Mutation>;
export type CreateCaseFieldV2MutationOptions = Apollo.BaseMutationOptions<CreateCaseFieldV2Mutation, CreateCaseFieldV2MutationVariables>;
export const UpdateCaseFieldV2Document = gql`
    mutation UpdateCaseFieldV2($id: ID!, $input: UpdateCaseFieldInput!) @endpoint(name: asoc_v2) {
  updateCaseField(id: $id, input: $input) {
    success
    caseField {
      id
      fieldName
      displayName
      fieldType
      description
      descriptor
      isDeprecated
      isObservable
      isAll
      isSystem
      isHidden
      isComputed
      regex
      exclusionRegexes
      validationRegex
      insertedAt
      updatedAt
    }
    errors
  }
}
    `;
export type UpdateCaseFieldV2MutationFn = Apollo.MutationFunction<UpdateCaseFieldV2Mutation, UpdateCaseFieldV2MutationVariables>;

/**
 * __useUpdateCaseFieldV2Mutation__
 *
 * To run a mutation, you first call `useUpdateCaseFieldV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseFieldV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseFieldV2Mutation, { data, loading, error }] = useUpdateCaseFieldV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCaseFieldV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaseFieldV2Mutation, UpdateCaseFieldV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaseFieldV2Mutation, UpdateCaseFieldV2MutationVariables>(UpdateCaseFieldV2Document, options);
      }
export type UpdateCaseFieldV2MutationHookResult = ReturnType<typeof useUpdateCaseFieldV2Mutation>;
export type UpdateCaseFieldV2MutationResult = Apollo.MutationResult<UpdateCaseFieldV2Mutation>;
export type UpdateCaseFieldV2MutationOptions = Apollo.BaseMutationOptions<UpdateCaseFieldV2Mutation, UpdateCaseFieldV2MutationVariables>;
export const DeleteCaseFieldV2Document = gql`
    mutation DeleteCaseFieldV2($id: ID!) @endpoint(name: asoc_v2) {
  deleteCaseField(id: $id) {
    success
    id
    errors
  }
}
    `;
export type DeleteCaseFieldV2MutationFn = Apollo.MutationFunction<DeleteCaseFieldV2Mutation, DeleteCaseFieldV2MutationVariables>;

/**
 * __useDeleteCaseFieldV2Mutation__
 *
 * To run a mutation, you first call `useDeleteCaseFieldV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCaseFieldV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCaseFieldV2Mutation, { data, loading, error }] = useDeleteCaseFieldV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCaseFieldV2Mutation(baseOptions?: Apollo.MutationHookOptions<DeleteCaseFieldV2Mutation, DeleteCaseFieldV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCaseFieldV2Mutation, DeleteCaseFieldV2MutationVariables>(DeleteCaseFieldV2Document, options);
      }
export type DeleteCaseFieldV2MutationHookResult = ReturnType<typeof useDeleteCaseFieldV2Mutation>;
export type DeleteCaseFieldV2MutationResult = Apollo.MutationResult<DeleteCaseFieldV2Mutation>;
export type DeleteCaseFieldV2MutationOptions = Apollo.BaseMutationOptions<DeleteCaseFieldV2Mutation, DeleteCaseFieldV2MutationVariables>;
export const CreatePriorityV2Document = gql`
    mutation CreatePriorityV2($input: CreatePriorityInput!) @endpoint(name: asoc_v2) {
  createPriority(input: $input) {
    success
    priority {
      id
      name
      icon
      color
      priorityValue
      isDefault
      insertedAt
      updatedAt
    }
    errors
  }
}
    `;
export type CreatePriorityV2MutationFn = Apollo.MutationFunction<CreatePriorityV2Mutation, CreatePriorityV2MutationVariables>;

/**
 * __useCreatePriorityV2Mutation__
 *
 * To run a mutation, you first call `useCreatePriorityV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePriorityV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPriorityV2Mutation, { data, loading, error }] = useCreatePriorityV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePriorityV2Mutation(baseOptions?: Apollo.MutationHookOptions<CreatePriorityV2Mutation, CreatePriorityV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePriorityV2Mutation, CreatePriorityV2MutationVariables>(CreatePriorityV2Document, options);
      }
export type CreatePriorityV2MutationHookResult = ReturnType<typeof useCreatePriorityV2Mutation>;
export type CreatePriorityV2MutationResult = Apollo.MutationResult<CreatePriorityV2Mutation>;
export type CreatePriorityV2MutationOptions = Apollo.BaseMutationOptions<CreatePriorityV2Mutation, CreatePriorityV2MutationVariables>;
export const UpdatePriorityV2Document = gql`
    mutation UpdatePriorityV2($id: ID!, $input: UpdatePriorityInput!) @endpoint(name: asoc_v2) {
  updatePriority(id: $id, input: $input) {
    success
    priority {
      id
      name
      icon
      color
      priorityValue
      isDefault
      insertedAt
      updatedAt
    }
    errors
  }
}
    `;
export type UpdatePriorityV2MutationFn = Apollo.MutationFunction<UpdatePriorityV2Mutation, UpdatePriorityV2MutationVariables>;

/**
 * __useUpdatePriorityV2Mutation__
 *
 * To run a mutation, you first call `useUpdatePriorityV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePriorityV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePriorityV2Mutation, { data, loading, error }] = useUpdatePriorityV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePriorityV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdatePriorityV2Mutation, UpdatePriorityV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePriorityV2Mutation, UpdatePriorityV2MutationVariables>(UpdatePriorityV2Document, options);
      }
export type UpdatePriorityV2MutationHookResult = ReturnType<typeof useUpdatePriorityV2Mutation>;
export type UpdatePriorityV2MutationResult = Apollo.MutationResult<UpdatePriorityV2Mutation>;
export type UpdatePriorityV2MutationOptions = Apollo.BaseMutationOptions<UpdatePriorityV2Mutation, UpdatePriorityV2MutationVariables>;
export const DeletePriorityV2Document = gql`
    mutation DeletePriorityV2($id: ID!) @endpoint(name: asoc_v2) {
  deletePriority(id: $id) {
    success
    id
    errors
  }
}
    `;
export type DeletePriorityV2MutationFn = Apollo.MutationFunction<DeletePriorityV2Mutation, DeletePriorityV2MutationVariables>;

/**
 * __useDeletePriorityV2Mutation__
 *
 * To run a mutation, you first call `useDeletePriorityV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePriorityV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePriorityV2Mutation, { data, loading, error }] = useDeletePriorityV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePriorityV2Mutation(baseOptions?: Apollo.MutationHookOptions<DeletePriorityV2Mutation, DeletePriorityV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePriorityV2Mutation, DeletePriorityV2MutationVariables>(DeletePriorityV2Document, options);
      }
export type DeletePriorityV2MutationHookResult = ReturnType<typeof useDeletePriorityV2Mutation>;
export type DeletePriorityV2MutationResult = Apollo.MutationResult<DeletePriorityV2Mutation>;
export type DeletePriorityV2MutationOptions = Apollo.BaseMutationOptions<DeletePriorityV2Mutation, DeletePriorityV2MutationVariables>;
export const SetDefaultPriorityV2Document = gql`
    mutation SetDefaultPriorityV2($id: ID!) @endpoint(name: asoc_v2) {
  setDefaultPriority(id: $id) {
    success
    priority {
      id
      name
      icon
      color
      priorityValue
      isDefault
      insertedAt
      updatedAt
    }
    errors
  }
}
    `;
export type SetDefaultPriorityV2MutationFn = Apollo.MutationFunction<SetDefaultPriorityV2Mutation, SetDefaultPriorityV2MutationVariables>;

/**
 * __useSetDefaultPriorityV2Mutation__
 *
 * To run a mutation, you first call `useSetDefaultPriorityV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultPriorityV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultPriorityV2Mutation, { data, loading, error }] = useSetDefaultPriorityV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetDefaultPriorityV2Mutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultPriorityV2Mutation, SetDefaultPriorityV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultPriorityV2Mutation, SetDefaultPriorityV2MutationVariables>(SetDefaultPriorityV2Document, options);
      }
export type SetDefaultPriorityV2MutationHookResult = ReturnType<typeof useSetDefaultPriorityV2Mutation>;
export type SetDefaultPriorityV2MutationResult = Apollo.MutationResult<SetDefaultPriorityV2Mutation>;
export type SetDefaultPriorityV2MutationOptions = Apollo.BaseMutationOptions<SetDefaultPriorityV2Mutation, SetDefaultPriorityV2MutationVariables>;
export const ReorderPrioritiesV2Document = gql`
    mutation ReorderPrioritiesV2($priorityIds: [ID!]!) @endpoint(name: asoc_v2) {
  reorderPriorities(priorityIds: $priorityIds) {
    id
    name
    icon
    color
    priorityValue
    isDefault
    insertedAt
    updatedAt
  }
}
    `;
export type ReorderPrioritiesV2MutationFn = Apollo.MutationFunction<ReorderPrioritiesV2Mutation, ReorderPrioritiesV2MutationVariables>;

/**
 * __useReorderPrioritiesV2Mutation__
 *
 * To run a mutation, you first call `useReorderPrioritiesV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderPrioritiesV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderPrioritiesV2Mutation, { data, loading, error }] = useReorderPrioritiesV2Mutation({
 *   variables: {
 *      priorityIds: // value for 'priorityIds'
 *   },
 * });
 */
export function useReorderPrioritiesV2Mutation(baseOptions?: Apollo.MutationHookOptions<ReorderPrioritiesV2Mutation, ReorderPrioritiesV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderPrioritiesV2Mutation, ReorderPrioritiesV2MutationVariables>(ReorderPrioritiesV2Document, options);
      }
export type ReorderPrioritiesV2MutationHookResult = ReturnType<typeof useReorderPrioritiesV2Mutation>;
export type ReorderPrioritiesV2MutationResult = Apollo.MutationResult<ReorderPrioritiesV2Mutation>;
export type ReorderPrioritiesV2MutationOptions = Apollo.BaseMutationOptions<ReorderPrioritiesV2Mutation, ReorderPrioritiesV2MutationVariables>;
export const CreateStatusWorkflowV2Document = gql`
    mutation CreateStatusWorkflowV2($input: CreateStatusWorkflowInput!) @endpoint(name: asoc_v2) {
  createStatusWorkflow(input: $input) {
    success
    statusWorkflow {
      id
      name
      description
      isSystem
      hasDraft
      transitions {
        from
        to
        statusType
      }
      insertedAt
      updatedAt
    }
    errors
  }
}
    `;
export type CreateStatusWorkflowV2MutationFn = Apollo.MutationFunction<CreateStatusWorkflowV2Mutation, CreateStatusWorkflowV2MutationVariables>;

/**
 * __useCreateStatusWorkflowV2Mutation__
 *
 * To run a mutation, you first call `useCreateStatusWorkflowV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStatusWorkflowV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStatusWorkflowV2Mutation, { data, loading, error }] = useCreateStatusWorkflowV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStatusWorkflowV2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateStatusWorkflowV2Mutation, CreateStatusWorkflowV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStatusWorkflowV2Mutation, CreateStatusWorkflowV2MutationVariables>(CreateStatusWorkflowV2Document, options);
      }
export type CreateStatusWorkflowV2MutationHookResult = ReturnType<typeof useCreateStatusWorkflowV2Mutation>;
export type CreateStatusWorkflowV2MutationResult = Apollo.MutationResult<CreateStatusWorkflowV2Mutation>;
export type CreateStatusWorkflowV2MutationOptions = Apollo.BaseMutationOptions<CreateStatusWorkflowV2Mutation, CreateStatusWorkflowV2MutationVariables>;
export const UpdateStatusWorkflowV2Document = gql`
    mutation UpdateStatusWorkflowV2($id: ID!, $input: UpdateStatusWorkflowInput!) @endpoint(name: asoc_v2) {
  updateStatusWorkflow(id: $id, input: $input) {
    success
    statusWorkflow {
      id
      name
      description
      isSystem
      hasDraft
      transitions {
        from
        to
        statusType
      }
      draftTransitions {
        from
        to
        statusType
      }
      insertedAt
      updatedAt
    }
    errors
  }
}
    `;
export type UpdateStatusWorkflowV2MutationFn = Apollo.MutationFunction<UpdateStatusWorkflowV2Mutation, UpdateStatusWorkflowV2MutationVariables>;

/**
 * __useUpdateStatusWorkflowV2Mutation__
 *
 * To run a mutation, you first call `useUpdateStatusWorkflowV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStatusWorkflowV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStatusWorkflowV2Mutation, { data, loading, error }] = useUpdateStatusWorkflowV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStatusWorkflowV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateStatusWorkflowV2Mutation, UpdateStatusWorkflowV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStatusWorkflowV2Mutation, UpdateStatusWorkflowV2MutationVariables>(UpdateStatusWorkflowV2Document, options);
      }
export type UpdateStatusWorkflowV2MutationHookResult = ReturnType<typeof useUpdateStatusWorkflowV2Mutation>;
export type UpdateStatusWorkflowV2MutationResult = Apollo.MutationResult<UpdateStatusWorkflowV2Mutation>;
export type UpdateStatusWorkflowV2MutationOptions = Apollo.BaseMutationOptions<UpdateStatusWorkflowV2Mutation, UpdateStatusWorkflowV2MutationVariables>;
export const DeleteStatusWorkflowV2Document = gql`
    mutation DeleteStatusWorkflowV2($id: ID!) @endpoint(name: asoc_v2) {
  deleteStatusWorkflow(id: $id) {
    success
    id
    errors
  }
}
    `;
export type DeleteStatusWorkflowV2MutationFn = Apollo.MutationFunction<DeleteStatusWorkflowV2Mutation, DeleteStatusWorkflowV2MutationVariables>;

/**
 * __useDeleteStatusWorkflowV2Mutation__
 *
 * To run a mutation, you first call `useDeleteStatusWorkflowV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStatusWorkflowV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStatusWorkflowV2Mutation, { data, loading, error }] = useDeleteStatusWorkflowV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStatusWorkflowV2Mutation(baseOptions?: Apollo.MutationHookOptions<DeleteStatusWorkflowV2Mutation, DeleteStatusWorkflowV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStatusWorkflowV2Mutation, DeleteStatusWorkflowV2MutationVariables>(DeleteStatusWorkflowV2Document, options);
      }
export type DeleteStatusWorkflowV2MutationHookResult = ReturnType<typeof useDeleteStatusWorkflowV2Mutation>;
export type DeleteStatusWorkflowV2MutationResult = Apollo.MutationResult<DeleteStatusWorkflowV2Mutation>;
export type DeleteStatusWorkflowV2MutationOptions = Apollo.BaseMutationOptions<DeleteStatusWorkflowV2Mutation, DeleteStatusWorkflowV2MutationVariables>;
export const CloneStatusWorkflowV2Document = gql`
    mutation CloneStatusWorkflowV2($id: ID!, $newName: String!) @endpoint(name: asoc_v2) {
  cloneStatusWorkflow(id: $id, newName: $newName) {
    success
    statusWorkflow {
      id
      name
      description
      isSystem
      hasDraft
      transitions {
        from
        to
        statusType
      }
      insertedAt
      updatedAt
    }
    errors
  }
}
    `;
export type CloneStatusWorkflowV2MutationFn = Apollo.MutationFunction<CloneStatusWorkflowV2Mutation, CloneStatusWorkflowV2MutationVariables>;

/**
 * __useCloneStatusWorkflowV2Mutation__
 *
 * To run a mutation, you first call `useCloneStatusWorkflowV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneStatusWorkflowV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneStatusWorkflowV2Mutation, { data, loading, error }] = useCloneStatusWorkflowV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      newName: // value for 'newName'
 *   },
 * });
 */
export function useCloneStatusWorkflowV2Mutation(baseOptions?: Apollo.MutationHookOptions<CloneStatusWorkflowV2Mutation, CloneStatusWorkflowV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneStatusWorkflowV2Mutation, CloneStatusWorkflowV2MutationVariables>(CloneStatusWorkflowV2Document, options);
      }
export type CloneStatusWorkflowV2MutationHookResult = ReturnType<typeof useCloneStatusWorkflowV2Mutation>;
export type CloneStatusWorkflowV2MutationResult = Apollo.MutationResult<CloneStatusWorkflowV2Mutation>;
export type CloneStatusWorkflowV2MutationOptions = Apollo.BaseMutationOptions<CloneStatusWorkflowV2Mutation, CloneStatusWorkflowV2MutationVariables>;
export const ReassignStatusWorkflowV2Document = gql`
    mutation ReassignStatusWorkflowV2($input: ReassignStatusWorkflowInput!) @endpoint(name: asoc_v2) {
  reassignStatusWorkflow(input: $input) {
    success
    caseTypesUpdated
    casesUpdated
    errors
  }
}
    `;
export type ReassignStatusWorkflowV2MutationFn = Apollo.MutationFunction<ReassignStatusWorkflowV2Mutation, ReassignStatusWorkflowV2MutationVariables>;

/**
 * __useReassignStatusWorkflowV2Mutation__
 *
 * To run a mutation, you first call `useReassignStatusWorkflowV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReassignStatusWorkflowV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reassignStatusWorkflowV2Mutation, { data, loading, error }] = useReassignStatusWorkflowV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReassignStatusWorkflowV2Mutation(baseOptions?: Apollo.MutationHookOptions<ReassignStatusWorkflowV2Mutation, ReassignStatusWorkflowV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReassignStatusWorkflowV2Mutation, ReassignStatusWorkflowV2MutationVariables>(ReassignStatusWorkflowV2Document, options);
      }
export type ReassignStatusWorkflowV2MutationHookResult = ReturnType<typeof useReassignStatusWorkflowV2Mutation>;
export type ReassignStatusWorkflowV2MutationResult = Apollo.MutationResult<ReassignStatusWorkflowV2Mutation>;
export type ReassignStatusWorkflowV2MutationOptions = Apollo.BaseMutationOptions<ReassignStatusWorkflowV2Mutation, ReassignStatusWorkflowV2MutationVariables>;
export const CreateCommentV2Document = gql`
    mutation CreateCommentV2($input: CreateCommentInput!) @endpoint(name: asoc_v2) {
  createComment(input: $input) {
    success
    comment {
      id
      content
      contentType
      insertedAt
      updatedAt
      user {
        id
        email
        displayName
      }
      isDeleted
    }
    errors
  }
}
    `;
export type CreateCommentV2MutationFn = Apollo.MutationFunction<CreateCommentV2Mutation, CreateCommentV2MutationVariables>;

/**
 * __useCreateCommentV2Mutation__
 *
 * To run a mutation, you first call `useCreateCommentV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentV2Mutation, { data, loading, error }] = useCreateCommentV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommentV2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentV2Mutation, CreateCommentV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentV2Mutation, CreateCommentV2MutationVariables>(CreateCommentV2Document, options);
      }
export type CreateCommentV2MutationHookResult = ReturnType<typeof useCreateCommentV2Mutation>;
export type CreateCommentV2MutationResult = Apollo.MutationResult<CreateCommentV2Mutation>;
export type CreateCommentV2MutationOptions = Apollo.BaseMutationOptions<CreateCommentV2Mutation, CreateCommentV2MutationVariables>;
export const UpdateCommentV2Document = gql`
    mutation UpdateCommentV2($id: ID!, $input: UpdateCommentInput!) @endpoint(name: asoc_v2) {
  updateComment(id: $id, input: $input) {
    success
    comment {
      id
      content
      contentType
      insertedAt
      updatedAt
      user {
        id
        email
        displayName
      }
      isDeleted
    }
    errors
  }
}
    `;
export type UpdateCommentV2MutationFn = Apollo.MutationFunction<UpdateCommentV2Mutation, UpdateCommentV2MutationVariables>;

/**
 * __useUpdateCommentV2Mutation__
 *
 * To run a mutation, you first call `useUpdateCommentV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentV2Mutation, { data, loading, error }] = useUpdateCommentV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommentV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommentV2Mutation, UpdateCommentV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommentV2Mutation, UpdateCommentV2MutationVariables>(UpdateCommentV2Document, options);
      }
export type UpdateCommentV2MutationHookResult = ReturnType<typeof useUpdateCommentV2Mutation>;
export type UpdateCommentV2MutationResult = Apollo.MutationResult<UpdateCommentV2Mutation>;
export type UpdateCommentV2MutationOptions = Apollo.BaseMutationOptions<UpdateCommentV2Mutation, UpdateCommentV2MutationVariables>;
export const DeleteCommentV2Document = gql`
    mutation DeleteCommentV2($id: ID!) @endpoint(name: asoc_v2) {
  deleteComment(id: $id) {
    success
    id
    errors
  }
}
    `;
export type DeleteCommentV2MutationFn = Apollo.MutationFunction<DeleteCommentV2Mutation, DeleteCommentV2MutationVariables>;

/**
 * __useDeleteCommentV2Mutation__
 *
 * To run a mutation, you first call `useDeleteCommentV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentV2Mutation, { data, loading, error }] = useDeleteCommentV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCommentV2Mutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentV2Mutation, DeleteCommentV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentV2Mutation, DeleteCommentV2MutationVariables>(DeleteCommentV2Document, options);
      }
export type DeleteCommentV2MutationHookResult = ReturnType<typeof useDeleteCommentV2Mutation>;
export type DeleteCommentV2MutationResult = Apollo.MutationResult<DeleteCommentV2Mutation>;
export type DeleteCommentV2MutationOptions = Apollo.BaseMutationOptions<DeleteCommentV2Mutation, DeleteCommentV2MutationVariables>;
export const CreateTaskV2Document = gql`
    mutation CreateTaskV2($input: CreateTaskInput!) @endpoint(name: asoc_v2) {
  createTask(input: $input) {
    success
    task {
      id
      taskNumber
      name
      description
      taskType
      triggerMode
      commentOutput
      status
      startedAt
      completedAt
      errorMessage
      sortOrder
      insertedAt
      updatedAt
      config
      result
      assignee {
        id
        email
        displayName
      }
      executable
      completable
      retriable
    }
    errors
  }
}
    `;
export type CreateTaskV2MutationFn = Apollo.MutationFunction<CreateTaskV2Mutation, CreateTaskV2MutationVariables>;

/**
 * __useCreateTaskV2Mutation__
 *
 * To run a mutation, you first call `useCreateTaskV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskV2Mutation, { data, loading, error }] = useCreateTaskV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaskV2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskV2Mutation, CreateTaskV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskV2Mutation, CreateTaskV2MutationVariables>(CreateTaskV2Document, options);
      }
export type CreateTaskV2MutationHookResult = ReturnType<typeof useCreateTaskV2Mutation>;
export type CreateTaskV2MutationResult = Apollo.MutationResult<CreateTaskV2Mutation>;
export type CreateTaskV2MutationOptions = Apollo.BaseMutationOptions<CreateTaskV2Mutation, CreateTaskV2MutationVariables>;
export const CreateWorkflowTaskV2Document = gql`
    mutation CreateWorkflowTaskV2($input: CreateWorkflowTaskInput!) @endpoint(name: asoc_v2) {
  createWorkflowTask(input: $input) {
    success
    task {
      id
      taskNumber
      name
      description
      taskType
      triggerMode
      commentOutput
      status
      startedAt
      completedAt
      errorMessage
      sortOrder
      insertedAt
      updatedAt
      config
      result
      assignee {
        id
        email
        displayName
      }
      executable
      completable
      retriable
    }
    errors
  }
}
    `;
export type CreateWorkflowTaskV2MutationFn = Apollo.MutationFunction<CreateWorkflowTaskV2Mutation, CreateWorkflowTaskV2MutationVariables>;

/**
 * __useCreateWorkflowTaskV2Mutation__
 *
 * To run a mutation, you first call `useCreateWorkflowTaskV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowTaskV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowTaskV2Mutation, { data, loading, error }] = useCreateWorkflowTaskV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkflowTaskV2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkflowTaskV2Mutation, CreateWorkflowTaskV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkflowTaskV2Mutation, CreateWorkflowTaskV2MutationVariables>(CreateWorkflowTaskV2Document, options);
      }
export type CreateWorkflowTaskV2MutationHookResult = ReturnType<typeof useCreateWorkflowTaskV2Mutation>;
export type CreateWorkflowTaskV2MutationResult = Apollo.MutationResult<CreateWorkflowTaskV2Mutation>;
export type CreateWorkflowTaskV2MutationOptions = Apollo.BaseMutationOptions<CreateWorkflowTaskV2Mutation, CreateWorkflowTaskV2MutationVariables>;
export const CreateManualTaskV2Document = gql`
    mutation CreateManualTaskV2($input: CreateManualTaskInput!) @endpoint(name: asoc_v2) {
  createManualTask(input: $input) {
    success
    task {
      id
      taskNumber
      name
      description
      taskType
      triggerMode
      commentOutput
      status
      startedAt
      completedAt
      errorMessage
      sortOrder
      insertedAt
      updatedAt
      config
      result
      assignee {
        id
        email
        displayName
      }
      executable
      completable
      retriable
    }
    errors
  }
}
    `;
export type CreateManualTaskV2MutationFn = Apollo.MutationFunction<CreateManualTaskV2Mutation, CreateManualTaskV2MutationVariables>;

/**
 * __useCreateManualTaskV2Mutation__
 *
 * To run a mutation, you first call `useCreateManualTaskV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManualTaskV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManualTaskV2Mutation, { data, loading, error }] = useCreateManualTaskV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateManualTaskV2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateManualTaskV2Mutation, CreateManualTaskV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateManualTaskV2Mutation, CreateManualTaskV2MutationVariables>(CreateManualTaskV2Document, options);
      }
export type CreateManualTaskV2MutationHookResult = ReturnType<typeof useCreateManualTaskV2Mutation>;
export type CreateManualTaskV2MutationResult = Apollo.MutationResult<CreateManualTaskV2Mutation>;
export type CreateManualTaskV2MutationOptions = Apollo.BaseMutationOptions<CreateManualTaskV2Mutation, CreateManualTaskV2MutationVariables>;
export const UpdateTaskV2Document = gql`
    mutation UpdateTaskV2($id: ID!, $input: UpdateTaskInput!) @endpoint(name: asoc_v2) {
  updateTask(id: $id, input: $input) {
    success
    task {
      id
      taskNumber
      name
      description
      taskType
      triggerMode
      commentOutput
      status
      startedAt
      completedAt
      errorMessage
      sortOrder
      insertedAt
      updatedAt
      config
      result
      assignee {
        id
        email
        displayName
      }
      executable
      completable
      retriable
    }
    errors
  }
}
    `;
export type UpdateTaskV2MutationFn = Apollo.MutationFunction<UpdateTaskV2Mutation, UpdateTaskV2MutationVariables>;

/**
 * __useUpdateTaskV2Mutation__
 *
 * To run a mutation, you first call `useUpdateTaskV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskV2Mutation, { data, loading, error }] = useUpdateTaskV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskV2Mutation, UpdateTaskV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskV2Mutation, UpdateTaskV2MutationVariables>(UpdateTaskV2Document, options);
      }
export type UpdateTaskV2MutationHookResult = ReturnType<typeof useUpdateTaskV2Mutation>;
export type UpdateTaskV2MutationResult = Apollo.MutationResult<UpdateTaskV2Mutation>;
export type UpdateTaskV2MutationOptions = Apollo.BaseMutationOptions<UpdateTaskV2Mutation, UpdateTaskV2MutationVariables>;
export const DeleteTaskV2Document = gql`
    mutation DeleteTaskV2($id: ID!) @endpoint(name: asoc_v2) {
  deleteTask(id: $id) {
    success
    id
    errors
  }
}
    `;
export type DeleteTaskV2MutationFn = Apollo.MutationFunction<DeleteTaskV2Mutation, DeleteTaskV2MutationVariables>;

/**
 * __useDeleteTaskV2Mutation__
 *
 * To run a mutation, you first call `useDeleteTaskV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskV2Mutation, { data, loading, error }] = useDeleteTaskV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTaskV2Mutation(baseOptions?: Apollo.MutationHookOptions<DeleteTaskV2Mutation, DeleteTaskV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTaskV2Mutation, DeleteTaskV2MutationVariables>(DeleteTaskV2Document, options);
      }
export type DeleteTaskV2MutationHookResult = ReturnType<typeof useDeleteTaskV2Mutation>;
export type DeleteTaskV2MutationResult = Apollo.MutationResult<DeleteTaskV2Mutation>;
export type DeleteTaskV2MutationOptions = Apollo.BaseMutationOptions<DeleteTaskV2Mutation, DeleteTaskV2MutationVariables>;
export const AssignTaskV2Document = gql`
    mutation AssignTaskV2($id: ID!, $assigneeId: ID!) @endpoint(name: asoc_v2) {
  assignTask(id: $id, assigneeId: $assigneeId) {
    success
    task {
      id
      taskNumber
      name
      assignee {
        id
        email
        displayName
      }
    }
    errors
  }
}
    `;
export type AssignTaskV2MutationFn = Apollo.MutationFunction<AssignTaskV2Mutation, AssignTaskV2MutationVariables>;

/**
 * __useAssignTaskV2Mutation__
 *
 * To run a mutation, you first call `useAssignTaskV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignTaskV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignTaskV2Mutation, { data, loading, error }] = useAssignTaskV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      assigneeId: // value for 'assigneeId'
 *   },
 * });
 */
export function useAssignTaskV2Mutation(baseOptions?: Apollo.MutationHookOptions<AssignTaskV2Mutation, AssignTaskV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignTaskV2Mutation, AssignTaskV2MutationVariables>(AssignTaskV2Document, options);
      }
export type AssignTaskV2MutationHookResult = ReturnType<typeof useAssignTaskV2Mutation>;
export type AssignTaskV2MutationResult = Apollo.MutationResult<AssignTaskV2Mutation>;
export type AssignTaskV2MutationOptions = Apollo.BaseMutationOptions<AssignTaskV2Mutation, AssignTaskV2MutationVariables>;
export const CancelTaskV2Document = gql`
    mutation CancelTaskV2($id: ID!) @endpoint(name: asoc_v2) {
  cancelTask(id: $id) {
    success
    task {
      id
      status
    }
    errors
  }
}
    `;
export type CancelTaskV2MutationFn = Apollo.MutationFunction<CancelTaskV2Mutation, CancelTaskV2MutationVariables>;

/**
 * __useCancelTaskV2Mutation__
 *
 * To run a mutation, you first call `useCancelTaskV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelTaskV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelTaskV2Mutation, { data, loading, error }] = useCancelTaskV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelTaskV2Mutation(baseOptions?: Apollo.MutationHookOptions<CancelTaskV2Mutation, CancelTaskV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelTaskV2Mutation, CancelTaskV2MutationVariables>(CancelTaskV2Document, options);
      }
export type CancelTaskV2MutationHookResult = ReturnType<typeof useCancelTaskV2Mutation>;
export type CancelTaskV2MutationResult = Apollo.MutationResult<CancelTaskV2Mutation>;
export type CancelTaskV2MutationOptions = Apollo.BaseMutationOptions<CancelTaskV2Mutation, CancelTaskV2MutationVariables>;
export const ExecuteTaskV2Document = gql`
    mutation ExecuteTaskV2($id: ID!) @endpoint(name: asoc_v2) {
  executeTask(id: $id) {
    success
    executionId
    task {
      id
      taskNumber
      name
      taskType
      triggerMode
      status
      startedAt
      completedAt
      errorMessage
      config
      result
      executable
      completable
      retriable
    }
    errors
  }
}
    `;
export type ExecuteTaskV2MutationFn = Apollo.MutationFunction<ExecuteTaskV2Mutation, ExecuteTaskV2MutationVariables>;

/**
 * __useExecuteTaskV2Mutation__
 *
 * To run a mutation, you first call `useExecuteTaskV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteTaskV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeTaskV2Mutation, { data, loading, error }] = useExecuteTaskV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExecuteTaskV2Mutation(baseOptions?: Apollo.MutationHookOptions<ExecuteTaskV2Mutation, ExecuteTaskV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteTaskV2Mutation, ExecuteTaskV2MutationVariables>(ExecuteTaskV2Document, options);
      }
export type ExecuteTaskV2MutationHookResult = ReturnType<typeof useExecuteTaskV2Mutation>;
export type ExecuteTaskV2MutationResult = Apollo.MutationResult<ExecuteTaskV2Mutation>;
export type ExecuteTaskV2MutationOptions = Apollo.BaseMutationOptions<ExecuteTaskV2Mutation, ExecuteTaskV2MutationVariables>;
export const RetryTaskV2Document = gql`
    mutation RetryTaskV2($id: ID!) @endpoint(name: asoc_v2) {
  retryTask(id: $id) {
    success
    executionId
    task {
      id
      taskNumber
      name
      taskType
      triggerMode
      status
      startedAt
      completedAt
      errorMessage
      config
      result
      executable
      completable
      retriable
    }
    errors
  }
}
    `;
export type RetryTaskV2MutationFn = Apollo.MutationFunction<RetryTaskV2Mutation, RetryTaskV2MutationVariables>;

/**
 * __useRetryTaskV2Mutation__
 *
 * To run a mutation, you first call `useRetryTaskV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryTaskV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryTaskV2Mutation, { data, loading, error }] = useRetryTaskV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRetryTaskV2Mutation(baseOptions?: Apollo.MutationHookOptions<RetryTaskV2Mutation, RetryTaskV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryTaskV2Mutation, RetryTaskV2MutationVariables>(RetryTaskV2Document, options);
      }
export type RetryTaskV2MutationHookResult = ReturnType<typeof useRetryTaskV2Mutation>;
export type RetryTaskV2MutationResult = Apollo.MutationResult<RetryTaskV2Mutation>;
export type RetryTaskV2MutationOptions = Apollo.BaseMutationOptions<RetryTaskV2Mutation, RetryTaskV2MutationVariables>;
export const CompleteManualTaskV2Document = gql`
    mutation CompleteManualTaskV2($id: ID!, $input: CompleteManualTaskInput!) @endpoint(name: asoc_v2) {
  completeManualTask(id: $id, input: $input) {
    success
    task {
      id
      taskNumber
      name
      taskType
      triggerMode
      status
      startedAt
      completedAt
      result
      completable
    }
    errors
  }
}
    `;
export type CompleteManualTaskV2MutationFn = Apollo.MutationFunction<CompleteManualTaskV2Mutation, CompleteManualTaskV2MutationVariables>;

/**
 * __useCompleteManualTaskV2Mutation__
 *
 * To run a mutation, you first call `useCompleteManualTaskV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteManualTaskV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeManualTaskV2Mutation, { data, loading, error }] = useCompleteManualTaskV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteManualTaskV2Mutation(baseOptions?: Apollo.MutationHookOptions<CompleteManualTaskV2Mutation, CompleteManualTaskV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteManualTaskV2Mutation, CompleteManualTaskV2MutationVariables>(CompleteManualTaskV2Document, options);
      }
export type CompleteManualTaskV2MutationHookResult = ReturnType<typeof useCompleteManualTaskV2Mutation>;
export type CompleteManualTaskV2MutationResult = Apollo.MutationResult<CompleteManualTaskV2Mutation>;
export type CompleteManualTaskV2MutationOptions = Apollo.BaseMutationOptions<CompleteManualTaskV2Mutation, CompleteManualTaskV2MutationVariables>;
export const UploadAttachmentV2Document = gql`
    mutation UploadAttachmentV2($input: UploadAttachmentInput!) @endpoint(name: asoc_v2) {
  uploadAttachment(input: $input) {
    success
    attachment {
      id
      filename
      contentType
      sizeBytes
      humanSize
      insertedAt
      updatedAt
      uploadedBy {
        id
        email
        displayName
      }
      downloadUrl
    }
    errors
  }
}
    `;
export type UploadAttachmentV2MutationFn = Apollo.MutationFunction<UploadAttachmentV2Mutation, UploadAttachmentV2MutationVariables>;

/**
 * __useUploadAttachmentV2Mutation__
 *
 * To run a mutation, you first call `useUploadAttachmentV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAttachmentV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAttachmentV2Mutation, { data, loading, error }] = useUploadAttachmentV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadAttachmentV2Mutation(baseOptions?: Apollo.MutationHookOptions<UploadAttachmentV2Mutation, UploadAttachmentV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadAttachmentV2Mutation, UploadAttachmentV2MutationVariables>(UploadAttachmentV2Document, options);
      }
export type UploadAttachmentV2MutationHookResult = ReturnType<typeof useUploadAttachmentV2Mutation>;
export type UploadAttachmentV2MutationResult = Apollo.MutationResult<UploadAttachmentV2Mutation>;
export type UploadAttachmentV2MutationOptions = Apollo.BaseMutationOptions<UploadAttachmentV2Mutation, UploadAttachmentV2MutationVariables>;
export const DeleteAttachmentV2Document = gql`
    mutation DeleteAttachmentV2($id: ID!) @endpoint(name: asoc_v2) {
  deleteAttachment(id: $id) {
    success
    errors
  }
}
    `;
export type DeleteAttachmentV2MutationFn = Apollo.MutationFunction<DeleteAttachmentV2Mutation, DeleteAttachmentV2MutationVariables>;

/**
 * __useDeleteAttachmentV2Mutation__
 *
 * To run a mutation, you first call `useDeleteAttachmentV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttachmentV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttachmentV2Mutation, { data, loading, error }] = useDeleteAttachmentV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAttachmentV2Mutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttachmentV2Mutation, DeleteAttachmentV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttachmentV2Mutation, DeleteAttachmentV2MutationVariables>(DeleteAttachmentV2Document, options);
      }
export type DeleteAttachmentV2MutationHookResult = ReturnType<typeof useDeleteAttachmentV2Mutation>;
export type DeleteAttachmentV2MutationResult = Apollo.MutationResult<DeleteAttachmentV2Mutation>;
export type DeleteAttachmentV2MutationOptions = Apollo.BaseMutationOptions<DeleteAttachmentV2Mutation, DeleteAttachmentV2MutationVariables>;
export const SetCaseFieldValueV2Document = gql`
    mutation SetCaseFieldValueV2($input: SetFieldValueInput!) @endpoint(name: asoc_v2) {
  setCaseFieldValue(input: $input) {
    success
    errors
  }
}
    `;
export type SetCaseFieldValueV2MutationFn = Apollo.MutationFunction<SetCaseFieldValueV2Mutation, SetCaseFieldValueV2MutationVariables>;

/**
 * __useSetCaseFieldValueV2Mutation__
 *
 * To run a mutation, you first call `useSetCaseFieldValueV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCaseFieldValueV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCaseFieldValueV2Mutation, { data, loading, error }] = useSetCaseFieldValueV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetCaseFieldValueV2Mutation(baseOptions?: Apollo.MutationHookOptions<SetCaseFieldValueV2Mutation, SetCaseFieldValueV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCaseFieldValueV2Mutation, SetCaseFieldValueV2MutationVariables>(SetCaseFieldValueV2Document, options);
      }
export type SetCaseFieldValueV2MutationHookResult = ReturnType<typeof useSetCaseFieldValueV2Mutation>;
export type SetCaseFieldValueV2MutationResult = Apollo.MutationResult<SetCaseFieldValueV2Mutation>;
export type SetCaseFieldValueV2MutationOptions = Apollo.BaseMutationOptions<SetCaseFieldValueV2Mutation, SetCaseFieldValueV2MutationVariables>;
export const LinkCasesV2Document = gql`
    mutation LinkCasesV2($input: LinkCasesInput!) @endpoint(name: asoc_v2) {
  linkCases(input: $input) {
    success
    errors
    caseLinks {
      id
      linkedCaseId
      insertedAt
      linkedCase {
        id
        caseNumber
        displayKey
        title
        status
        priority
      }
    }
  }
}
    `;
export type LinkCasesV2MutationFn = Apollo.MutationFunction<LinkCasesV2Mutation, LinkCasesV2MutationVariables>;

/**
 * __useLinkCasesV2Mutation__
 *
 * To run a mutation, you first call `useLinkCasesV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkCasesV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkCasesV2Mutation, { data, loading, error }] = useLinkCasesV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkCasesV2Mutation(baseOptions?: Apollo.MutationHookOptions<LinkCasesV2Mutation, LinkCasesV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkCasesV2Mutation, LinkCasesV2MutationVariables>(LinkCasesV2Document, options);
      }
export type LinkCasesV2MutationHookResult = ReturnType<typeof useLinkCasesV2Mutation>;
export type LinkCasesV2MutationResult = Apollo.MutationResult<LinkCasesV2Mutation>;
export type LinkCasesV2MutationOptions = Apollo.BaseMutationOptions<LinkCasesV2Mutation, LinkCasesV2MutationVariables>;
export const UnlinkCasesV2Document = gql`
    mutation UnlinkCasesV2($input: UnlinkCasesInput!) @endpoint(name: asoc_v2) {
  unlinkCases(input: $input) {
    success
    errors
  }
}
    `;
export type UnlinkCasesV2MutationFn = Apollo.MutationFunction<UnlinkCasesV2Mutation, UnlinkCasesV2MutationVariables>;

/**
 * __useUnlinkCasesV2Mutation__
 *
 * To run a mutation, you first call `useUnlinkCasesV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkCasesV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkCasesV2Mutation, { data, loading, error }] = useUnlinkCasesV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlinkCasesV2Mutation(baseOptions?: Apollo.MutationHookOptions<UnlinkCasesV2Mutation, UnlinkCasesV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkCasesV2Mutation, UnlinkCasesV2MutationVariables>(UnlinkCasesV2Document, options);
      }
export type UnlinkCasesV2MutationHookResult = ReturnType<typeof useUnlinkCasesV2Mutation>;
export type UnlinkCasesV2MutationResult = Apollo.MutationResult<UnlinkCasesV2Mutation>;
export type UnlinkCasesV2MutationOptions = Apollo.BaseMutationOptions<UnlinkCasesV2Mutation, UnlinkCasesV2MutationVariables>;
export const LinkAlertsToCaseV2Document = gql`
    mutation LinkAlertsToCaseV2($caseId: String!, $alertIds: [String!]!) @endpoint(name: asoc_v2) {
  linkAlertsToCase(caseId: $caseId, alertIds: $alertIds) {
    success
    linkedCount
    errors
    caseId
    linkedAlertIds
  }
}
    `;
export type LinkAlertsToCaseV2MutationFn = Apollo.MutationFunction<LinkAlertsToCaseV2Mutation, LinkAlertsToCaseV2MutationVariables>;

/**
 * __useLinkAlertsToCaseV2Mutation__
 *
 * To run a mutation, you first call `useLinkAlertsToCaseV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkAlertsToCaseV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkAlertsToCaseV2Mutation, { data, loading, error }] = useLinkAlertsToCaseV2Mutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      alertIds: // value for 'alertIds'
 *   },
 * });
 */
export function useLinkAlertsToCaseV2Mutation(baseOptions?: Apollo.MutationHookOptions<LinkAlertsToCaseV2Mutation, LinkAlertsToCaseV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkAlertsToCaseV2Mutation, LinkAlertsToCaseV2MutationVariables>(LinkAlertsToCaseV2Document, options);
      }
export type LinkAlertsToCaseV2MutationHookResult = ReturnType<typeof useLinkAlertsToCaseV2Mutation>;
export type LinkAlertsToCaseV2MutationResult = Apollo.MutationResult<LinkAlertsToCaseV2Mutation>;
export type LinkAlertsToCaseV2MutationOptions = Apollo.BaseMutationOptions<LinkAlertsToCaseV2Mutation, LinkAlertsToCaseV2MutationVariables>;
export const UnlinkAlertsFromCaseV2Document = gql`
    mutation UnlinkAlertsFromCaseV2($caseId: String!, $alertIds: [String!]!) @endpoint(name: asoc_v2) {
  unlinkAlertsFromCase(caseId: $caseId, alertIds: $alertIds) {
    success
    unlinkedCount
    errors
    caseId
    remainingAlertIds
  }
}
    `;
export type UnlinkAlertsFromCaseV2MutationFn = Apollo.MutationFunction<UnlinkAlertsFromCaseV2Mutation, UnlinkAlertsFromCaseV2MutationVariables>;

/**
 * __useUnlinkAlertsFromCaseV2Mutation__
 *
 * To run a mutation, you first call `useUnlinkAlertsFromCaseV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkAlertsFromCaseV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkAlertsFromCaseV2Mutation, { data, loading, error }] = useUnlinkAlertsFromCaseV2Mutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      alertIds: // value for 'alertIds'
 *   },
 * });
 */
export function useUnlinkAlertsFromCaseV2Mutation(baseOptions?: Apollo.MutationHookOptions<UnlinkAlertsFromCaseV2Mutation, UnlinkAlertsFromCaseV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkAlertsFromCaseV2Mutation, UnlinkAlertsFromCaseV2MutationVariables>(UnlinkAlertsFromCaseV2Document, options);
      }
export type UnlinkAlertsFromCaseV2MutationHookResult = ReturnType<typeof useUnlinkAlertsFromCaseV2Mutation>;
export type UnlinkAlertsFromCaseV2MutationResult = Apollo.MutationResult<UnlinkAlertsFromCaseV2Mutation>;
export type UnlinkAlertsFromCaseV2MutationOptions = Apollo.BaseMutationOptions<UnlinkAlertsFromCaseV2Mutation, UnlinkAlertsFromCaseV2MutationVariables>;
export const CreateProjectV2Document = gql`
    mutation CreateProjectV2($input: CreateCaseProjectInput!) @endpoint(name: asoc_v2) {
  createProject(input: $input) {
    success
    errors
    caseProject {
      id
      name
      slug
      description
      insertedAt
      updatedAt
    }
  }
}
    `;
export type CreateProjectV2MutationFn = Apollo.MutationFunction<CreateProjectV2Mutation, CreateProjectV2MutationVariables>;

/**
 * __useCreateProjectV2Mutation__
 *
 * To run a mutation, you first call `useCreateProjectV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectV2Mutation, { data, loading, error }] = useCreateProjectV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectV2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectV2Mutation, CreateProjectV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectV2Mutation, CreateProjectV2MutationVariables>(CreateProjectV2Document, options);
      }
export type CreateProjectV2MutationHookResult = ReturnType<typeof useCreateProjectV2Mutation>;
export type CreateProjectV2MutationResult = Apollo.MutationResult<CreateProjectV2Mutation>;
export type CreateProjectV2MutationOptions = Apollo.BaseMutationOptions<CreateProjectV2Mutation, CreateProjectV2MutationVariables>;
export const UpdateProjectV2Document = gql`
    mutation UpdateProjectV2($id: ID!, $input: UpdateCaseProjectInput!) @endpoint(name: asoc_v2) {
  updateProject(id: $id, input: $input) {
    success
    errors
    caseProject {
      id
      name
      slug
      description
      insertedAt
      updatedAt
    }
  }
}
    `;
export type UpdateProjectV2MutationFn = Apollo.MutationFunction<UpdateProjectV2Mutation, UpdateProjectV2MutationVariables>;

/**
 * __useUpdateProjectV2Mutation__
 *
 * To run a mutation, you first call `useUpdateProjectV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectV2Mutation, { data, loading, error }] = useUpdateProjectV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectV2Mutation, UpdateProjectV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectV2Mutation, UpdateProjectV2MutationVariables>(UpdateProjectV2Document, options);
      }
export type UpdateProjectV2MutationHookResult = ReturnType<typeof useUpdateProjectV2Mutation>;
export type UpdateProjectV2MutationResult = Apollo.MutationResult<UpdateProjectV2Mutation>;
export type UpdateProjectV2MutationOptions = Apollo.BaseMutationOptions<UpdateProjectV2Mutation, UpdateProjectV2MutationVariables>;
export const DeleteProjectV2Document = gql`
    mutation DeleteProjectV2($id: ID!) @endpoint(name: asoc_v2) {
  deleteProject(id: $id) {
    success
    id
    errors
  }
}
    `;
export type DeleteProjectV2MutationFn = Apollo.MutationFunction<DeleteProjectV2Mutation, DeleteProjectV2MutationVariables>;

/**
 * __useDeleteProjectV2Mutation__
 *
 * To run a mutation, you first call `useDeleteProjectV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectV2Mutation, { data, loading, error }] = useDeleteProjectV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectV2Mutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectV2Mutation, DeleteProjectV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectV2Mutation, DeleteProjectV2MutationVariables>(DeleteProjectV2Document, options);
      }
export type DeleteProjectV2MutationHookResult = ReturnType<typeof useDeleteProjectV2Mutation>;
export type DeleteProjectV2MutationResult = Apollo.MutationResult<DeleteProjectV2Mutation>;
export type DeleteProjectV2MutationOptions = Apollo.BaseMutationOptions<DeleteProjectV2Mutation, DeleteProjectV2MutationVariables>;
export const ForceSyncV2Document = gql`
    mutation ForceSyncV2($projectId: ID!) @endpoint(name: asoc_v2) {
  forceSync(projectId: $projectId) {
    success
    projectId
    errors
  }
}
    `;
export type ForceSyncV2MutationFn = Apollo.MutationFunction<ForceSyncV2Mutation, ForceSyncV2MutationVariables>;

/**
 * __useForceSyncV2Mutation__
 *
 * To run a mutation, you first call `useForceSyncV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceSyncV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceSyncV2Mutation, { data, loading, error }] = useForceSyncV2Mutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useForceSyncV2Mutation(baseOptions?: Apollo.MutationHookOptions<ForceSyncV2Mutation, ForceSyncV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForceSyncV2Mutation, ForceSyncV2MutationVariables>(ForceSyncV2Document, options);
      }
export type ForceSyncV2MutationHookResult = ReturnType<typeof useForceSyncV2Mutation>;
export type ForceSyncV2MutationResult = Apollo.MutationResult<ForceSyncV2Mutation>;
export type ForceSyncV2MutationOptions = Apollo.BaseMutationOptions<ForceSyncV2Mutation, ForceSyncV2MutationVariables>;
export const UpsertSyncConfigV2Document = gql`
    mutation UpsertSyncConfigV2($input: UpsertSyncConfigInput!) @endpoint(name: asoc_v2) {
  upsertSyncConfig(input: $input) {
    success
    syncConfig {
      defaultStrategy
      fieldStrategies
    }
    errors
  }
}
    `;
export type UpsertSyncConfigV2MutationFn = Apollo.MutationFunction<UpsertSyncConfigV2Mutation, UpsertSyncConfigV2MutationVariables>;

/**
 * __useUpsertSyncConfigV2Mutation__
 *
 * To run a mutation, you first call `useUpsertSyncConfigV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSyncConfigV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSyncConfigV2Mutation, { data, loading, error }] = useUpsertSyncConfigV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertSyncConfigV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpsertSyncConfigV2Mutation, UpsertSyncConfigV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertSyncConfigV2Mutation, UpsertSyncConfigV2MutationVariables>(UpsertSyncConfigV2Document, options);
      }
export type UpsertSyncConfigV2MutationHookResult = ReturnType<typeof useUpsertSyncConfigV2Mutation>;
export type UpsertSyncConfigV2MutationResult = Apollo.MutationResult<UpsertSyncConfigV2Mutation>;
export type UpsertSyncConfigV2MutationOptions = Apollo.BaseMutationOptions<UpsertSyncConfigV2Mutation, UpsertSyncConfigV2MutationVariables>;
export const DispatchCaseEventV2Document = gql`
    mutation DispatchCaseEventV2($input: DispatchCaseEventInput!) @endpoint(name: asoc_v2) {
  dispatchCaseEvent(input: $input) {
    id
    status
    updatedAt
  }
}
    `;
export type DispatchCaseEventV2MutationFn = Apollo.MutationFunction<DispatchCaseEventV2Mutation, DispatchCaseEventV2MutationVariables>;

/**
 * __useDispatchCaseEventV2Mutation__
 *
 * To run a mutation, you first call `useDispatchCaseEventV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDispatchCaseEventV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dispatchCaseEventV2Mutation, { data, loading, error }] = useDispatchCaseEventV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDispatchCaseEventV2Mutation(baseOptions?: Apollo.MutationHookOptions<DispatchCaseEventV2Mutation, DispatchCaseEventV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DispatchCaseEventV2Mutation, DispatchCaseEventV2MutationVariables>(DispatchCaseEventV2Document, options);
      }
export type DispatchCaseEventV2MutationHookResult = ReturnType<typeof useDispatchCaseEventV2Mutation>;
export type DispatchCaseEventV2MutationResult = Apollo.MutationResult<DispatchCaseEventV2Mutation>;
export type DispatchCaseEventV2MutationOptions = Apollo.BaseMutationOptions<DispatchCaseEventV2Mutation, DispatchCaseEventV2MutationVariables>;
export const SearchCasesV2Document = gql`
    query SearchCasesV2($limit: Int, $offset: Int, $sortBy: CaseSortField, $sortOrder: SortOrder, $filter: CaseFilterInput) @endpoint(name: asoc_v2) {
  searchCases(
    limit: $limit
    offset: $offset
    sortBy: $sortBy
    sortOrder: $sortOrder
    filter: $filter
  ) {
    cases {
      id
      caseNumber
      displayKey
      title
      status
      priority
      assignee {
        id
        email
        displayName
      }
      insertedAt
      updatedAt
    }
    total
    hasMore
  }
}
    `;

/**
 * __useSearchCasesV2Query__
 *
 * To run a query within a React component, call `useSearchCasesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useSearchCasesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCasesV2Query({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchCasesV2Query(baseOptions?: Apollo.QueryHookOptions<SearchCasesV2Query, SearchCasesV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCasesV2Query, SearchCasesV2QueryVariables>(SearchCasesV2Document, options);
      }
export function useSearchCasesV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCasesV2Query, SearchCasesV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCasesV2Query, SearchCasesV2QueryVariables>(SearchCasesV2Document, options);
        }
// @ts-ignore
export function useSearchCasesV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchCasesV2Query, SearchCasesV2QueryVariables>): Apollo.UseSuspenseQueryResult<SearchCasesV2Query, SearchCasesV2QueryVariables>;
export function useSearchCasesV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchCasesV2Query, SearchCasesV2QueryVariables>): Apollo.UseSuspenseQueryResult<SearchCasesV2Query | undefined, SearchCasesV2QueryVariables>;
export function useSearchCasesV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchCasesV2Query, SearchCasesV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchCasesV2Query, SearchCasesV2QueryVariables>(SearchCasesV2Document, options);
        }
export type SearchCasesV2QueryHookResult = ReturnType<typeof useSearchCasesV2Query>;
export type SearchCasesV2LazyQueryHookResult = ReturnType<typeof useSearchCasesV2LazyQuery>;
export type SearchCasesV2SuspenseQueryHookResult = ReturnType<typeof useSearchCasesV2SuspenseQuery>;
export type SearchCasesV2QueryResult = Apollo.QueryResult<SearchCasesV2Query, SearchCasesV2QueryVariables>;
export const ListPrioritiesV2Document = gql`
    query ListPrioritiesV2 @endpoint(name: asoc_v2) {
  priorities {
    id
    name
    icon
    color
    priorityValue
    isDefault
    insertedAt
    updatedAt
  }
}
    `;

/**
 * __useListPrioritiesV2Query__
 *
 * To run a query within a React component, call `useListPrioritiesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useListPrioritiesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPrioritiesV2Query({
 *   variables: {
 *   },
 * });
 */
export function useListPrioritiesV2Query(baseOptions?: Apollo.QueryHookOptions<ListPrioritiesV2Query, ListPrioritiesV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPrioritiesV2Query, ListPrioritiesV2QueryVariables>(ListPrioritiesV2Document, options);
      }
export function useListPrioritiesV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPrioritiesV2Query, ListPrioritiesV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPrioritiesV2Query, ListPrioritiesV2QueryVariables>(ListPrioritiesV2Document, options);
        }
// @ts-ignore
export function useListPrioritiesV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListPrioritiesV2Query, ListPrioritiesV2QueryVariables>): Apollo.UseSuspenseQueryResult<ListPrioritiesV2Query, ListPrioritiesV2QueryVariables>;
export function useListPrioritiesV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPrioritiesV2Query, ListPrioritiesV2QueryVariables>): Apollo.UseSuspenseQueryResult<ListPrioritiesV2Query | undefined, ListPrioritiesV2QueryVariables>;
export function useListPrioritiesV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPrioritiesV2Query, ListPrioritiesV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListPrioritiesV2Query, ListPrioritiesV2QueryVariables>(ListPrioritiesV2Document, options);
        }
export type ListPrioritiesV2QueryHookResult = ReturnType<typeof useListPrioritiesV2Query>;
export type ListPrioritiesV2LazyQueryHookResult = ReturnType<typeof useListPrioritiesV2LazyQuery>;
export type ListPrioritiesV2SuspenseQueryHookResult = ReturnType<typeof useListPrioritiesV2SuspenseQuery>;
export type ListPrioritiesV2QueryResult = Apollo.QueryResult<ListPrioritiesV2Query, ListPrioritiesV2QueryVariables>;
export const GetPriorityV2Document = gql`
    query GetPriorityV2($id: ID!) @endpoint(name: asoc_v2) {
  priority(id: $id) {
    id
    name
    icon
    color
    priorityValue
    isDefault
    insertedAt
    updatedAt
  }
}
    `;

/**
 * __useGetPriorityV2Query__
 *
 * To run a query within a React component, call `useGetPriorityV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetPriorityV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPriorityV2Query({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPriorityV2Query(baseOptions: Apollo.QueryHookOptions<GetPriorityV2Query, GetPriorityV2QueryVariables> & ({ variables: GetPriorityV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPriorityV2Query, GetPriorityV2QueryVariables>(GetPriorityV2Document, options);
      }
export function useGetPriorityV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPriorityV2Query, GetPriorityV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPriorityV2Query, GetPriorityV2QueryVariables>(GetPriorityV2Document, options);
        }
// @ts-ignore
export function useGetPriorityV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPriorityV2Query, GetPriorityV2QueryVariables>): Apollo.UseSuspenseQueryResult<GetPriorityV2Query, GetPriorityV2QueryVariables>;
export function useGetPriorityV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPriorityV2Query, GetPriorityV2QueryVariables>): Apollo.UseSuspenseQueryResult<GetPriorityV2Query | undefined, GetPriorityV2QueryVariables>;
export function useGetPriorityV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPriorityV2Query, GetPriorityV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPriorityV2Query, GetPriorityV2QueryVariables>(GetPriorityV2Document, options);
        }
export type GetPriorityV2QueryHookResult = ReturnType<typeof useGetPriorityV2Query>;
export type GetPriorityV2LazyQueryHookResult = ReturnType<typeof useGetPriorityV2LazyQuery>;
export type GetPriorityV2SuspenseQueryHookResult = ReturnType<typeof useGetPriorityV2SuspenseQuery>;
export type GetPriorityV2QueryResult = Apollo.QueryResult<GetPriorityV2Query, GetPriorityV2QueryVariables>;
export const ListStatusWorkflowsV2Document = gql`
    query ListStatusWorkflowsV2($limit: Int, $includeDeleted: Boolean) @endpoint(name: asoc_v2) {
  statusWorkflows(limit: $limit, includeDeleted: $includeDeleted) {
    id
    name
    description
    isSystem
    hasDraft
    transitions {
      from
      to
      statusType
    }
  }
}
    `;

/**
 * __useListStatusWorkflowsV2Query__
 *
 * To run a query within a React component, call `useListStatusWorkflowsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useListStatusWorkflowsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListStatusWorkflowsV2Query({
 *   variables: {
 *      limit: // value for 'limit'
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useListStatusWorkflowsV2Query(baseOptions?: Apollo.QueryHookOptions<ListStatusWorkflowsV2Query, ListStatusWorkflowsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListStatusWorkflowsV2Query, ListStatusWorkflowsV2QueryVariables>(ListStatusWorkflowsV2Document, options);
      }
export function useListStatusWorkflowsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListStatusWorkflowsV2Query, ListStatusWorkflowsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListStatusWorkflowsV2Query, ListStatusWorkflowsV2QueryVariables>(ListStatusWorkflowsV2Document, options);
        }
// @ts-ignore
export function useListStatusWorkflowsV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListStatusWorkflowsV2Query, ListStatusWorkflowsV2QueryVariables>): Apollo.UseSuspenseQueryResult<ListStatusWorkflowsV2Query, ListStatusWorkflowsV2QueryVariables>;
export function useListStatusWorkflowsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListStatusWorkflowsV2Query, ListStatusWorkflowsV2QueryVariables>): Apollo.UseSuspenseQueryResult<ListStatusWorkflowsV2Query | undefined, ListStatusWorkflowsV2QueryVariables>;
export function useListStatusWorkflowsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListStatusWorkflowsV2Query, ListStatusWorkflowsV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListStatusWorkflowsV2Query, ListStatusWorkflowsV2QueryVariables>(ListStatusWorkflowsV2Document, options);
        }
export type ListStatusWorkflowsV2QueryHookResult = ReturnType<typeof useListStatusWorkflowsV2Query>;
export type ListStatusWorkflowsV2LazyQueryHookResult = ReturnType<typeof useListStatusWorkflowsV2LazyQuery>;
export type ListStatusWorkflowsV2SuspenseQueryHookResult = ReturnType<typeof useListStatusWorkflowsV2SuspenseQuery>;
export type ListStatusWorkflowsV2QueryResult = Apollo.QueryResult<ListStatusWorkflowsV2Query, ListStatusWorkflowsV2QueryVariables>;
export const GetStatusWorkflowForCaseTypeV2Document = gql`
    query GetStatusWorkflowForCaseTypeV2($caseTypeId: ID!) @endpoint(name: asoc_v2) {
  statusWorkflowForCaseType(caseTypeId: $caseTypeId) {
    id
    name
    description
    isSystem
    hasDraft
    transitions {
      from
      to
      statusType
    }
  }
}
    `;

/**
 * __useGetStatusWorkflowForCaseTypeV2Query__
 *
 * To run a query within a React component, call `useGetStatusWorkflowForCaseTypeV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetStatusWorkflowForCaseTypeV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatusWorkflowForCaseTypeV2Query({
 *   variables: {
 *      caseTypeId: // value for 'caseTypeId'
 *   },
 * });
 */
export function useGetStatusWorkflowForCaseTypeV2Query(baseOptions: Apollo.QueryHookOptions<GetStatusWorkflowForCaseTypeV2Query, GetStatusWorkflowForCaseTypeV2QueryVariables> & ({ variables: GetStatusWorkflowForCaseTypeV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatusWorkflowForCaseTypeV2Query, GetStatusWorkflowForCaseTypeV2QueryVariables>(GetStatusWorkflowForCaseTypeV2Document, options);
      }
export function useGetStatusWorkflowForCaseTypeV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatusWorkflowForCaseTypeV2Query, GetStatusWorkflowForCaseTypeV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatusWorkflowForCaseTypeV2Query, GetStatusWorkflowForCaseTypeV2QueryVariables>(GetStatusWorkflowForCaseTypeV2Document, options);
        }
// @ts-ignore
export function useGetStatusWorkflowForCaseTypeV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStatusWorkflowForCaseTypeV2Query, GetStatusWorkflowForCaseTypeV2QueryVariables>): Apollo.UseSuspenseQueryResult<GetStatusWorkflowForCaseTypeV2Query, GetStatusWorkflowForCaseTypeV2QueryVariables>;
export function useGetStatusWorkflowForCaseTypeV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStatusWorkflowForCaseTypeV2Query, GetStatusWorkflowForCaseTypeV2QueryVariables>): Apollo.UseSuspenseQueryResult<GetStatusWorkflowForCaseTypeV2Query | undefined, GetStatusWorkflowForCaseTypeV2QueryVariables>;
export function useGetStatusWorkflowForCaseTypeV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStatusWorkflowForCaseTypeV2Query, GetStatusWorkflowForCaseTypeV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStatusWorkflowForCaseTypeV2Query, GetStatusWorkflowForCaseTypeV2QueryVariables>(GetStatusWorkflowForCaseTypeV2Document, options);
        }
export type GetStatusWorkflowForCaseTypeV2QueryHookResult = ReturnType<typeof useGetStatusWorkflowForCaseTypeV2Query>;
export type GetStatusWorkflowForCaseTypeV2LazyQueryHookResult = ReturnType<typeof useGetStatusWorkflowForCaseTypeV2LazyQuery>;
export type GetStatusWorkflowForCaseTypeV2SuspenseQueryHookResult = ReturnType<typeof useGetStatusWorkflowForCaseTypeV2SuspenseQuery>;
export type GetStatusWorkflowForCaseTypeV2QueryResult = Apollo.QueryResult<GetStatusWorkflowForCaseTypeV2Query, GetStatusWorkflowForCaseTypeV2QueryVariables>;
export const AdvancedSearchV2Document = gql`
    query AdvancedSearchV2($query: String!, $limit: Int, $offset: Int, $sortBy: CaseSortField, $sortOrder: SortOrder) @endpoint(name: asoc_v2) {
  advancedSearch(
    query: $query
    limit: $limit
    offset: $offset
    sortBy: $sortBy
    sortOrder: $sortOrder
  ) {
    cases {
      id
      caseNumber
      displayKey
      title
      status
      priority
      assignee {
        id
        email
        displayName
      }
      insertedAt
      updatedAt
    }
    total
    hasMore
  }
}
    `;

/**
 * __useAdvancedSearchV2Query__
 *
 * To run a query within a React component, call `useAdvancedSearchV2Query` and pass it any options that fit your needs.
 * When your component renders, `useAdvancedSearchV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvancedSearchV2Query({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useAdvancedSearchV2Query(baseOptions: Apollo.QueryHookOptions<AdvancedSearchV2Query, AdvancedSearchV2QueryVariables> & ({ variables: AdvancedSearchV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdvancedSearchV2Query, AdvancedSearchV2QueryVariables>(AdvancedSearchV2Document, options);
      }
export function useAdvancedSearchV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdvancedSearchV2Query, AdvancedSearchV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdvancedSearchV2Query, AdvancedSearchV2QueryVariables>(AdvancedSearchV2Document, options);
        }
// @ts-ignore
export function useAdvancedSearchV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdvancedSearchV2Query, AdvancedSearchV2QueryVariables>): Apollo.UseSuspenseQueryResult<AdvancedSearchV2Query, AdvancedSearchV2QueryVariables>;
export function useAdvancedSearchV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdvancedSearchV2Query, AdvancedSearchV2QueryVariables>): Apollo.UseSuspenseQueryResult<AdvancedSearchV2Query | undefined, AdvancedSearchV2QueryVariables>;
export function useAdvancedSearchV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdvancedSearchV2Query, AdvancedSearchV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdvancedSearchV2Query, AdvancedSearchV2QueryVariables>(AdvancedSearchV2Document, options);
        }
export type AdvancedSearchV2QueryHookResult = ReturnType<typeof useAdvancedSearchV2Query>;
export type AdvancedSearchV2LazyQueryHookResult = ReturnType<typeof useAdvancedSearchV2LazyQuery>;
export type AdvancedSearchV2SuspenseQueryHookResult = ReturnType<typeof useAdvancedSearchV2SuspenseQuery>;
export type AdvancedSearchV2QueryResult = Apollo.QueryResult<AdvancedSearchV2Query, AdvancedSearchV2QueryVariables>;
export const ValidateSearchQueryV2Document = gql`
    query ValidateSearchQueryV2($query: String!) @endpoint(name: asoc_v2) {
  validateSearch(query: $query) {
    valid
    error
    parsedQuery
  }
}
    `;

/**
 * __useValidateSearchQueryV2Query__
 *
 * To run a query within a React component, call `useValidateSearchQueryV2Query` and pass it any options that fit your needs.
 * When your component renders, `useValidateSearchQueryV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateSearchQueryV2Query({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useValidateSearchQueryV2Query(baseOptions: Apollo.QueryHookOptions<ValidateSearchQueryV2Query, ValidateSearchQueryV2QueryVariables> & ({ variables: ValidateSearchQueryV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateSearchQueryV2Query, ValidateSearchQueryV2QueryVariables>(ValidateSearchQueryV2Document, options);
      }
export function useValidateSearchQueryV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateSearchQueryV2Query, ValidateSearchQueryV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateSearchQueryV2Query, ValidateSearchQueryV2QueryVariables>(ValidateSearchQueryV2Document, options);
        }
// @ts-ignore
export function useValidateSearchQueryV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ValidateSearchQueryV2Query, ValidateSearchQueryV2QueryVariables>): Apollo.UseSuspenseQueryResult<ValidateSearchQueryV2Query, ValidateSearchQueryV2QueryVariables>;
export function useValidateSearchQueryV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateSearchQueryV2Query, ValidateSearchQueryV2QueryVariables>): Apollo.UseSuspenseQueryResult<ValidateSearchQueryV2Query | undefined, ValidateSearchQueryV2QueryVariables>;
export function useValidateSearchQueryV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateSearchQueryV2Query, ValidateSearchQueryV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateSearchQueryV2Query, ValidateSearchQueryV2QueryVariables>(ValidateSearchQueryV2Document, options);
        }
export type ValidateSearchQueryV2QueryHookResult = ReturnType<typeof useValidateSearchQueryV2Query>;
export type ValidateSearchQueryV2LazyQueryHookResult = ReturnType<typeof useValidateSearchQueryV2LazyQuery>;
export type ValidateSearchQueryV2SuspenseQueryHookResult = ReturnType<typeof useValidateSearchQueryV2SuspenseQuery>;
export type ValidateSearchQueryV2QueryResult = Apollo.QueryResult<ValidateSearchQueryV2Query, ValidateSearchQueryV2QueryVariables>;
export const ListSavedSearchesV2Document = gql`
    query ListSavedSearchesV2($limit: Int) @endpoint(name: asoc_v2) {
  savedSearches: allSavedSearches(limit: $limit) {
    id
    name
    queryType
    query
    description
    isShared
    ownerId
    insertedAt
    updatedAt
  }
}
    `;

/**
 * __useListSavedSearchesV2Query__
 *
 * To run a query within a React component, call `useListSavedSearchesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useListSavedSearchesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSavedSearchesV2Query({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListSavedSearchesV2Query(baseOptions?: Apollo.QueryHookOptions<ListSavedSearchesV2Query, ListSavedSearchesV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSavedSearchesV2Query, ListSavedSearchesV2QueryVariables>(ListSavedSearchesV2Document, options);
      }
export function useListSavedSearchesV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSavedSearchesV2Query, ListSavedSearchesV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSavedSearchesV2Query, ListSavedSearchesV2QueryVariables>(ListSavedSearchesV2Document, options);
        }
// @ts-ignore
export function useListSavedSearchesV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListSavedSearchesV2Query, ListSavedSearchesV2QueryVariables>): Apollo.UseSuspenseQueryResult<ListSavedSearchesV2Query, ListSavedSearchesV2QueryVariables>;
export function useListSavedSearchesV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSavedSearchesV2Query, ListSavedSearchesV2QueryVariables>): Apollo.UseSuspenseQueryResult<ListSavedSearchesV2Query | undefined, ListSavedSearchesV2QueryVariables>;
export function useListSavedSearchesV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSavedSearchesV2Query, ListSavedSearchesV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSavedSearchesV2Query, ListSavedSearchesV2QueryVariables>(ListSavedSearchesV2Document, options);
        }
export type ListSavedSearchesV2QueryHookResult = ReturnType<typeof useListSavedSearchesV2Query>;
export type ListSavedSearchesV2LazyQueryHookResult = ReturnType<typeof useListSavedSearchesV2LazyQuery>;
export type ListSavedSearchesV2SuspenseQueryHookResult = ReturnType<typeof useListSavedSearchesV2SuspenseQuery>;
export type ListSavedSearchesV2QueryResult = Apollo.QueryResult<ListSavedSearchesV2Query, ListSavedSearchesV2QueryVariables>;
export const GetCaseByNumberV2Document = gql`
    query GetCaseByNumberV2($caseNumber: Int!) @endpoint(name: asoc_v2) {
  caseByNumber(caseNumber: $caseNumber) {
    id
    caseNumber
    displayKey
    title
    description
    status
    priority
    project {
      id
      name
      prefix
    }
    assignee {
      id
      email
      displayName
    }
    reporter {
      id
      email
      displayName
    }
    fieldValues {
      id
      value
      parsedValue
      caseField {
        id
        fieldName
        displayName
        fieldType
        description
        isObservable
        isSystem
        isHidden
      }
    }
    externalId
    externalUrl
    syncState
    lastSyncedAt
    insertedAt
    updatedAt
  }
}
    `;

/**
 * __useGetCaseByNumberV2Query__
 *
 * To run a query within a React component, call `useGetCaseByNumberV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseByNumberV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseByNumberV2Query({
 *   variables: {
 *      caseNumber: // value for 'caseNumber'
 *   },
 * });
 */
export function useGetCaseByNumberV2Query(baseOptions: Apollo.QueryHookOptions<GetCaseByNumberV2Query, GetCaseByNumberV2QueryVariables> & ({ variables: GetCaseByNumberV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseByNumberV2Query, GetCaseByNumberV2QueryVariables>(GetCaseByNumberV2Document, options);
      }
export function useGetCaseByNumberV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseByNumberV2Query, GetCaseByNumberV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseByNumberV2Query, GetCaseByNumberV2QueryVariables>(GetCaseByNumberV2Document, options);
        }
// @ts-ignore
export function useGetCaseByNumberV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseByNumberV2Query, GetCaseByNumberV2QueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseByNumberV2Query, GetCaseByNumberV2QueryVariables>;
export function useGetCaseByNumberV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseByNumberV2Query, GetCaseByNumberV2QueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseByNumberV2Query | undefined, GetCaseByNumberV2QueryVariables>;
export function useGetCaseByNumberV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseByNumberV2Query, GetCaseByNumberV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseByNumberV2Query, GetCaseByNumberV2QueryVariables>(GetCaseByNumberV2Document, options);
        }
export type GetCaseByNumberV2QueryHookResult = ReturnType<typeof useGetCaseByNumberV2Query>;
export type GetCaseByNumberV2LazyQueryHookResult = ReturnType<typeof useGetCaseByNumberV2LazyQuery>;
export type GetCaseByNumberV2SuspenseQueryHookResult = ReturnType<typeof useGetCaseByNumberV2SuspenseQuery>;
export type GetCaseByNumberV2QueryResult = Apollo.QueryResult<GetCaseByNumberV2Query, GetCaseByNumberV2QueryVariables>;
export const GetCaseByIdV2Document = gql`
    query GetCaseByIdV2($id: ID!) @endpoint(name: asoc_v2) {
  case(id: $id) {
    id
    caseNumber
    displayKey
    title
    description
    status
    priority
    project {
      id
      name
      prefix
    }
    assignee {
      id
      email
      displayName
    }
    reporter {
      id
      email
      displayName
    }
    fieldValues {
      id
      value
      parsedValue
      caseField {
        id
        fieldName
        displayName
        fieldType
        description
        isObservable
        isSystem
        isHidden
      }
    }
    externalId
    externalUrl
    syncState
    lastSyncedAt
    insertedAt
    updatedAt
  }
}
    `;

/**
 * __useGetCaseByIdV2Query__
 *
 * To run a query within a React component, call `useGetCaseByIdV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseByIdV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseByIdV2Query({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCaseByIdV2Query(baseOptions: Apollo.QueryHookOptions<GetCaseByIdV2Query, GetCaseByIdV2QueryVariables> & ({ variables: GetCaseByIdV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseByIdV2Query, GetCaseByIdV2QueryVariables>(GetCaseByIdV2Document, options);
      }
export function useGetCaseByIdV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseByIdV2Query, GetCaseByIdV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseByIdV2Query, GetCaseByIdV2QueryVariables>(GetCaseByIdV2Document, options);
        }
// @ts-ignore
export function useGetCaseByIdV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseByIdV2Query, GetCaseByIdV2QueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseByIdV2Query, GetCaseByIdV2QueryVariables>;
export function useGetCaseByIdV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseByIdV2Query, GetCaseByIdV2QueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseByIdV2Query | undefined, GetCaseByIdV2QueryVariables>;
export function useGetCaseByIdV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseByIdV2Query, GetCaseByIdV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseByIdV2Query, GetCaseByIdV2QueryVariables>(GetCaseByIdV2Document, options);
        }
export type GetCaseByIdV2QueryHookResult = ReturnType<typeof useGetCaseByIdV2Query>;
export type GetCaseByIdV2LazyQueryHookResult = ReturnType<typeof useGetCaseByIdV2LazyQuery>;
export type GetCaseByIdV2SuspenseQueryHookResult = ReturnType<typeof useGetCaseByIdV2SuspenseQuery>;
export type GetCaseByIdV2QueryResult = Apollo.QueryResult<GetCaseByIdV2Query, GetCaseByIdV2QueryVariables>;
export const ListCaseFieldsV2Document = gql`
    query ListCaseFieldsV2($fieldType: CaseFieldType, $isObservable: Boolean) @endpoint(name: asoc_v2) {
  caseFields(fieldType: $fieldType, isObservable: $isObservable) {
    id
    fieldName
    displayName
    fieldType
    description
    descriptor
    isDeprecated
    isObservable
    isAll
    isSystem
    isHidden
    isComputed
    regex
    exclusionRegexes
    validationRegex
    insertedAt
    updatedAt
  }
}
    `;

/**
 * __useListCaseFieldsV2Query__
 *
 * To run a query within a React component, call `useListCaseFieldsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useListCaseFieldsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCaseFieldsV2Query({
 *   variables: {
 *      fieldType: // value for 'fieldType'
 *      isObservable: // value for 'isObservable'
 *   },
 * });
 */
export function useListCaseFieldsV2Query(baseOptions?: Apollo.QueryHookOptions<ListCaseFieldsV2Query, ListCaseFieldsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCaseFieldsV2Query, ListCaseFieldsV2QueryVariables>(ListCaseFieldsV2Document, options);
      }
export function useListCaseFieldsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCaseFieldsV2Query, ListCaseFieldsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCaseFieldsV2Query, ListCaseFieldsV2QueryVariables>(ListCaseFieldsV2Document, options);
        }
// @ts-ignore
export function useListCaseFieldsV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListCaseFieldsV2Query, ListCaseFieldsV2QueryVariables>): Apollo.UseSuspenseQueryResult<ListCaseFieldsV2Query, ListCaseFieldsV2QueryVariables>;
export function useListCaseFieldsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCaseFieldsV2Query, ListCaseFieldsV2QueryVariables>): Apollo.UseSuspenseQueryResult<ListCaseFieldsV2Query | undefined, ListCaseFieldsV2QueryVariables>;
export function useListCaseFieldsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCaseFieldsV2Query, ListCaseFieldsV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCaseFieldsV2Query, ListCaseFieldsV2QueryVariables>(ListCaseFieldsV2Document, options);
        }
export type ListCaseFieldsV2QueryHookResult = ReturnType<typeof useListCaseFieldsV2Query>;
export type ListCaseFieldsV2LazyQueryHookResult = ReturnType<typeof useListCaseFieldsV2LazyQuery>;
export type ListCaseFieldsV2SuspenseQueryHookResult = ReturnType<typeof useListCaseFieldsV2SuspenseQuery>;
export type ListCaseFieldsV2QueryResult = Apollo.QueryResult<ListCaseFieldsV2Query, ListCaseFieldsV2QueryVariables>;
export const GetCaseFieldV2Document = gql`
    query GetCaseFieldV2($id: ID!) @endpoint(name: asoc_v2) {
  caseField(id: $id) {
    id
    fieldName
    displayName
    fieldType
    description
    descriptor
    isDeprecated
    isObservable
    isAll
    isSystem
    isHidden
    isComputed
    regex
    exclusionRegexes
    validationRegex
    insertedAt
    updatedAt
  }
}
    `;

/**
 * __useGetCaseFieldV2Query__
 *
 * To run a query within a React component, call `useGetCaseFieldV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseFieldV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseFieldV2Query({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCaseFieldV2Query(baseOptions: Apollo.QueryHookOptions<GetCaseFieldV2Query, GetCaseFieldV2QueryVariables> & ({ variables: GetCaseFieldV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseFieldV2Query, GetCaseFieldV2QueryVariables>(GetCaseFieldV2Document, options);
      }
export function useGetCaseFieldV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseFieldV2Query, GetCaseFieldV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseFieldV2Query, GetCaseFieldV2QueryVariables>(GetCaseFieldV2Document, options);
        }
// @ts-ignore
export function useGetCaseFieldV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseFieldV2Query, GetCaseFieldV2QueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseFieldV2Query, GetCaseFieldV2QueryVariables>;
export function useGetCaseFieldV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseFieldV2Query, GetCaseFieldV2QueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseFieldV2Query | undefined, GetCaseFieldV2QueryVariables>;
export function useGetCaseFieldV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseFieldV2Query, GetCaseFieldV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseFieldV2Query, GetCaseFieldV2QueryVariables>(GetCaseFieldV2Document, options);
        }
export type GetCaseFieldV2QueryHookResult = ReturnType<typeof useGetCaseFieldV2Query>;
export type GetCaseFieldV2LazyQueryHookResult = ReturnType<typeof useGetCaseFieldV2LazyQuery>;
export type GetCaseFieldV2SuspenseQueryHookResult = ReturnType<typeof useGetCaseFieldV2SuspenseQuery>;
export type GetCaseFieldV2QueryResult = Apollo.QueryResult<GetCaseFieldV2Query, GetCaseFieldV2QueryVariables>;
export const ListCommentsV2Document = gql`
    query ListCommentsV2($caseId: ID!, $limit: Int, $includeDeleted: Boolean) @endpoint(name: asoc_v2) {
  comments(caseId: $caseId, limit: $limit, includeDeleted: $includeDeleted) {
    id
    content
    contentType
    insertedAt
    updatedAt
    user {
      id
      email
      displayName
    }
    isDeleted
  }
}
    `;

/**
 * __useListCommentsV2Query__
 *
 * To run a query within a React component, call `useListCommentsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useListCommentsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCommentsV2Query({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      limit: // value for 'limit'
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useListCommentsV2Query(baseOptions: Apollo.QueryHookOptions<ListCommentsV2Query, ListCommentsV2QueryVariables> & ({ variables: ListCommentsV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCommentsV2Query, ListCommentsV2QueryVariables>(ListCommentsV2Document, options);
      }
export function useListCommentsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCommentsV2Query, ListCommentsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCommentsV2Query, ListCommentsV2QueryVariables>(ListCommentsV2Document, options);
        }
// @ts-ignore
export function useListCommentsV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListCommentsV2Query, ListCommentsV2QueryVariables>): Apollo.UseSuspenseQueryResult<ListCommentsV2Query, ListCommentsV2QueryVariables>;
export function useListCommentsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCommentsV2Query, ListCommentsV2QueryVariables>): Apollo.UseSuspenseQueryResult<ListCommentsV2Query | undefined, ListCommentsV2QueryVariables>;
export function useListCommentsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCommentsV2Query, ListCommentsV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCommentsV2Query, ListCommentsV2QueryVariables>(ListCommentsV2Document, options);
        }
export type ListCommentsV2QueryHookResult = ReturnType<typeof useListCommentsV2Query>;
export type ListCommentsV2LazyQueryHookResult = ReturnType<typeof useListCommentsV2LazyQuery>;
export type ListCommentsV2SuspenseQueryHookResult = ReturnType<typeof useListCommentsV2SuspenseQuery>;
export type ListCommentsV2QueryResult = Apollo.QueryResult<ListCommentsV2Query, ListCommentsV2QueryVariables>;
export const GetCommentV2Document = gql`
    query GetCommentV2($id: ID!) @endpoint(name: asoc_v2) {
  comment(id: $id) {
    id
    content
    contentType
    insertedAt
    updatedAt
    user {
      id
      email
      displayName
    }
    isDeleted
  }
}
    `;

/**
 * __useGetCommentV2Query__
 *
 * To run a query within a React component, call `useGetCommentV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentV2Query({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCommentV2Query(baseOptions: Apollo.QueryHookOptions<GetCommentV2Query, GetCommentV2QueryVariables> & ({ variables: GetCommentV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommentV2Query, GetCommentV2QueryVariables>(GetCommentV2Document, options);
      }
export function useGetCommentV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommentV2Query, GetCommentV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommentV2Query, GetCommentV2QueryVariables>(GetCommentV2Document, options);
        }
// @ts-ignore
export function useGetCommentV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommentV2Query, GetCommentV2QueryVariables>): Apollo.UseSuspenseQueryResult<GetCommentV2Query, GetCommentV2QueryVariables>;
export function useGetCommentV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommentV2Query, GetCommentV2QueryVariables>): Apollo.UseSuspenseQueryResult<GetCommentV2Query | undefined, GetCommentV2QueryVariables>;
export function useGetCommentV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommentV2Query, GetCommentV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommentV2Query, GetCommentV2QueryVariables>(GetCommentV2Document, options);
        }
export type GetCommentV2QueryHookResult = ReturnType<typeof useGetCommentV2Query>;
export type GetCommentV2LazyQueryHookResult = ReturnType<typeof useGetCommentV2LazyQuery>;
export type GetCommentV2SuspenseQueryHookResult = ReturnType<typeof useGetCommentV2SuspenseQuery>;
export type GetCommentV2QueryResult = Apollo.QueryResult<GetCommentV2Query, GetCommentV2QueryVariables>;
export const ListTasksV2Document = gql`
    query ListTasksV2($caseId: ID!, $status: TaskStatus, $taskType: TaskType, $limit: Int) @endpoint(name: asoc_v2) {
  tasks(caseId: $caseId, status: $status, taskType: $taskType, limit: $limit) {
    id
    taskNumber
    name
    description
    taskType
    triggerMode
    commentOutput
    status
    startedAt
    completedAt
    errorMessage
    sortOrder
    insertedAt
    updatedAt
    config
    result
    assignee {
      id
      email
      displayName
    }
    executable
    completable
    retriable
  }
}
    `;

/**
 * __useListTasksV2Query__
 *
 * To run a query within a React component, call `useListTasksV2Query` and pass it any options that fit your needs.
 * When your component renders, `useListTasksV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTasksV2Query({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      status: // value for 'status'
 *      taskType: // value for 'taskType'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListTasksV2Query(baseOptions: Apollo.QueryHookOptions<ListTasksV2Query, ListTasksV2QueryVariables> & ({ variables: ListTasksV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTasksV2Query, ListTasksV2QueryVariables>(ListTasksV2Document, options);
      }
export function useListTasksV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTasksV2Query, ListTasksV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTasksV2Query, ListTasksV2QueryVariables>(ListTasksV2Document, options);
        }
// @ts-ignore
export function useListTasksV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListTasksV2Query, ListTasksV2QueryVariables>): Apollo.UseSuspenseQueryResult<ListTasksV2Query, ListTasksV2QueryVariables>;
export function useListTasksV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListTasksV2Query, ListTasksV2QueryVariables>): Apollo.UseSuspenseQueryResult<ListTasksV2Query | undefined, ListTasksV2QueryVariables>;
export function useListTasksV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListTasksV2Query, ListTasksV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListTasksV2Query, ListTasksV2QueryVariables>(ListTasksV2Document, options);
        }
export type ListTasksV2QueryHookResult = ReturnType<typeof useListTasksV2Query>;
export type ListTasksV2LazyQueryHookResult = ReturnType<typeof useListTasksV2LazyQuery>;
export type ListTasksV2SuspenseQueryHookResult = ReturnType<typeof useListTasksV2SuspenseQuery>;
export type ListTasksV2QueryResult = Apollo.QueryResult<ListTasksV2Query, ListTasksV2QueryVariables>;
export const GetTaskV2Document = gql`
    query GetTaskV2($id: ID!) @endpoint(name: asoc_v2) {
  task(id: $id) {
    id
    taskNumber
    name
    description
    taskType
    triggerMode
    commentOutput
    status
    startedAt
    completedAt
    errorMessage
    sortOrder
    insertedAt
    updatedAt
    config
    result
    assignee {
      id
      email
      displayName
    }
    executable
    completable
    retriable
  }
}
    `;

/**
 * __useGetTaskV2Query__
 *
 * To run a query within a React component, call `useGetTaskV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskV2Query({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskV2Query(baseOptions: Apollo.QueryHookOptions<GetTaskV2Query, GetTaskV2QueryVariables> & ({ variables: GetTaskV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskV2Query, GetTaskV2QueryVariables>(GetTaskV2Document, options);
      }
export function useGetTaskV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskV2Query, GetTaskV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskV2Query, GetTaskV2QueryVariables>(GetTaskV2Document, options);
        }
// @ts-ignore
export function useGetTaskV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskV2Query, GetTaskV2QueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskV2Query, GetTaskV2QueryVariables>;
export function useGetTaskV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskV2Query, GetTaskV2QueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskV2Query | undefined, GetTaskV2QueryVariables>;
export function useGetTaskV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskV2Query, GetTaskV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskV2Query, GetTaskV2QueryVariables>(GetTaskV2Document, options);
        }
export type GetTaskV2QueryHookResult = ReturnType<typeof useGetTaskV2Query>;
export type GetTaskV2LazyQueryHookResult = ReturnType<typeof useGetTaskV2LazyQuery>;
export type GetTaskV2SuspenseQueryHookResult = ReturnType<typeof useGetTaskV2SuspenseQuery>;
export type GetTaskV2QueryResult = Apollo.QueryResult<GetTaskV2Query, GetTaskV2QueryVariables>;
export const ListAttachmentsV2Document = gql`
    query ListAttachmentsV2($caseId: ID!) @endpoint(name: asoc_v2) {
  attachments(caseId: $caseId) {
    success
    attachments {
      id
      filename
      contentType
      sizeBytes
      humanSize
      insertedAt
      updatedAt
      uploadedBy {
        id
        email
        displayName
      }
      downloadUrl
    }
    totalSizeBytes
    errors
  }
}
    `;

/**
 * __useListAttachmentsV2Query__
 *
 * To run a query within a React component, call `useListAttachmentsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useListAttachmentsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAttachmentsV2Query({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useListAttachmentsV2Query(baseOptions: Apollo.QueryHookOptions<ListAttachmentsV2Query, ListAttachmentsV2QueryVariables> & ({ variables: ListAttachmentsV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAttachmentsV2Query, ListAttachmentsV2QueryVariables>(ListAttachmentsV2Document, options);
      }
export function useListAttachmentsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAttachmentsV2Query, ListAttachmentsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAttachmentsV2Query, ListAttachmentsV2QueryVariables>(ListAttachmentsV2Document, options);
        }
// @ts-ignore
export function useListAttachmentsV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListAttachmentsV2Query, ListAttachmentsV2QueryVariables>): Apollo.UseSuspenseQueryResult<ListAttachmentsV2Query, ListAttachmentsV2QueryVariables>;
export function useListAttachmentsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAttachmentsV2Query, ListAttachmentsV2QueryVariables>): Apollo.UseSuspenseQueryResult<ListAttachmentsV2Query | undefined, ListAttachmentsV2QueryVariables>;
export function useListAttachmentsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAttachmentsV2Query, ListAttachmentsV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAttachmentsV2Query, ListAttachmentsV2QueryVariables>(ListAttachmentsV2Document, options);
        }
export type ListAttachmentsV2QueryHookResult = ReturnType<typeof useListAttachmentsV2Query>;
export type ListAttachmentsV2LazyQueryHookResult = ReturnType<typeof useListAttachmentsV2LazyQuery>;
export type ListAttachmentsV2SuspenseQueryHookResult = ReturnType<typeof useListAttachmentsV2SuspenseQuery>;
export type ListAttachmentsV2QueryResult = Apollo.QueryResult<ListAttachmentsV2Query, ListAttachmentsV2QueryVariables>;
export const GetCaseHistoryV2Document = gql`
    query GetCaseHistoryV2($caseId: ID!, $limit: Int, $offset: Int) @endpoint(name: asoc_v2) {
  caseHistory(caseId: $caseId, limit: $limit, offset: $offset) {
    entries {
      id
      fieldName
      modificationType
      beforeValue
      afterValue
      metadata
      insertedAt
      user {
        id
        email
        displayName
      }
    }
    total
    hasMore
  }
}
    `;

/**
 * __useGetCaseHistoryV2Query__
 *
 * To run a query within a React component, call `useGetCaseHistoryV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseHistoryV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseHistoryV2Query({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetCaseHistoryV2Query(baseOptions: Apollo.QueryHookOptions<GetCaseHistoryV2Query, GetCaseHistoryV2QueryVariables> & ({ variables: GetCaseHistoryV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseHistoryV2Query, GetCaseHistoryV2QueryVariables>(GetCaseHistoryV2Document, options);
      }
export function useGetCaseHistoryV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseHistoryV2Query, GetCaseHistoryV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseHistoryV2Query, GetCaseHistoryV2QueryVariables>(GetCaseHistoryV2Document, options);
        }
// @ts-ignore
export function useGetCaseHistoryV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseHistoryV2Query, GetCaseHistoryV2QueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseHistoryV2Query, GetCaseHistoryV2QueryVariables>;
export function useGetCaseHistoryV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseHistoryV2Query, GetCaseHistoryV2QueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseHistoryV2Query | undefined, GetCaseHistoryV2QueryVariables>;
export function useGetCaseHistoryV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseHistoryV2Query, GetCaseHistoryV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseHistoryV2Query, GetCaseHistoryV2QueryVariables>(GetCaseHistoryV2Document, options);
        }
export type GetCaseHistoryV2QueryHookResult = ReturnType<typeof useGetCaseHistoryV2Query>;
export type GetCaseHistoryV2LazyQueryHookResult = ReturnType<typeof useGetCaseHistoryV2LazyQuery>;
export type GetCaseHistoryV2SuspenseQueryHookResult = ReturnType<typeof useGetCaseHistoryV2SuspenseQuery>;
export type GetCaseHistoryV2QueryResult = Apollo.QueryResult<GetCaseHistoryV2Query, GetCaseHistoryV2QueryVariables>;
export const LinkedCasesV2Document = gql`
    query LinkedCasesV2($caseId: ID!, $linkType: String, $limit: Int) @endpoint(name: asoc_v2) {
  linkedCases(caseId: $caseId, linkType: $linkType, limit: $limit) {
    id
    linkedCaseId
    linkType
    sharedObservables
    similarityScore
    insertedAt
    linkedCase {
      id
      caseNumber
      displayKey
      title
      status
      priority
      project {
        id
        name
        prefix
      }
      assignee {
        id
        email
        displayName
      }
      reporter {
        id
        email
        displayName
      }
      insertedAt
      updatedAt
    }
    createdBy {
      id
      email
      displayName
    }
  }
}
    `;

/**
 * __useLinkedCasesV2Query__
 *
 * To run a query within a React component, call `useLinkedCasesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useLinkedCasesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkedCasesV2Query({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      linkType: // value for 'linkType'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useLinkedCasesV2Query(baseOptions: Apollo.QueryHookOptions<LinkedCasesV2Query, LinkedCasesV2QueryVariables> & ({ variables: LinkedCasesV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LinkedCasesV2Query, LinkedCasesV2QueryVariables>(LinkedCasesV2Document, options);
      }
export function useLinkedCasesV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinkedCasesV2Query, LinkedCasesV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LinkedCasesV2Query, LinkedCasesV2QueryVariables>(LinkedCasesV2Document, options);
        }
// @ts-ignore
export function useLinkedCasesV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LinkedCasesV2Query, LinkedCasesV2QueryVariables>): Apollo.UseSuspenseQueryResult<LinkedCasesV2Query, LinkedCasesV2QueryVariables>;
export function useLinkedCasesV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LinkedCasesV2Query, LinkedCasesV2QueryVariables>): Apollo.UseSuspenseQueryResult<LinkedCasesV2Query | undefined, LinkedCasesV2QueryVariables>;
export function useLinkedCasesV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LinkedCasesV2Query, LinkedCasesV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LinkedCasesV2Query, LinkedCasesV2QueryVariables>(LinkedCasesV2Document, options);
        }
export type LinkedCasesV2QueryHookResult = ReturnType<typeof useLinkedCasesV2Query>;
export type LinkedCasesV2LazyQueryHookResult = ReturnType<typeof useLinkedCasesV2LazyQuery>;
export type LinkedCasesV2SuspenseQueryHookResult = ReturnType<typeof useLinkedCasesV2SuspenseQuery>;
export type LinkedCasesV2QueryResult = Apollo.QueryResult<LinkedCasesV2Query, LinkedCasesV2QueryVariables>;
export const FindSimilarCasesV2Document = gql`
    query FindSimilarCasesV2($caseId: ID!, $excludeLinked: Boolean, $minimumMatches: Int, $limit: Int, $offset: Int) @endpoint(name: asoc_v2) {
  findSimilarCases(
    caseId: $caseId
    input: {excludeLinked: $excludeLinked, minimumMatches: $minimumMatches, limit: $limit, offset: $offset}
  ) {
    success
    errors
    result {
      similarCases {
        case {
          id
          caseNumber
          displayKey
          title
          description
          status
          priority
          project {
            id
            name
            prefix
          }
          assignee {
            id
            email
            displayName
          }
          reporter {
            id
            email
            displayName
          }
          insertedAt
          updatedAt
        }
        totalObservables
        matchedCount
        similarityScore
        matchedFields {
          fieldName
          displayName
          fieldType
          matchedValues
        }
      }
      totalCount
      observables {
        fieldId
        fieldName
        displayName
        fieldType
        values
      }
    }
  }
}
    `;

/**
 * __useFindSimilarCasesV2Query__
 *
 * To run a query within a React component, call `useFindSimilarCasesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useFindSimilarCasesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindSimilarCasesV2Query({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      excludeLinked: // value for 'excludeLinked'
 *      minimumMatches: // value for 'minimumMatches'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useFindSimilarCasesV2Query(baseOptions: Apollo.QueryHookOptions<FindSimilarCasesV2Query, FindSimilarCasesV2QueryVariables> & ({ variables: FindSimilarCasesV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindSimilarCasesV2Query, FindSimilarCasesV2QueryVariables>(FindSimilarCasesV2Document, options);
      }
export function useFindSimilarCasesV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindSimilarCasesV2Query, FindSimilarCasesV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindSimilarCasesV2Query, FindSimilarCasesV2QueryVariables>(FindSimilarCasesV2Document, options);
        }
// @ts-ignore
export function useFindSimilarCasesV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindSimilarCasesV2Query, FindSimilarCasesV2QueryVariables>): Apollo.UseSuspenseQueryResult<FindSimilarCasesV2Query, FindSimilarCasesV2QueryVariables>;
export function useFindSimilarCasesV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindSimilarCasesV2Query, FindSimilarCasesV2QueryVariables>): Apollo.UseSuspenseQueryResult<FindSimilarCasesV2Query | undefined, FindSimilarCasesV2QueryVariables>;
export function useFindSimilarCasesV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindSimilarCasesV2Query, FindSimilarCasesV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindSimilarCasesV2Query, FindSimilarCasesV2QueryVariables>(FindSimilarCasesV2Document, options);
        }
export type FindSimilarCasesV2QueryHookResult = ReturnType<typeof useFindSimilarCasesV2Query>;
export type FindSimilarCasesV2LazyQueryHookResult = ReturnType<typeof useFindSimilarCasesV2LazyQuery>;
export type FindSimilarCasesV2SuspenseQueryHookResult = ReturnType<typeof useFindSimilarCasesV2SuspenseQuery>;
export type FindSimilarCasesV2QueryResult = Apollo.QueryResult<FindSimilarCasesV2Query, FindSimilarCasesV2QueryVariables>;
export const GetCaseTypeFieldsV2Document = gql`
    query GetCaseTypeFieldsV2($caseTypeId: ID!) @endpoint(name: asoc_v2) {
  caseTypeFieldMappings(caseTypeId: $caseTypeId) {
    id
    createRequired
    closeRequired
    sortOrder
    caseTypeId
    caseFieldId
    caseField {
      id
      fieldName
      displayName
      fieldType
      description
      descriptor
      isObservable
      isSystem
      isHidden
      isComputed
    }
    insertedAt
    updatedAt
  }
}
    `;

/**
 * __useGetCaseTypeFieldsV2Query__
 *
 * To run a query within a React component, call `useGetCaseTypeFieldsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseTypeFieldsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseTypeFieldsV2Query({
 *   variables: {
 *      caseTypeId: // value for 'caseTypeId'
 *   },
 * });
 */
export function useGetCaseTypeFieldsV2Query(baseOptions: Apollo.QueryHookOptions<GetCaseTypeFieldsV2Query, GetCaseTypeFieldsV2QueryVariables> & ({ variables: GetCaseTypeFieldsV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseTypeFieldsV2Query, GetCaseTypeFieldsV2QueryVariables>(GetCaseTypeFieldsV2Document, options);
      }
export function useGetCaseTypeFieldsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseTypeFieldsV2Query, GetCaseTypeFieldsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseTypeFieldsV2Query, GetCaseTypeFieldsV2QueryVariables>(GetCaseTypeFieldsV2Document, options);
        }
// @ts-ignore
export function useGetCaseTypeFieldsV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseTypeFieldsV2Query, GetCaseTypeFieldsV2QueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseTypeFieldsV2Query, GetCaseTypeFieldsV2QueryVariables>;
export function useGetCaseTypeFieldsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseTypeFieldsV2Query, GetCaseTypeFieldsV2QueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseTypeFieldsV2Query | undefined, GetCaseTypeFieldsV2QueryVariables>;
export function useGetCaseTypeFieldsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseTypeFieldsV2Query, GetCaseTypeFieldsV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseTypeFieldsV2Query, GetCaseTypeFieldsV2QueryVariables>(GetCaseTypeFieldsV2Document, options);
        }
export type GetCaseTypeFieldsV2QueryHookResult = ReturnType<typeof useGetCaseTypeFieldsV2Query>;
export type GetCaseTypeFieldsV2LazyQueryHookResult = ReturnType<typeof useGetCaseTypeFieldsV2LazyQuery>;
export type GetCaseTypeFieldsV2SuspenseQueryHookResult = ReturnType<typeof useGetCaseTypeFieldsV2SuspenseQuery>;
export type GetCaseTypeFieldsV2QueryResult = Apollo.QueryResult<GetCaseTypeFieldsV2Query, GetCaseTypeFieldsV2QueryVariables>;
export const GetCaseTypeAllFieldsV2Document = gql`
    query GetCaseTypeAllFieldsV2($caseTypeId: ID!, $includeHidden: Boolean) @endpoint(name: asoc_v2) {
  caseTypeAllFields(caseTypeId: $caseTypeId, includeHidden: $includeHidden) {
    id
    fieldName
    displayName
    fieldType
    description
    descriptor
    isObservable
    isSystem
    isHidden
    isComputed
  }
}
    `;

/**
 * __useGetCaseTypeAllFieldsV2Query__
 *
 * To run a query within a React component, call `useGetCaseTypeAllFieldsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseTypeAllFieldsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseTypeAllFieldsV2Query({
 *   variables: {
 *      caseTypeId: // value for 'caseTypeId'
 *      includeHidden: // value for 'includeHidden'
 *   },
 * });
 */
export function useGetCaseTypeAllFieldsV2Query(baseOptions: Apollo.QueryHookOptions<GetCaseTypeAllFieldsV2Query, GetCaseTypeAllFieldsV2QueryVariables> & ({ variables: GetCaseTypeAllFieldsV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseTypeAllFieldsV2Query, GetCaseTypeAllFieldsV2QueryVariables>(GetCaseTypeAllFieldsV2Document, options);
      }
export function useGetCaseTypeAllFieldsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseTypeAllFieldsV2Query, GetCaseTypeAllFieldsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseTypeAllFieldsV2Query, GetCaseTypeAllFieldsV2QueryVariables>(GetCaseTypeAllFieldsV2Document, options);
        }
// @ts-ignore
export function useGetCaseTypeAllFieldsV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseTypeAllFieldsV2Query, GetCaseTypeAllFieldsV2QueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseTypeAllFieldsV2Query, GetCaseTypeAllFieldsV2QueryVariables>;
export function useGetCaseTypeAllFieldsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseTypeAllFieldsV2Query, GetCaseTypeAllFieldsV2QueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseTypeAllFieldsV2Query | undefined, GetCaseTypeAllFieldsV2QueryVariables>;
export function useGetCaseTypeAllFieldsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseTypeAllFieldsV2Query, GetCaseTypeAllFieldsV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseTypeAllFieldsV2Query, GetCaseTypeAllFieldsV2QueryVariables>(GetCaseTypeAllFieldsV2Document, options);
        }
export type GetCaseTypeAllFieldsV2QueryHookResult = ReturnType<typeof useGetCaseTypeAllFieldsV2Query>;
export type GetCaseTypeAllFieldsV2LazyQueryHookResult = ReturnType<typeof useGetCaseTypeAllFieldsV2LazyQuery>;
export type GetCaseTypeAllFieldsV2SuspenseQueryHookResult = ReturnType<typeof useGetCaseTypeAllFieldsV2SuspenseQuery>;
export type GetCaseTypeAllFieldsV2QueryResult = Apollo.QueryResult<GetCaseTypeAllFieldsV2Query, GetCaseTypeAllFieldsV2QueryVariables>;
export const TemplateVariablesV2Document = gql`
    query TemplateVariablesV2($caseTypeId: ID!) @endpoint(name: asoc_v2) {
  templateVariables(caseTypeId: $caseTypeId) {
    fieldName
    displayName
    fieldType
    category
  }
}
    `;

/**
 * __useTemplateVariablesV2Query__
 *
 * To run a query within a React component, call `useTemplateVariablesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useTemplateVariablesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateVariablesV2Query({
 *   variables: {
 *      caseTypeId: // value for 'caseTypeId'
 *   },
 * });
 */
export function useTemplateVariablesV2Query(baseOptions: Apollo.QueryHookOptions<TemplateVariablesV2Query, TemplateVariablesV2QueryVariables> & ({ variables: TemplateVariablesV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateVariablesV2Query, TemplateVariablesV2QueryVariables>(TemplateVariablesV2Document, options);
      }
export function useTemplateVariablesV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateVariablesV2Query, TemplateVariablesV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateVariablesV2Query, TemplateVariablesV2QueryVariables>(TemplateVariablesV2Document, options);
        }
// @ts-ignore
export function useTemplateVariablesV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TemplateVariablesV2Query, TemplateVariablesV2QueryVariables>): Apollo.UseSuspenseQueryResult<TemplateVariablesV2Query, TemplateVariablesV2QueryVariables>;
export function useTemplateVariablesV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TemplateVariablesV2Query, TemplateVariablesV2QueryVariables>): Apollo.UseSuspenseQueryResult<TemplateVariablesV2Query | undefined, TemplateVariablesV2QueryVariables>;
export function useTemplateVariablesV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TemplateVariablesV2Query, TemplateVariablesV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TemplateVariablesV2Query, TemplateVariablesV2QueryVariables>(TemplateVariablesV2Document, options);
        }
export type TemplateVariablesV2QueryHookResult = ReturnType<typeof useTemplateVariablesV2Query>;
export type TemplateVariablesV2LazyQueryHookResult = ReturnType<typeof useTemplateVariablesV2LazyQuery>;
export type TemplateVariablesV2SuspenseQueryHookResult = ReturnType<typeof useTemplateVariablesV2SuspenseQuery>;
export type TemplateVariablesV2QueryResult = Apollo.QueryResult<TemplateVariablesV2Query, TemplateVariablesV2QueryVariables>;
export const AllTemplateVariablesV2Document = gql`
    query AllTemplateVariablesV2 @endpoint(name: asoc_v2) {
  allTemplateVariables {
    fieldName
    displayName
    fieldType
    category
  }
}
    `;

/**
 * __useAllTemplateVariablesV2Query__
 *
 * To run a query within a React component, call `useAllTemplateVariablesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useAllTemplateVariablesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTemplateVariablesV2Query({
 *   variables: {
 *   },
 * });
 */
export function useAllTemplateVariablesV2Query(baseOptions?: Apollo.QueryHookOptions<AllTemplateVariablesV2Query, AllTemplateVariablesV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTemplateVariablesV2Query, AllTemplateVariablesV2QueryVariables>(AllTemplateVariablesV2Document, options);
      }
export function useAllTemplateVariablesV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTemplateVariablesV2Query, AllTemplateVariablesV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTemplateVariablesV2Query, AllTemplateVariablesV2QueryVariables>(AllTemplateVariablesV2Document, options);
        }
// @ts-ignore
export function useAllTemplateVariablesV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllTemplateVariablesV2Query, AllTemplateVariablesV2QueryVariables>): Apollo.UseSuspenseQueryResult<AllTemplateVariablesV2Query, AllTemplateVariablesV2QueryVariables>;
export function useAllTemplateVariablesV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllTemplateVariablesV2Query, AllTemplateVariablesV2QueryVariables>): Apollo.UseSuspenseQueryResult<AllTemplateVariablesV2Query | undefined, AllTemplateVariablesV2QueryVariables>;
export function useAllTemplateVariablesV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllTemplateVariablesV2Query, AllTemplateVariablesV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllTemplateVariablesV2Query, AllTemplateVariablesV2QueryVariables>(AllTemplateVariablesV2Document, options);
        }
export type AllTemplateVariablesV2QueryHookResult = ReturnType<typeof useAllTemplateVariablesV2Query>;
export type AllTemplateVariablesV2LazyQueryHookResult = ReturnType<typeof useAllTemplateVariablesV2LazyQuery>;
export type AllTemplateVariablesV2SuspenseQueryHookResult = ReturnType<typeof useAllTemplateVariablesV2SuspenseQuery>;
export type AllTemplateVariablesV2QueryResult = Apollo.QueryResult<AllTemplateVariablesV2Query, AllTemplateVariablesV2QueryVariables>;
export const ListCaseProjectsV2Document = gql`
    query ListCaseProjectsV2 @endpoint(name: asoc_v2) {
  caseProjects {
    id
    name
    slug
    description
    projectType
    icon
    color
    insertedAt
    updatedAt
  }
}
    `;

/**
 * __useListCaseProjectsV2Query__
 *
 * To run a query within a React component, call `useListCaseProjectsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useListCaseProjectsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCaseProjectsV2Query({
 *   variables: {
 *   },
 * });
 */
export function useListCaseProjectsV2Query(baseOptions?: Apollo.QueryHookOptions<ListCaseProjectsV2Query, ListCaseProjectsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCaseProjectsV2Query, ListCaseProjectsV2QueryVariables>(ListCaseProjectsV2Document, options);
      }
export function useListCaseProjectsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCaseProjectsV2Query, ListCaseProjectsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCaseProjectsV2Query, ListCaseProjectsV2QueryVariables>(ListCaseProjectsV2Document, options);
        }
// @ts-ignore
export function useListCaseProjectsV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListCaseProjectsV2Query, ListCaseProjectsV2QueryVariables>): Apollo.UseSuspenseQueryResult<ListCaseProjectsV2Query, ListCaseProjectsV2QueryVariables>;
export function useListCaseProjectsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCaseProjectsV2Query, ListCaseProjectsV2QueryVariables>): Apollo.UseSuspenseQueryResult<ListCaseProjectsV2Query | undefined, ListCaseProjectsV2QueryVariables>;
export function useListCaseProjectsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCaseProjectsV2Query, ListCaseProjectsV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCaseProjectsV2Query, ListCaseProjectsV2QueryVariables>(ListCaseProjectsV2Document, options);
        }
export type ListCaseProjectsV2QueryHookResult = ReturnType<typeof useListCaseProjectsV2Query>;
export type ListCaseProjectsV2LazyQueryHookResult = ReturnType<typeof useListCaseProjectsV2LazyQuery>;
export type ListCaseProjectsV2SuspenseQueryHookResult = ReturnType<typeof useListCaseProjectsV2SuspenseQuery>;
export type ListCaseProjectsV2QueryResult = Apollo.QueryResult<ListCaseProjectsV2Query, ListCaseProjectsV2QueryVariables>;
export const LinkedAlertsV2Document = gql`
    query LinkedAlertsV2($caseId: ID!) @endpoint(name: asoc_v2) {
  case(id: $caseId) {
    id
    linkedAlerts {
      id
      externalId
      name
      description
      severity
      siemSource
      query
      extraData
      tags
      insertedAt
      updatedAt
    }
  }
}
    `;

/**
 * __useLinkedAlertsV2Query__
 *
 * To run a query within a React component, call `useLinkedAlertsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useLinkedAlertsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkedAlertsV2Query({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useLinkedAlertsV2Query(baseOptions: Apollo.QueryHookOptions<LinkedAlertsV2Query, LinkedAlertsV2QueryVariables> & ({ variables: LinkedAlertsV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LinkedAlertsV2Query, LinkedAlertsV2QueryVariables>(LinkedAlertsV2Document, options);
      }
export function useLinkedAlertsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinkedAlertsV2Query, LinkedAlertsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LinkedAlertsV2Query, LinkedAlertsV2QueryVariables>(LinkedAlertsV2Document, options);
        }
// @ts-ignore
export function useLinkedAlertsV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LinkedAlertsV2Query, LinkedAlertsV2QueryVariables>): Apollo.UseSuspenseQueryResult<LinkedAlertsV2Query, LinkedAlertsV2QueryVariables>;
export function useLinkedAlertsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LinkedAlertsV2Query, LinkedAlertsV2QueryVariables>): Apollo.UseSuspenseQueryResult<LinkedAlertsV2Query | undefined, LinkedAlertsV2QueryVariables>;
export function useLinkedAlertsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LinkedAlertsV2Query, LinkedAlertsV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LinkedAlertsV2Query, LinkedAlertsV2QueryVariables>(LinkedAlertsV2Document, options);
        }
export type LinkedAlertsV2QueryHookResult = ReturnType<typeof useLinkedAlertsV2Query>;
export type LinkedAlertsV2LazyQueryHookResult = ReturnType<typeof useLinkedAlertsV2LazyQuery>;
export type LinkedAlertsV2SuspenseQueryHookResult = ReturnType<typeof useLinkedAlertsV2SuspenseQuery>;
export type LinkedAlertsV2QueryResult = Apollo.QueryResult<LinkedAlertsV2Query, LinkedAlertsV2QueryVariables>;
export const LinkedAlertsV2PaginatedDocument = gql`
    query LinkedAlertsV2Paginated($caseId: ID!, $limit: Int, $offset: Int) @endpoint(name: asoc_v2) {
  case(id: $caseId) {
    id
    linkedAlertsPage(limit: $limit, offset: $offset) {
      alerts {
        id
        externalId
        name
        description
        severity
        siemSource
        query
        extraData
        tags
        insertedAt
        updatedAt
      }
      total
      hasMore
    }
  }
}
    `;

/**
 * __useLinkedAlertsV2PaginatedQuery__
 *
 * To run a query within a React component, call `useLinkedAlertsV2PaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkedAlertsV2PaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkedAlertsV2PaginatedQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useLinkedAlertsV2PaginatedQuery(baseOptions: Apollo.QueryHookOptions<LinkedAlertsV2PaginatedQuery, LinkedAlertsV2PaginatedQueryVariables> & ({ variables: LinkedAlertsV2PaginatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LinkedAlertsV2PaginatedQuery, LinkedAlertsV2PaginatedQueryVariables>(LinkedAlertsV2PaginatedDocument, options);
      }
export function useLinkedAlertsV2PaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinkedAlertsV2PaginatedQuery, LinkedAlertsV2PaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LinkedAlertsV2PaginatedQuery, LinkedAlertsV2PaginatedQueryVariables>(LinkedAlertsV2PaginatedDocument, options);
        }
// @ts-ignore
export function useLinkedAlertsV2PaginatedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LinkedAlertsV2PaginatedQuery, LinkedAlertsV2PaginatedQueryVariables>): Apollo.UseSuspenseQueryResult<LinkedAlertsV2PaginatedQuery, LinkedAlertsV2PaginatedQueryVariables>;
export function useLinkedAlertsV2PaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LinkedAlertsV2PaginatedQuery, LinkedAlertsV2PaginatedQueryVariables>): Apollo.UseSuspenseQueryResult<LinkedAlertsV2PaginatedQuery | undefined, LinkedAlertsV2PaginatedQueryVariables>;
export function useLinkedAlertsV2PaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LinkedAlertsV2PaginatedQuery, LinkedAlertsV2PaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LinkedAlertsV2PaginatedQuery, LinkedAlertsV2PaginatedQueryVariables>(LinkedAlertsV2PaginatedDocument, options);
        }
export type LinkedAlertsV2PaginatedQueryHookResult = ReturnType<typeof useLinkedAlertsV2PaginatedQuery>;
export type LinkedAlertsV2PaginatedLazyQueryHookResult = ReturnType<typeof useLinkedAlertsV2PaginatedLazyQuery>;
export type LinkedAlertsV2PaginatedSuspenseQueryHookResult = ReturnType<typeof useLinkedAlertsV2PaginatedSuspenseQuery>;
export type LinkedAlertsV2PaginatedQueryResult = Apollo.QueryResult<LinkedAlertsV2PaginatedQuery, LinkedAlertsV2PaginatedQueryVariables>;
export const SyncDashboardV2Document = gql`
    query SyncDashboardV2 @endpoint(name: asoc_v2) {
  syncSources {
    projectId
    projectName
    projectSlug
    ingestWorkflowId
    outboundWorkflowId
    syncInterval
    conflictStrategy
    lastSyncedAt
  }
}
    `;

/**
 * __useSyncDashboardV2Query__
 *
 * To run a query within a React component, call `useSyncDashboardV2Query` and pass it any options that fit your needs.
 * When your component renders, `useSyncDashboardV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncDashboardV2Query({
 *   variables: {
 *   },
 * });
 */
export function useSyncDashboardV2Query(baseOptions?: Apollo.QueryHookOptions<SyncDashboardV2Query, SyncDashboardV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncDashboardV2Query, SyncDashboardV2QueryVariables>(SyncDashboardV2Document, options);
      }
export function useSyncDashboardV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncDashboardV2Query, SyncDashboardV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncDashboardV2Query, SyncDashboardV2QueryVariables>(SyncDashboardV2Document, options);
        }
// @ts-ignore
export function useSyncDashboardV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SyncDashboardV2Query, SyncDashboardV2QueryVariables>): Apollo.UseSuspenseQueryResult<SyncDashboardV2Query, SyncDashboardV2QueryVariables>;
export function useSyncDashboardV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SyncDashboardV2Query, SyncDashboardV2QueryVariables>): Apollo.UseSuspenseQueryResult<SyncDashboardV2Query | undefined, SyncDashboardV2QueryVariables>;
export function useSyncDashboardV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SyncDashboardV2Query, SyncDashboardV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SyncDashboardV2Query, SyncDashboardV2QueryVariables>(SyncDashboardV2Document, options);
        }
export type SyncDashboardV2QueryHookResult = ReturnType<typeof useSyncDashboardV2Query>;
export type SyncDashboardV2LazyQueryHookResult = ReturnType<typeof useSyncDashboardV2LazyQuery>;
export type SyncDashboardV2SuspenseQueryHookResult = ReturnType<typeof useSyncDashboardV2SuspenseQuery>;
export type SyncDashboardV2QueryResult = Apollo.QueryResult<SyncDashboardV2Query, SyncDashboardV2QueryVariables>;
export const SyncOutboxCountV2Document = gql`
    query SyncOutboxCountV2($state: String, $limit: Int) @endpoint(name: asoc_v2) {
  syncOutbox(state: $state, limit: $limit) {
    id
  }
}
    `;

/**
 * __useSyncOutboxCountV2Query__
 *
 * To run a query within a React component, call `useSyncOutboxCountV2Query` and pass it any options that fit your needs.
 * When your component renders, `useSyncOutboxCountV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncOutboxCountV2Query({
 *   variables: {
 *      state: // value for 'state'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSyncOutboxCountV2Query(baseOptions?: Apollo.QueryHookOptions<SyncOutboxCountV2Query, SyncOutboxCountV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncOutboxCountV2Query, SyncOutboxCountV2QueryVariables>(SyncOutboxCountV2Document, options);
      }
export function useSyncOutboxCountV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncOutboxCountV2Query, SyncOutboxCountV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncOutboxCountV2Query, SyncOutboxCountV2QueryVariables>(SyncOutboxCountV2Document, options);
        }
// @ts-ignore
export function useSyncOutboxCountV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SyncOutboxCountV2Query, SyncOutboxCountV2QueryVariables>): Apollo.UseSuspenseQueryResult<SyncOutboxCountV2Query, SyncOutboxCountV2QueryVariables>;
export function useSyncOutboxCountV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SyncOutboxCountV2Query, SyncOutboxCountV2QueryVariables>): Apollo.UseSuspenseQueryResult<SyncOutboxCountV2Query | undefined, SyncOutboxCountV2QueryVariables>;
export function useSyncOutboxCountV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SyncOutboxCountV2Query, SyncOutboxCountV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SyncOutboxCountV2Query, SyncOutboxCountV2QueryVariables>(SyncOutboxCountV2Document, options);
        }
export type SyncOutboxCountV2QueryHookResult = ReturnType<typeof useSyncOutboxCountV2Query>;
export type SyncOutboxCountV2LazyQueryHookResult = ReturnType<typeof useSyncOutboxCountV2LazyQuery>;
export type SyncOutboxCountV2SuspenseQueryHookResult = ReturnType<typeof useSyncOutboxCountV2SuspenseQuery>;
export type SyncOutboxCountV2QueryResult = Apollo.QueryResult<SyncOutboxCountV2Query, SyncOutboxCountV2QueryVariables>;
export const SyncHealthV2Document = gql`
    query SyncHealthV2 @endpoint(name: asoc_v2) {
  syncHealthSummary {
    totalProjects
    healthy
    degraded
    error
    lastSync
    outboxPending
  }
}
    `;

/**
 * __useSyncHealthV2Query__
 *
 * To run a query within a React component, call `useSyncHealthV2Query` and pass it any options that fit your needs.
 * When your component renders, `useSyncHealthV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncHealthV2Query({
 *   variables: {
 *   },
 * });
 */
export function useSyncHealthV2Query(baseOptions?: Apollo.QueryHookOptions<SyncHealthV2Query, SyncHealthV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncHealthV2Query, SyncHealthV2QueryVariables>(SyncHealthV2Document, options);
      }
export function useSyncHealthV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncHealthV2Query, SyncHealthV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncHealthV2Query, SyncHealthV2QueryVariables>(SyncHealthV2Document, options);
        }
// @ts-ignore
export function useSyncHealthV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SyncHealthV2Query, SyncHealthV2QueryVariables>): Apollo.UseSuspenseQueryResult<SyncHealthV2Query, SyncHealthV2QueryVariables>;
export function useSyncHealthV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SyncHealthV2Query, SyncHealthV2QueryVariables>): Apollo.UseSuspenseQueryResult<SyncHealthV2Query | undefined, SyncHealthV2QueryVariables>;
export function useSyncHealthV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SyncHealthV2Query, SyncHealthV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SyncHealthV2Query, SyncHealthV2QueryVariables>(SyncHealthV2Document, options);
        }
export type SyncHealthV2QueryHookResult = ReturnType<typeof useSyncHealthV2Query>;
export type SyncHealthV2LazyQueryHookResult = ReturnType<typeof useSyncHealthV2LazyQuery>;
export type SyncHealthV2SuspenseQueryHookResult = ReturnType<typeof useSyncHealthV2SuspenseQuery>;
export type SyncHealthV2QueryResult = Apollo.QueryResult<SyncHealthV2Query, SyncHealthV2QueryVariables>;
export const CorrelationStatsV2Document = gql`
    query CorrelationStatsV2 @endpoint(name: asoc_v2) {
  correlationStats {
    totalCorrelations
    avgObservablesPerCase
  }
}
    `;

/**
 * __useCorrelationStatsV2Query__
 *
 * To run a query within a React component, call `useCorrelationStatsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useCorrelationStatsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCorrelationStatsV2Query({
 *   variables: {
 *   },
 * });
 */
export function useCorrelationStatsV2Query(baseOptions?: Apollo.QueryHookOptions<CorrelationStatsV2Query, CorrelationStatsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CorrelationStatsV2Query, CorrelationStatsV2QueryVariables>(CorrelationStatsV2Document, options);
      }
export function useCorrelationStatsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CorrelationStatsV2Query, CorrelationStatsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CorrelationStatsV2Query, CorrelationStatsV2QueryVariables>(CorrelationStatsV2Document, options);
        }
// @ts-ignore
export function useCorrelationStatsV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CorrelationStatsV2Query, CorrelationStatsV2QueryVariables>): Apollo.UseSuspenseQueryResult<CorrelationStatsV2Query, CorrelationStatsV2QueryVariables>;
export function useCorrelationStatsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CorrelationStatsV2Query, CorrelationStatsV2QueryVariables>): Apollo.UseSuspenseQueryResult<CorrelationStatsV2Query | undefined, CorrelationStatsV2QueryVariables>;
export function useCorrelationStatsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CorrelationStatsV2Query, CorrelationStatsV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CorrelationStatsV2Query, CorrelationStatsV2QueryVariables>(CorrelationStatsV2Document, options);
        }
export type CorrelationStatsV2QueryHookResult = ReturnType<typeof useCorrelationStatsV2Query>;
export type CorrelationStatsV2LazyQueryHookResult = ReturnType<typeof useCorrelationStatsV2LazyQuery>;
export type CorrelationStatsV2SuspenseQueryHookResult = ReturnType<typeof useCorrelationStatsV2SuspenseQuery>;
export type CorrelationStatsV2QueryResult = Apollo.QueryResult<CorrelationStatsV2Query, CorrelationStatsV2QueryVariables>;
export const SyncConfigV2Document = gql`
    query SyncConfigV2($projectId: ID!) @endpoint(name: asoc_v2) {
  caseProject(id: $projectId) {
    id
    name
    syncInterval
    conflictStrategy
    ingestWorkflowId
    outboundWorkflowId
  }
}
    `;

/**
 * __useSyncConfigV2Query__
 *
 * To run a query within a React component, call `useSyncConfigV2Query` and pass it any options that fit your needs.
 * When your component renders, `useSyncConfigV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncConfigV2Query({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useSyncConfigV2Query(baseOptions: Apollo.QueryHookOptions<SyncConfigV2Query, SyncConfigV2QueryVariables> & ({ variables: SyncConfigV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncConfigV2Query, SyncConfigV2QueryVariables>(SyncConfigV2Document, options);
      }
export function useSyncConfigV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncConfigV2Query, SyncConfigV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncConfigV2Query, SyncConfigV2QueryVariables>(SyncConfigV2Document, options);
        }
// @ts-ignore
export function useSyncConfigV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SyncConfigV2Query, SyncConfigV2QueryVariables>): Apollo.UseSuspenseQueryResult<SyncConfigV2Query, SyncConfigV2QueryVariables>;
export function useSyncConfigV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SyncConfigV2Query, SyncConfigV2QueryVariables>): Apollo.UseSuspenseQueryResult<SyncConfigV2Query | undefined, SyncConfigV2QueryVariables>;
export function useSyncConfigV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SyncConfigV2Query, SyncConfigV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SyncConfigV2Query, SyncConfigV2QueryVariables>(SyncConfigV2Document, options);
        }
export type SyncConfigV2QueryHookResult = ReturnType<typeof useSyncConfigV2Query>;
export type SyncConfigV2LazyQueryHookResult = ReturnType<typeof useSyncConfigV2LazyQuery>;
export type SyncConfigV2SuspenseQueryHookResult = ReturnType<typeof useSyncConfigV2SuspenseQuery>;
export type SyncConfigV2QueryResult = Apollo.QueryResult<SyncConfigV2Query, SyncConfigV2QueryVariables>;
export const AvailableCaseEventsV2Document = gql`
    query AvailableCaseEventsV2($caseId: ID!) @endpoint(name: asoc_v2) {
  availableCaseEvents(caseId: $caseId) {
    event
    to
    enabled
    reason
  }
}
    `;

/**
 * __useAvailableCaseEventsV2Query__
 *
 * To run a query within a React component, call `useAvailableCaseEventsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useAvailableCaseEventsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableCaseEventsV2Query({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useAvailableCaseEventsV2Query(baseOptions: Apollo.QueryHookOptions<AvailableCaseEventsV2Query, AvailableCaseEventsV2QueryVariables> & ({ variables: AvailableCaseEventsV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableCaseEventsV2Query, AvailableCaseEventsV2QueryVariables>(AvailableCaseEventsV2Document, options);
      }
export function useAvailableCaseEventsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableCaseEventsV2Query, AvailableCaseEventsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableCaseEventsV2Query, AvailableCaseEventsV2QueryVariables>(AvailableCaseEventsV2Document, options);
        }
// @ts-ignore
export function useAvailableCaseEventsV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AvailableCaseEventsV2Query, AvailableCaseEventsV2QueryVariables>): Apollo.UseSuspenseQueryResult<AvailableCaseEventsV2Query, AvailableCaseEventsV2QueryVariables>;
export function useAvailableCaseEventsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailableCaseEventsV2Query, AvailableCaseEventsV2QueryVariables>): Apollo.UseSuspenseQueryResult<AvailableCaseEventsV2Query | undefined, AvailableCaseEventsV2QueryVariables>;
export function useAvailableCaseEventsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailableCaseEventsV2Query, AvailableCaseEventsV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailableCaseEventsV2Query, AvailableCaseEventsV2QueryVariables>(AvailableCaseEventsV2Document, options);
        }
export type AvailableCaseEventsV2QueryHookResult = ReturnType<typeof useAvailableCaseEventsV2Query>;
export type AvailableCaseEventsV2LazyQueryHookResult = ReturnType<typeof useAvailableCaseEventsV2LazyQuery>;
export type AvailableCaseEventsV2SuspenseQueryHookResult = ReturnType<typeof useAvailableCaseEventsV2SuspenseQuery>;
export type AvailableCaseEventsV2QueryResult = Apollo.QueryResult<AvailableCaseEventsV2Query, AvailableCaseEventsV2QueryVariables>;
export const CaseStatusHistoryV2Document = gql`
    query CaseStatusHistoryV2($caseId: ID!, $limit: Int) @endpoint(name: asoc_v2) {
  caseStatusHistory(caseId: $caseId, limit: $limit) {
    id
    fromStatus
    toStatus
    event
    actorType
    actorId
    workflowRunId
    payload
    insertedAt
  }
}
    `;

/**
 * __useCaseStatusHistoryV2Query__
 *
 * To run a query within a React component, call `useCaseStatusHistoryV2Query` and pass it any options that fit your needs.
 * When your component renders, `useCaseStatusHistoryV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCaseStatusHistoryV2Query({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCaseStatusHistoryV2Query(baseOptions: Apollo.QueryHookOptions<CaseStatusHistoryV2Query, CaseStatusHistoryV2QueryVariables> & ({ variables: CaseStatusHistoryV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CaseStatusHistoryV2Query, CaseStatusHistoryV2QueryVariables>(CaseStatusHistoryV2Document, options);
      }
export function useCaseStatusHistoryV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CaseStatusHistoryV2Query, CaseStatusHistoryV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CaseStatusHistoryV2Query, CaseStatusHistoryV2QueryVariables>(CaseStatusHistoryV2Document, options);
        }
// @ts-ignore
export function useCaseStatusHistoryV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CaseStatusHistoryV2Query, CaseStatusHistoryV2QueryVariables>): Apollo.UseSuspenseQueryResult<CaseStatusHistoryV2Query, CaseStatusHistoryV2QueryVariables>;
export function useCaseStatusHistoryV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CaseStatusHistoryV2Query, CaseStatusHistoryV2QueryVariables>): Apollo.UseSuspenseQueryResult<CaseStatusHistoryV2Query | undefined, CaseStatusHistoryV2QueryVariables>;
export function useCaseStatusHistoryV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CaseStatusHistoryV2Query, CaseStatusHistoryV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CaseStatusHistoryV2Query, CaseStatusHistoryV2QueryVariables>(CaseStatusHistoryV2Document, options);
        }
export type CaseStatusHistoryV2QueryHookResult = ReturnType<typeof useCaseStatusHistoryV2Query>;
export type CaseStatusHistoryV2LazyQueryHookResult = ReturnType<typeof useCaseStatusHistoryV2LazyQuery>;
export type CaseStatusHistoryV2SuspenseQueryHookResult = ReturnType<typeof useCaseStatusHistoryV2SuspenseQuery>;
export type CaseStatusHistoryV2QueryResult = Apollo.QueryResult<CaseStatusHistoryV2Query, CaseStatusHistoryV2QueryVariables>;
export const CaseEventsV2Document = gql`
    subscription CaseEventsV2($caseId: ID!) {
  caseEvents(caseId: $caseId) {
    eventType
    caseId
    timestamp
    actor {
      userId
      displayName
    }
    changes
    caseSummary {
      id
      caseNumber
      title
      status
      priority
      assigneeId
      updatedAt
    }
    comment {
      id
      content
      contentType
      userId
      insertedAt
      updatedAt
    }
    task {
      id
      taskNumber
      name
      taskType
      triggerMode
      status
      assigneeId
      sortOrder
      startedAt
      completedAt
    }
    fieldUpdate {
      fieldName
      fieldId
      oldValue
      newValue
    }
    attachment {
      id
      filename
      contentType
      sizeBytes
      uploadedById
    }
  }
}
    `;

/**
 * __useCaseEventsV2Subscription__
 *
 * To run a query within a React component, call `useCaseEventsV2Subscription` and pass it any options that fit your needs.
 * When your component renders, `useCaseEventsV2Subscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCaseEventsV2Subscription({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useCaseEventsV2Subscription(baseOptions: Apollo.SubscriptionHookOptions<CaseEventsV2Subscription, CaseEventsV2SubscriptionVariables> & ({ variables: CaseEventsV2SubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CaseEventsV2Subscription, CaseEventsV2SubscriptionVariables>(CaseEventsV2Document, options);
      }
export type CaseEventsV2SubscriptionHookResult = ReturnType<typeof useCaseEventsV2Subscription>;
export type CaseEventsV2SubscriptionResult = Apollo.SubscriptionResult<CaseEventsV2Subscription>;
export const GetTaskTemplateV2Document = gql`
    query GetTaskTemplateV2($id: ID!) @endpoint(name: asoc_v2) {
  taskTemplate(id: $id) {
    id
    name
    description
    taskType
    triggerMode
    commentOutput
    sortOrder
    insertedAt
    updatedAt
    config
    assignee {
      id
      email
      displayName
    }
    project {
      id
      name
    }
  }
}
    `;

/**
 * __useGetTaskTemplateV2Query__
 *
 * To run a query within a React component, call `useGetTaskTemplateV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskTemplateV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskTemplateV2Query({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskTemplateV2Query(baseOptions: Apollo.QueryHookOptions<GetTaskTemplateV2Query, GetTaskTemplateV2QueryVariables> & ({ variables: GetTaskTemplateV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskTemplateV2Query, GetTaskTemplateV2QueryVariables>(GetTaskTemplateV2Document, options);
      }
export function useGetTaskTemplateV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskTemplateV2Query, GetTaskTemplateV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskTemplateV2Query, GetTaskTemplateV2QueryVariables>(GetTaskTemplateV2Document, options);
        }
// @ts-ignore
export function useGetTaskTemplateV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskTemplateV2Query, GetTaskTemplateV2QueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskTemplateV2Query, GetTaskTemplateV2QueryVariables>;
export function useGetTaskTemplateV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskTemplateV2Query, GetTaskTemplateV2QueryVariables>): Apollo.UseSuspenseQueryResult<GetTaskTemplateV2Query | undefined, GetTaskTemplateV2QueryVariables>;
export function useGetTaskTemplateV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaskTemplateV2Query, GetTaskTemplateV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskTemplateV2Query, GetTaskTemplateV2QueryVariables>(GetTaskTemplateV2Document, options);
        }
export type GetTaskTemplateV2QueryHookResult = ReturnType<typeof useGetTaskTemplateV2Query>;
export type GetTaskTemplateV2LazyQueryHookResult = ReturnType<typeof useGetTaskTemplateV2LazyQuery>;
export type GetTaskTemplateV2SuspenseQueryHookResult = ReturnType<typeof useGetTaskTemplateV2SuspenseQuery>;
export type GetTaskTemplateV2QueryResult = Apollo.QueryResult<GetTaskTemplateV2Query, GetTaskTemplateV2QueryVariables>;
export const ListTaskTemplatesV2Document = gql`
    query ListTaskTemplatesV2($caseTypeId: ID!) @endpoint(name: asoc_v2) {
  taskTemplates(caseTypeId: $caseTypeId) {
    id
    name
    description
    taskType
    triggerMode
    commentOutput
    sortOrder
    insertedAt
    updatedAt
    config
    assignee {
      id
      email
      displayName
    }
  }
}
    `;

/**
 * __useListTaskTemplatesV2Query__
 *
 * To run a query within a React component, call `useListTaskTemplatesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useListTaskTemplatesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTaskTemplatesV2Query({
 *   variables: {
 *      caseTypeId: // value for 'caseTypeId'
 *   },
 * });
 */
export function useListTaskTemplatesV2Query(baseOptions: Apollo.QueryHookOptions<ListTaskTemplatesV2Query, ListTaskTemplatesV2QueryVariables> & ({ variables: ListTaskTemplatesV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTaskTemplatesV2Query, ListTaskTemplatesV2QueryVariables>(ListTaskTemplatesV2Document, options);
      }
export function useListTaskTemplatesV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTaskTemplatesV2Query, ListTaskTemplatesV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTaskTemplatesV2Query, ListTaskTemplatesV2QueryVariables>(ListTaskTemplatesV2Document, options);
        }
// @ts-ignore
export function useListTaskTemplatesV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListTaskTemplatesV2Query, ListTaskTemplatesV2QueryVariables>): Apollo.UseSuspenseQueryResult<ListTaskTemplatesV2Query, ListTaskTemplatesV2QueryVariables>;
export function useListTaskTemplatesV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListTaskTemplatesV2Query, ListTaskTemplatesV2QueryVariables>): Apollo.UseSuspenseQueryResult<ListTaskTemplatesV2Query | undefined, ListTaskTemplatesV2QueryVariables>;
export function useListTaskTemplatesV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListTaskTemplatesV2Query, ListTaskTemplatesV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListTaskTemplatesV2Query, ListTaskTemplatesV2QueryVariables>(ListTaskTemplatesV2Document, options);
        }
export type ListTaskTemplatesV2QueryHookResult = ReturnType<typeof useListTaskTemplatesV2Query>;
export type ListTaskTemplatesV2LazyQueryHookResult = ReturnType<typeof useListTaskTemplatesV2LazyQuery>;
export type ListTaskTemplatesV2SuspenseQueryHookResult = ReturnType<typeof useListTaskTemplatesV2SuspenseQuery>;
export type ListTaskTemplatesV2QueryResult = Apollo.QueryResult<ListTaskTemplatesV2Query, ListTaskTemplatesV2QueryVariables>;
export const CreateTaskTemplateV2Document = gql`
    mutation CreateTaskTemplateV2($caseTypeId: ID!, $input: CreateTaskTemplateInput!) @endpoint(name: asoc_v2) {
  createTaskTemplate(caseTypeId: $caseTypeId, input: $input) {
    success
    taskTemplate {
      id
      name
      description
      taskType
      triggerMode
      commentOutput
      sortOrder
      insertedAt
      updatedAt
      config
      assignee {
        id
        email
        displayName
      }
    }
    errors
  }
}
    `;
export type CreateTaskTemplateV2MutationFn = Apollo.MutationFunction<CreateTaskTemplateV2Mutation, CreateTaskTemplateV2MutationVariables>;

/**
 * __useCreateTaskTemplateV2Mutation__
 *
 * To run a mutation, you first call `useCreateTaskTemplateV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskTemplateV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskTemplateV2Mutation, { data, loading, error }] = useCreateTaskTemplateV2Mutation({
 *   variables: {
 *      caseTypeId: // value for 'caseTypeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaskTemplateV2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskTemplateV2Mutation, CreateTaskTemplateV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskTemplateV2Mutation, CreateTaskTemplateV2MutationVariables>(CreateTaskTemplateV2Document, options);
      }
export type CreateTaskTemplateV2MutationHookResult = ReturnType<typeof useCreateTaskTemplateV2Mutation>;
export type CreateTaskTemplateV2MutationResult = Apollo.MutationResult<CreateTaskTemplateV2Mutation>;
export type CreateTaskTemplateV2MutationOptions = Apollo.BaseMutationOptions<CreateTaskTemplateV2Mutation, CreateTaskTemplateV2MutationVariables>;
export const UpdateTaskTemplateV2Document = gql`
    mutation UpdateTaskTemplateV2($id: ID!, $input: UpdateTaskTemplateInput!) @endpoint(name: asoc_v2) {
  updateTaskTemplate(id: $id, input: $input) {
    success
    taskTemplate {
      id
      name
      description
      taskType
      triggerMode
      commentOutput
      sortOrder
      insertedAt
      updatedAt
      config
      assignee {
        id
        email
        displayName
      }
    }
    errors
  }
}
    `;
export type UpdateTaskTemplateV2MutationFn = Apollo.MutationFunction<UpdateTaskTemplateV2Mutation, UpdateTaskTemplateV2MutationVariables>;

/**
 * __useUpdateTaskTemplateV2Mutation__
 *
 * To run a mutation, you first call `useUpdateTaskTemplateV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskTemplateV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskTemplateV2Mutation, { data, loading, error }] = useUpdateTaskTemplateV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskTemplateV2Mutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskTemplateV2Mutation, UpdateTaskTemplateV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskTemplateV2Mutation, UpdateTaskTemplateV2MutationVariables>(UpdateTaskTemplateV2Document, options);
      }
export type UpdateTaskTemplateV2MutationHookResult = ReturnType<typeof useUpdateTaskTemplateV2Mutation>;
export type UpdateTaskTemplateV2MutationResult = Apollo.MutationResult<UpdateTaskTemplateV2Mutation>;
export type UpdateTaskTemplateV2MutationOptions = Apollo.BaseMutationOptions<UpdateTaskTemplateV2Mutation, UpdateTaskTemplateV2MutationVariables>;
export const DeleteTaskTemplateV2Document = gql`
    mutation DeleteTaskTemplateV2($id: ID!) @endpoint(name: asoc_v2) {
  deleteTaskTemplate(id: $id) {
    success
    taskTemplate {
      id
    }
    errors
  }
}
    `;
export type DeleteTaskTemplateV2MutationFn = Apollo.MutationFunction<DeleteTaskTemplateV2Mutation, DeleteTaskTemplateV2MutationVariables>;

/**
 * __useDeleteTaskTemplateV2Mutation__
 *
 * To run a mutation, you first call `useDeleteTaskTemplateV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskTemplateV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskTemplateV2Mutation, { data, loading, error }] = useDeleteTaskTemplateV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTaskTemplateV2Mutation(baseOptions?: Apollo.MutationHookOptions<DeleteTaskTemplateV2Mutation, DeleteTaskTemplateV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTaskTemplateV2Mutation, DeleteTaskTemplateV2MutationVariables>(DeleteTaskTemplateV2Document, options);
      }
export type DeleteTaskTemplateV2MutationHookResult = ReturnType<typeof useDeleteTaskTemplateV2Mutation>;
export type DeleteTaskTemplateV2MutationResult = Apollo.MutationResult<DeleteTaskTemplateV2Mutation>;
export type DeleteTaskTemplateV2MutationOptions = Apollo.BaseMutationOptions<DeleteTaskTemplateV2Mutation, DeleteTaskTemplateV2MutationVariables>;
export const ReorderTaskTemplatesV2Document = gql`
    mutation ReorderTaskTemplatesV2($caseTypeId: ID!, $templateIds: [ID!]!) @endpoint(name: asoc_v2) {
  reorderTaskTemplates(caseTypeId: $caseTypeId, templateIds: $templateIds) {
    id
    name
    sortOrder
    taskType
    triggerMode
    commentOutput
    config
  }
}
    `;
export type ReorderTaskTemplatesV2MutationFn = Apollo.MutationFunction<ReorderTaskTemplatesV2Mutation, ReorderTaskTemplatesV2MutationVariables>;

/**
 * __useReorderTaskTemplatesV2Mutation__
 *
 * To run a mutation, you first call `useReorderTaskTemplatesV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderTaskTemplatesV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderTaskTemplatesV2Mutation, { data, loading, error }] = useReorderTaskTemplatesV2Mutation({
 *   variables: {
 *      caseTypeId: // value for 'caseTypeId'
 *      templateIds: // value for 'templateIds'
 *   },
 * });
 */
export function useReorderTaskTemplatesV2Mutation(baseOptions?: Apollo.MutationHookOptions<ReorderTaskTemplatesV2Mutation, ReorderTaskTemplatesV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderTaskTemplatesV2Mutation, ReorderTaskTemplatesV2MutationVariables>(ReorderTaskTemplatesV2Document, options);
      }
export type ReorderTaskTemplatesV2MutationHookResult = ReturnType<typeof useReorderTaskTemplatesV2Mutation>;
export type ReorderTaskTemplatesV2MutationResult = Apollo.MutationResult<ReorderTaskTemplatesV2Mutation>;
export type ReorderTaskTemplatesV2MutationOptions = Apollo.BaseMutationOptions<ReorderTaskTemplatesV2Mutation, ReorderTaskTemplatesV2MutationVariables>;